/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import IdGenerator from './IdGenerator';
import ObjectFactory from './ObjectFactory';
import UseSpecType from './UseSpecType';
import ModuleRelinker from './ModuleRelinker';
import EmbeddedModuleRelinker from './EmbeddedModuleRelinker';
import MoserObjectUtils from './MoserObjectUtils';
import InstanceType from './InstanceType';
import DataModuleExtractor from './DataModuleExtractor';
import QuerySubjectUtils from './QuerySubjectUtils';
import QsClassifierType from './QsClassifierType';
import ShortcutUtils from './ShortcutUtils';
import LegacyInsertor from './LegacyInsertor';
import ObjectType from './ObjectType';
import EditModeType from './EditModeType';
import BaseQueryItemType from './BaseQueryItemType';
import PhysicalObjectType from './PhysicalObjectType';
import TransientSourceType from './TransientSourceType';
import ReferenceResolver from './ReferenceResolver';
import EditModeUtils from './EditModeUtils';
import MetricJoinGraph from './MetricJoinGraph';
import MoserObject from './MoserObject';
import TreatAs from './TreatAs';
import ItemScanner from './ItemScanner';
import PropertySetter from './PropertySetter';
import MoserCommonUtils from './MoserCommonUtils';
import CopyMode from './CopyMode';
import CommonResolverUtil from './CommonResolverUtil';
import QueryItem from './QueryItem';
import RelationshipUtils from './RelationshipUtils';
import MemberType from './MemberType';
import CalculatedMemberTypeEnum from './CalculatedMemberTypeEnum';
import PropertyType from './PropertyType';
import Filter from './Filter';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/core/module/util/IdGenerator (static) // generateNewUseSpecId, new, generateNewUseSpecIdWithPrefix, splitQualifiedPath, makeIdentifier
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectFactory (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType
//@import com/ibm/bi/platform/moser/common/relink/ModuleRelinker (runtime) // new
//@import com/ibm/bi/platform/moser/common/relink/EmbeddedModuleRelinker (runtime) // new
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (static) // getParentObjectOfType, getItems, getShortcutReferences, getObjectTypesById, getCalculations, getList, getLongIdentifier, getFilters, getQueryItems, getFolderTypes
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
//@import com/ibm/bi/platform/moser/core/module/util/DataModuleExtractor (static) // generatePositionAfter, removeMembersFromQS, removeModuleMetadata, getUseSpecByObjectType, getUseSpecRefs, getUseSpec, getUseSpecByRef
//@import com/ibm/bi/platform/moser/core/module/util/QuerySubjectUtils (static) // addAllRef, clearEmbeddedFilter, clearPropertyOverride, getParentModule, convertReferenceQuerySubjectToCopy, getQueryItemById, getParentQuerySubject, clearRef, getQuerySubjectRefOrOriginalRef, clearOriginalRef, getUseSpecById, getNormalized
//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (static) // QsClassifierType
//@import com/ibm/bi/platform/moser/common/utils/ShortcutUtils (static) // isShortcutOrAlias, isAliasQSPropRO, copyPropertiesFromReference, updateItemTypeParent, isShortcutValid, cleanShortcutItemPropertyOverride, isShortcutQSPropRO, isAliasValid, isShortcut, insertAsShortcut, isShortcutOrAliasValid, resolveExtensionPositions
//@import com/ibm/bi/platform/moser/core/metadata/util/LegacyInsertor (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (static) // EditModeType
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/TransientSourceType (static) // TransientSourceType
//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (static) // resolveFolderTypeReferences, strBetween, getFirstPart, resolve, getMoserObjectByIdForExpression, getQueryItemByIdAndQuerySubject, bindMoserObject, resolveRelationship, strAfter, getSecondPart
//@import com/ibm/bi/platform/moser/common/utils/EditModeUtils (static) // setEditMode
//@import com/ibm/bi/platform/moser/common/utils/MetricJoinGraph (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject
//@import com/ibm/bi/platform/moser/common/generated/metadata/TreatAs (static) // TreatAs
//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // replaceIdForExpr
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // getAllQueryItemsInQuerySubject, cleanQuerySubjectItemNormalization, set, getUsedIds, setIdentifier, getExtractIdentifiersSpec, isExtendedItem, getQueryItems, refreshShortcutItemNorm, resetReferencedObject, relinkItemNormalizationGroups, createItemsFromSplitDefinition, cleanIdForExpressionQuerySubject, checkSplitRefToQueryItem, updateIdForExpressionEmbeddedFilter, ensureIdForExpression, getParentQuerySubject, addQueryItemToItemNormalizationGroup, updateIdForExpressionQuerySubject, updateIdForExpression, addShortcutQIToItemNormalization, updateItemNormFromAdd, isEmptyRef
//@import com/ibm/bi/platform/moser/common/utils/MoserCommonUtils (static) // areCompatibleDataTypes, getObject, getScale, generateHighlevelDatatype, createAncestors, getPrecision
//@import com/ibm/bi/platform/moser/core/metadata/util/CopyMode (static) // CopyMode
//@import com/ibm/bi/platform/moser/core/metadata/util/CommonResolverUtil (static) // getFMPlaceHolderInMDTV, isFMObject, markFM
//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (static) // new
//@import com/ibm/bi/platform/moser/core/metadata/util/RelationshipUtils (static) // isEqual
//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberTypeEnum (static) // fromValue
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (static) // new

/**
 * This class provides a set of static utility APIs for manipulate a data module. This class will be translated to JavaScript If a function is used only for traverse, don't use getXXX (it might create an empty list). use basicGetXXX.
 */
export default class ModuleUtils extends BaseMoserObject{

	/**
	 * Create a new module
	 * @param {ObjectFactory} objectFactory  : the object factory that will be used to create the module
	 * @param {String} label  : the module label
	 * @param {String} expressionLocale  : the expression locale
	 * @return {Module}
	 */
	static createModule(objectFactory, label, expressionLocale) {
		var module = objectFactory.createModule();
		module.setLabel(label);
		module.setContainer("C");
		new IdGenerator(null).generateId(module);
		module.setVersion("22.0");
		module.setExpressionLocale(expressionLocale);
		module.setDataRetrievalMode("liveConnection");
		var f = objectFactory.createFolderType();
		module.addMetadataTreeView(f);
		return module;
	}

	/**
	 * Returns the feature name of a feature in a moser object type. Returns null if the feature name cannot be found.
	 * @param {int} featureID   feature identifier
	 * @param {String} objectType  moser object type
	 * @return {String}  feature name
	 */
	static getFeatureName(featureID, objectType) {
		var objectFactory = new ObjectFactory();
		var object = objectFactory.createMoserObjectByObjectType(objectType);
		if (!object) {
			return null;
		}
		return object.getFeatureName(featureID);
	}

	/**
	 * Add a source to a module
	 * @param {Module} module  : the  module
	 * @param {UseSpecType} srcModuleType  : Source type (package, module, file, ...etc)
	 * @param {String} srcModuleStoreId  : source module store id
	 * @param {String} srcModuleSearchPath  : source module search path (Deprecated, ignored)
	 * @param  objectFactory: factory to create new module objects
	 * @param {boolean} addMDTVPlaceHolder  : true to add a place holder in the MDTV (Only for FM package and OLAP)
	 * @param  ancestors: the ancestors of the useSpec
	 * @return {UseSpec}  newly created UseSpec for this source
	 */
	static addSource(module, srcModuleType, srcModuleStoreId, srcModuleSearchPath, objectFactory, addMDTVPlaceHolder, ancestors) {
		var useSpec = objectFactory.createModuleUseSpec();
		useSpec.setIdentifier(IdGenerator.generateNewUseSpecId(module));
		useSpec.setType(srcModuleType);
		useSpec.setStoreID(srcModuleStoreId);
		if (ancestors && !(ancestors.length==0)) {
			Array.prototype.push.apply(useSpec.getAncestors(), ancestors);
		}
		module.addUseSpec(useSpec);
		if (addMDTVPlaceHolder && (UseSpecType.PACKAGE === srcModuleType || UseSpecType.LW_OLAP === srcModuleType)) {
			ModuleUtils._addPlaceHolder(module, useSpec.getIdentifier(), objectFactory);
		}
		if (UseSpecType.DATABASE === srcModuleType) {
			useSpec.setDataCacheExpiry("3600");
		}
		return useSpec;
	}

	/**
	 * Relink a source in a Data Module
	 * @param {Module} module  : the module
	 * @param {UseSpec} useSpec  : the useSpec to relink
	 * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	 * @param {String} newSrcStoreId  : the new source module store id
	 * @param  newSrcAncestors: the ancestors of the useSpec
	 * @param  objectFactory: factory to create new module objects
	 * @return {UseSpec}  newly created UseSpec for the relinked source
	 */
	static relinkDataModuleSource(module, useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
		var relinker = new ModuleRelinker(module, null);
		return relinker.relinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
	}

	/**
	 * Relink a data module which contains references to a particular useSpec so they use identifiers from newSrcModule.
	 * @param {Module} module  : the module
	 * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	 * @param {Module} newSrcModule  : the new module to relink identifiers to
	 */
	static relinkDataModule(module, useSpec, newSrcModule) {
		var relinker = new ModuleRelinker(module, newSrcModule);
		relinker.relinkIdentifiers(useSpec);
		relinker.relinkDataSourceOverride(useSpec);
	}

	/**
	 * Relink a source in an Embedded Module
	 * @param {Module} module  : the embedded module
	 * @param {UseSpec} useSpec  : the useSpec to relink
	 * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	 * @param {String} newSrcStoreId  : the new source module store id
	 * @param  newSrcAncestors: the ancestors of the useSpec
	 * @param  objectFactory: factory to create new module objects
	 * @return {UseSpec}  newly created UseSpec for the relinked source
	 */
	static relinkEmbeddedModuleSource(module, useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
		var relinker = new EmbeddedModuleRelinker(module, null);
		return relinker.relinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
	}

	/**
	 * Relink a embedded module which contains references to a particular useSpec so they use identifiers from newSrcModule.
	 * @param {Module} module  : the module
	 * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	 * @param {Module} newSrcModule  : the new module to relink identifiers to
	 */
	static relinkEmbeddedModule(module, useSpec, newSrcModule) {
		var relinker = new EmbeddedModuleRelinker(module, newSrcModule);
		relinker.relinkIdentifiers(useSpec);
	}

	/**
	 * Relink idForExpression's, used against an embedded module, from one source to another.
	 * @param {Module} module  : Can be either: 1- Currently resolved and working Module (some sources exists) 2- The embedded module in raw form (dashboard has shaping and source no longer exists) 3- Null (no sources or dashboard shaping exists)
	 * @param {Array} expressions  : list of idForExpressions to relink
	 * @param {Module} newSrcModule  : the new module to relink identifiers to
	 * @return {Array}  A list of relinked idForExpressions, in the same order as provided.
	 */
	static relinkIdForExpressions(module, expressions, newSrcModule) {
		var relinker = new EmbeddedModuleRelinker(module, newSrcModule);
		return relinker.relinkIdForExpressions(expressions);
	}

	static findQueryItemById(parent, id) {
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(parent), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qi = __exp_enFor0[__i_enFor0];
			var qiID = qi.getIdentifier();
			if (qiID == null || qiID.length === 0) {
				qiID = qi.getIdForExpression();
			}
			if (id == qiID) {
				return qi;
			}
			var parts = id.split(new RegExp("\\" + "."));
			var identifier = parts[parts.length - 1];
			if (identifier == qiID) {
				return qi;
			}
		}
		return null;
	}

	static findQuerySubjectCalculationById(parent, id) {
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getCalculations(parent), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var cal = __exp_enFor0[__i_enFor0];
			var calID = cal.getIdentifier();
			if (calID == null || calID.length === 0) {
				calID = cal.getIdForExpression();
			}
			if (id == calID) {
				return cal;
			}
		}
		return null;
	}

	static findQuerySubjectFilterById(parent, id) {
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getFilters(parent), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qi = __exp_enFor0[__i_enFor0];
			var qiID = qi.getIdentifier();
			if (qiID == null || qiID.length === 0) {
				qiID = qi.getIdForExpression();
			}
			if (id == qiID) {
				return qi;
			}
		}
		return null;
	}

	/**
	 * Given an array of MoserObjects from source modules and a data module, return an array with found MoserObjects in the data module
	 * @param {Array} sourceModuleObjects  - MoserObjects from the source module
	 * @param {Module} dataModule           - the data module being queried
	 * @return {Array}  A list of MoserObjects from the data module that already exist in the source module
	 */
	static findSourceModuleMoserObjectInDataModule(sourceModuleObjects, dataModule) {
		var foundMoserObjects = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = sourceModuleObjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(obj, dataModule, foundMoserObjects);
		}
		return foundMoserObjects;
	}

	static _findSingleSourceModuleMoserObjectInDataModule(obj, dataModule, foundMoserObjects) {
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType) {
			var qsObj = obj;
			var mdQs = null;
			var srcMdAlias = ModuleUtils.getSourceModuleAliasIfNotDefined(null, dataModule, obj);
			var id = srcMdAlias + "." + qsObj.getIdentifier();
			mdQs = ModuleUtils._findQuerySubjectByOriginalRefThenRef(dataModule, id);
			if (mdQs) {
				foundMoserObjects.push(mdQs);
			}
		}
		if ("QueryItem" == objectType || "Calculation" == objectType || "Filter" == objectType) {
			var dmQsList = dataModule.getQuerySubject();
			var srcPrQs = ModuleUtils._getParentQuerySubject(obj);
			var srcMdAlias = ModuleUtils.getSourceModuleAliasIfNotDefined(null, dataModule, srcPrQs);
			var mdObj = null;
			for (var __i_enFor0 = 0, __exp_enFor0 = dmQsList, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var dmQs = __exp_enFor0[__i_enFor0];
				mdObj = ModuleUtils._findMdQsObjByRef(obj, srcMdAlias, dmQs, srcPrQs);
				if (mdObj) {
					foundMoserObjects.push(mdObj);
				}
			}
		}
		if ("Relationship" == objectType) {
			var relObj = obj;
			var dmRlshp = null;
			var ref = null;
			var srcMdAlias = ModuleUtils.getSourceModuleAliasIfNotDefined(null, dataModule, relObj);
			if (srcMdAlias != null) {
				ref = srcMdAlias + "." + relObj.getIdentifier();
				dmRlshp = ModuleUtils._findRelationshipByRef(dataModule, ref);
			}
			if (!dmRlshp) {
				dmRlshp = ModuleUtils._findRelationshipMatch(dataModule, relObj);
			}
			if (dmRlshp) {
				foundMoserObjects.push(dmRlshp);
			}
		}
		if ("Folder" == objectType) {
			var f = obj;
			var items = f.basicGetItem();
			if (items) {
				for (var __i_enFor1 = 0, __exp_enFor1 = items, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var item = __exp_enFor1[__i_enFor1];
					ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(item, dataModule, foundMoserObjects);
				}
			}
		}
		if ("FolderType" == objectType) {
			var folder = obj;
			var folderItems = folder.basicGetFolderItem();
			if (folderItems) {
				for (var __i_enFor2 = 0, __exp_enFor2 = folderItems, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var folderItem = __exp_enFor2[__i_enFor2];
					ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(folderItem, dataModule, foundMoserObjects);
				}
			}
		}
		if ("FolderItemType" == objectType) {
			var folderItem = obj;
			var folder = folderItem.getFolder();
			var o = folderItem.getReferencedObject();
			if (folder) {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(folder, dataModule, foundMoserObjects);
			} else if (o) {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(o, dataModule, foundMoserObjects);
			}
		}
		if ("ItemType" == objectType) {
			var itemType = obj;
			var folder = itemType.getFolder();
			var qi = itemType.getQueryItem();
			var flt = itemType.getFilter();
			var calc = itemType.getCalculation();
			if (folder) {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(folder, dataModule, foundMoserObjects);
			} else if (qi) {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(qi, dataModule, foundMoserObjects);
			} else if (flt) {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(flt, dataModule, foundMoserObjects);
			} else {
				ModuleUtils._findSingleSourceModuleMoserObjectInDataModule(calc, dataModule, foundMoserObjects);
			}
		}
	}

	/**
	 * Find relationship by ref if it exists Ignores relationships with copy or missing instance type
	 * @param {Module} module
	 * @param {String} ref
	 * @return {Relationship}  the matching relationship
	 */
	static _findRelationshipByRef(module, ref) {
		var relList = MoserObjectUtils.getList(module.basicGetRelationship());
		for (var __i_enFor0 = 0, __exp_enFor0 = relList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var rel = __exp_enFor0[__i_enFor0];
			if (rel.getInstanceType() != InstanceType.REFERENCE) {
				var relRef = rel.getRef();
				if (ref == relRef) {
					return rel;
				}
			}
		}
		return null;
	}

	/**
	 * Given source module alias and the source object identifier, first get the references of the qs in data module, and iterate the ref list to find one whose module alias (first part of the ref) matches the src module alias and qs identifier matches the identifier of the parent qs of source obj.
	 * @param {MoserObject} obj         - Source object
	 * @param {String} srcMdAlias  - Source module alias
	 * @param {QuerySubject} dmQs        - Data module query subject
	 * @param {QuerySubject} srcPrQs     - The parent query subject of the source object
	 * @return {MoserObject}  found data module object
	 */
	static _findMdQsObjByRef(obj, srcMdAlias, dmQs, srcPrQs) {
		var mdObj;
		var insType = dmQs.getInstanceType();
		var refs = insType && InstanceType.REFERENCE === insType ? dmQs.getOriginalRef() : dmQs.getRef();
		if (refs && !(refs.length==0)) {
			for (var __i_enFor0 = 0, __exp_enFor0 = refs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var ref = __exp_enFor0[__i_enFor0];
				var parts = ref.split(new RegExp("\\" + "."));
				if (parts.length < 2) {
					continue;
				}
				var mdAlias = parts[0];
				var mdId = parts[1];
				if (mdAlias == srcMdAlias && mdId == srcPrQs.getIdentifier()) {
					var objId = (obj).getIdentifier();
					if ("QueryItem" == obj.getObjectType()) {
						mdObj = ModuleUtils.findQueryItemById(dmQs, objId);
					} else if ("Filter" == obj.getObjectType()) {
						mdObj = ModuleUtils.findQuerySubjectFilterById(dmQs, objId);
					} else if ("Calculation" == obj.getObjectType()) {
						mdObj = ModuleUtils.findQuerySubjectCalculationById(dmQs, objId);
					}
				}
			}
		}
		return mdObj;
	}

	/**
	 * Given an array of MoserObjects from a data module and a key/value mapping of source modules referenced by the data module, Return an array with the found MoserObjects in the source modules
	 * @param {Array} dataModuleObjects  - MoserObjects from the data module
	 * @param {Map} sourceModules      - A list of source modules being queried
	 * @return {Array}  A list of MoserObjects from the source module that already exist in the data module
	 */
	static findDataModuleMoserObjectInSourceModule(dataModuleObjects, sourceModules) {
		var foundMoserObjects = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = dataModuleObjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(obj, sourceModules, foundMoserObjects);
		}
		return foundMoserObjects;
	}

	static _findSingleDataModuleMoserObjectInSourceModule(obj, sourceModules, foundMoserObjects) {
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType || "QueryItem" == objectType || "Calculation" == objectType || "Filter" == objectType) {
			ModuleUtils._findQuerySubjectRelatedObjects(obj, sourceModules, foundMoserObjects);
		}
		if ("Relationship" == objectType) {
			var relObj = obj;
			var sourceRlshp = null;
			var ref = relObj.getRef();
			if (ref != null) {
				var Ids = ref.split(new RegExp("\\" + "."));
				var srcModuleId = Ids[0];
				var srcRlshpId = Ids[1];
				if (sourceModules.hasOwnProperty(srcModuleId)) {
					sourceRlshp = ModuleUtils.getRelationshipById(srcRlshpId, sourceModules[srcModuleId]);
					if (sourceRlshp) {
						foundMoserObjects.push(sourceRlshp);
					}
				}
			} else {
				return;
			}
		}
		if ("Folder" == objectType) {
			var f = obj;
			var items = f.basicGetItem();
			if (items) {
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(item, sourceModules, foundMoserObjects);
				}
			}
		}
		if ("FolderType" == objectType) {
			var folder = obj;
			var folderItems = folder.basicGetFolderItem();
			if (folderItems) {
				for (var __i_enFor1 = 0, __exp_enFor1 = folderItems, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var folderItem = __exp_enFor1[__i_enFor1];
					ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(folderItem, sourceModules, foundMoserObjects);
				}
			}
		}
		if ("FolderItemType" == objectType) {
			var folderItem = obj;
			var folder = folderItem.getFolder();
			var o = folderItem.getReferencedObject();
			if (folder) {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(folder, sourceModules, foundMoserObjects);
			} else if (o) {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(o, sourceModules, foundMoserObjects);
			}
		}
		if ("ItemType" == objectType) {
			var itemType = obj;
			var folder = itemType.getFolder();
			var qi = itemType.getQueryItem();
			var flt = itemType.getFilter();
			var calc = itemType.getCalculation();
			if (folder) {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(folder, sourceModules, foundMoserObjects);
			} else if (qi) {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(qi, sourceModules, foundMoserObjects);
			} else if (flt) {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(flt, sourceModules, foundMoserObjects);
			} else {
				ModuleUtils._findSingleDataModuleMoserObjectInSourceModule(calc, sourceModules, foundMoserObjects);
			}
		}
	}

	/**
	 * Given an object, find a list of referenced modules, and then find its corresponding referenced obj inside the source query subject of this ref module.
	 * @param {ObjectType} obj                - The object to search for in the referenced module
	 * @param {Map} sourceModules      - a list of source modules.
	 * @param {Array} foundMoserObjects  - the List container to hold found objects
	 * @return {void}  null
	 */
	static _findQuerySubjectRelatedObjects(obj, sourceModules, foundMoserObjects) {
		var parentQs = ModuleUtils._getParentQuerySubject(obj);
		if (!parentQs) {
			return;
		}
		var refs = ModuleUtils._getReferencedObjectsIdentifiers(parentQs);
		if (!refs || refs.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = refs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var ref = __exp_enFor0[__i_enFor0];
			var parts = ref.split(new RegExp("\\" + "."));
			var mdAlias = parts[0];
			var qsId = parts[1];
			if (sourceModules.hasOwnProperty(mdAlias)) {
				var targetModule = sourceModules[mdAlias];
				var sourceQs = ModuleUtils.getQuerySubjectById(qsId, targetModule);
				if (!sourceQs) {
					continue;
				}
				var foundObj = null;
				var id = obj.getIdentifier();
				if ("QuerySubject" == obj.getObjectType()) {
					foundObj = sourceQs;
				} else if ("QueryItem" == obj.getObjectType()) {
					foundObj = ModuleUtils.findQueryItemById(sourceQs, id);
				} else if ("Filter" == obj.getObjectType()) {
					foundObj = ModuleUtils.findQuerySubjectFilterById(sourceQs, id);
				} else if ("Calculation" == obj.getObjectType()) {
					foundObj = ModuleUtils.findQuerySubjectCalculationById(sourceQs, id);
				}
				if (foundObj) {
					foundMoserObjects.push(foundObj);
					return;
				}
			}
		}
	}

	/**
	 * Given a query subject and its reference condition, return a list containing the identifiers of its referenced modules and the identifiers of the referenced query subjects in these modules
	 * @param {QuerySubject} qsObj  - current query subject
	 * @return {Array}  a list containing 2 lists, one with the ids of referenced data modules and another with corresponding ids of query subjects
	 */
	static _getReferencedObjectsIdentifiers(qsObj) {
		var instanceType = qsObj.getInstanceType();
		var qsRefs = instanceType && instanceType == InstanceType.REFERENCE ? qsObj.getOriginalRef() : qsObj.getRef();
		var ids = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = qsRefs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var ref = __exp_enFor0[__i_enFor0];
			var refSplit = ref.split(new RegExp("\\" + "."));
			if (refSplit.length == 2) {
				ids.push(ref);
			}
		}
		return ids;
	}

	/**
	 * Removes all members from all QueryItems within a given QuerySubject. This method extracts QueryItems from the items list.
	 * @param {QuerySubject} qs  - a QuerySubject object to have members removed from
	 */
	static removeMembers(qs) {
		DataModuleExtractor.removeMembersFromQS(qs);
	}

	/**
	 * Add a place holder for fm package tree view
	 * @param {Module} module
	 * @param {String} srcId
	 * @param {ObjectFactory} objectFactory
	 */
	static _addPlaceHolder(module, srcId, objectFactory) {
		var placeHolder = objectFactory.createFolderType();
		placeHolder.setIdentifier(srcId);
		var fi = objectFactory.createFolderItemType();
		fi.setFolder(placeHolder);
		var f;
		var mdtv = module.getMetadataTreeView();
		if (mdtv.length==0) {
			f = objectFactory.createFolderType();
			module.addMetadataTreeView(f);
		} else {
			f = mdtv[0];
		}
		f.addFolderItem(fi);
	}

	/**
	 * Prepare the module metadata for saving either a newly created data module or the changes made to an existing data module prior to the REST call: POST "/modules" or PUT "/modules/{moduleId}"
	 * @param {Module} module  - an Module object with metadata to be saved
	 * @return {Object}  a JSON object
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static prepareModuleForSave(module) {
		var moduleJSON;
		var clonedModule = module.clone();
		if (clonedModule) {
			DataModuleExtractor.removeModuleMetadata(clonedModule);
			moduleJSON = clonedModule.toJSON();
		}
		return moduleJSON;
	}

	/**
	 * Generate and set the object id in a given scope.
	 * @param {ObjectType} scope  : The object parent.
	 * @param {ObjectType} obj  : The object that will needs an id.
	 */
	static generateObjectId(scope, obj) {
		new IdGenerator(scope).generateId(obj);
	}

	/**
	 * Create and initialized an id generator. The caller can then use the returned id generator to create an id for multiple objects by calling generateId(obj).
	 * @return {IdGenerator}  an Id generator that is initialized with the given scope.
	 */
	static getIdGenerator(scope) {
		return new IdGenerator(scope);
	}

	/**
	 * Generate a new use spec id.
	 * @param {Module} module  : The module object.
	 * @return {String}  the new use spec id.
	 */
	static getNewUseSpecId(module) {
		return IdGenerator.generateNewUseSpecId(module);
	}

	/**
	 * Break the query subject reference and convert it to a copy
	 * @param   qs: the query subject
	 * @param   module: The module that includes the query subject
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static convertReferenceQuerySubjectToCopy(qs, module) {
		QuerySubjectUtils.convertReferenceQuerySubjectToCopy(qs, module);
	}

	/**
	 * insert querysubject into module, and, add it to MDTV.
	 * @param {Module} module  		: destination module.
	 * @param {Array} qsList 		: querysubject list.
	 * @param {FolderType} mdtvFolder 	: MDTV.
	 * @param {int} inserAtIndex 	: position.
	 * @param {ObjectFactory} objectFactory  : factory.
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static insertQuerySubject(module, qsList, mdtvFolder, inserAtIndex, objectFactory) {
		var mdtvIndex = inserAtIndex;
		var insertAsRef = false;
		var idGenerator = ModuleUtils.getIdGenerator(module);
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			insertAsRef = false;
			if (QsClassifierType.OPERATION_QUERY_SUBJECT == qs.getClassifier() && !(ShortcutUtils.isShortcutOrAlias(qs, true))) {
				var useSpec = ModuleUtils.getSourceModuleUseSpecInParentModule(qs, module);
				var srcModule = QuerySubjectUtils.getParentModule(qs);
				if (useSpec && useSpec.getType() == UseSpecType.MODULE) {
					var oldIdToObjectMap = {};
					var oldIdList = [];
					var asReference = true;
					insertAsRef = true;
					mdtvIndex = ModuleUtils._insertQuerySubjectImp(module, null, srcModule, asReference, mdtvFolder, objectFactory, oldIdList, oldIdToObjectMap, null, null, null, idGenerator, mdtvIndex, qs, qs.getObjectType());
				}
			}
			if (!insertAsRef) {
				module.addQuerySubject(qs);
				ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex++, objectFactory);
			}
		}
	}

	/**
	 * get SourceModule UseSpec In ParentModule.
	 * @param {MoserObject} srcObj 	source object.
	 * @param {Module} module 	parent module.
	 * @return {UseSpec}  UseSpec or null.
	 */
	static getSourceModuleUseSpecInParentModule(srcObj, module) {
		if (!srcObj || !module) {
			return null;
		}
		var useSpecs = module.basicGetUseSpec();
		if (!useSpecs || useSpecs.length==0) {
			return null;
		}
		var srcModule = QuerySubjectUtils.getParentModule(srcObj);
		if (!srcModule) {
			return null;
		}
		var useLst = srcModule.basicGetUse();
		if (!useLst || useLst.length != 1) {
			return null;
		}
		var srcModuleStoreId = useLst[0];
		for (var __i_enFor0 = 0, __exp_enFor0 = useSpecs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var useSp = __exp_enFor0[__i_enFor0];
			var alias = useSp.getIdentifier();
			if (alias != null && 0 == alias.indexOf("__Base")) {
				continue;
			}
			if (srcModuleStoreId == useSp.getStoreID()) {
				return useSp;
			}
		}
		return null;
	}

	/**
	 * get the source module alias from usespec in module.
	 * @param {String} srcModuleId 	existing srcModuleId.
	 * @param {Module} module 		module.
	 * @param {MoserObject} srcObj 		source object.
	 * @return {String}  source module alias.
	 */
	static getSourceModuleAliasIfNotDefined(srcModuleId, module, srcObj) {
		if (srcModuleId != null) {
			return srcModuleId;
		}
		var useSpec = ModuleUtils.getSourceModuleUseSpecInParentModule(srcObj, module);
		if (useSpec) {
			return useSpec.getIdentifier();
		}
		return null;
	}

	/**
	 * Insert query subjects, relationship, calculations, filters into a module. This is typically used to insert a proposal into a module. This method will update the mdtv to insert the ref to the new objects. In case of copying query subject, if it already exists, it restore the deleted query items
	 * @param {ObjectType} destParent  : destination module (note that in the future this should be other objects too)
	 * @param {Array} objList  : List of moser objects (currently: query subjects, relationships, calculations, filters, query items)
	 * @param {String} srcModuleId  : the source module id. i.e. module.usespec[src module].identifier
	 * @param {Module} srcModule  : the source module
	 * @param {boolean} asReference  : as reference or copy
	 * @param {FolderType} mdtvFolder  : where to insert the objects in the mdtv
	 * @param {int} insertAtIndex  : where to insert the objects in the mdtvFolder
	 * @param {ObjectFactory} objectFactory  : to create the new objects (if clone is not used)
	 * @param {Object} idMap  : identifier map, storing old to new identifiers
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static insert(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, idMap) {
		var insertor = new LegacyInsertor();
		insertor.init(destParent, objList, srcModuleId, srcModule, asReference);
		insertor.preInsert();
		var oldIdToObjectMap = {};
		var oldIdList;
		var newObjects;
		if (srcModule && srcModule.basicGetUseSpec() && !(srcModule.basicGetUseSpec().length==0)) {
			oldIdList = [];
			newObjects = [];
		}
		var qsNewlyInsertQIMap = {};
		var qsNewlyInsertQILst = [];
		ModuleUtils._insertImp(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst);
		ModuleUtils._restoreItemNormalizationFromSourceQS(qsNewlyInsertQILst, qsNewlyInsertQIMap, objectFactory);
		insertor.postInsert(oldIdToObjectMap);
	}

	/**
	 * Returns true if the property in the moser object is read-only.
	 * @param {MoserObject} moserObj
	 */
	static isPropertyReadOnly(moserObj, featureId) {
		if (featureId == 28 || featureId == 203 || featureId == 204) {
			return true;
		}
		if (moserObj instanceof ObjectType) {
			var objType = moserObj;
			if (objType.getEditMode() == EditModeType.RO) {
				return true;
			}
			if (objType.getEditMode() == EditModeType.RWPARTIAL && objType.getObjectType() == "QuerySubject") {
				if (ShortcutUtils.isShortcutValid(objType)) {
					return ShortcutUtils.isShortcutQSPropRO(featureId);
				}
				if (ShortcutUtils.isAliasValid(objType)) {
					return ShortcutUtils.isAliasQSPropRO(featureId);
				}
			}
			if (featureId == 91) {
				return !(moserObj.getObjectType() == "QuerySubject") && !(moserObj.getObjectType() == "QueryItem") && !(moserObj.getObjectType() == "Calculation") && !(moserObj.getObjectType() == "Filter") && !(moserObj.getObjectType() == "Folder");
			}
			if (objType.getObjectType() == "MemberType") {
				return true;
			}
			if (objType instanceof BaseQueryItemType) {
				switch (featureId) {
				case 196:
					return true;
				case 141:
					return objType.isImported();
				default:
					break;
				}
			}
			if (objType.getObjectType() == "ProjectedItemType") {
				switch (featureId) {
				case 196:
					return true;
				case 141:
					return objType.isImported();
				default:
					break;
				}
			}
			if (objType.getObjectType() == "Module" && featureId == 157) {
				return true;
			}
			if (featureId == 157 || featureId == 127) {
				return objType.isImported();
			}
			if (!objType.getEditMode() || objType.getEditMode() == EditModeType.RW) {
				return false;
			}
		}
		if (moserObj instanceof PhysicalObjectType) {
			return true;
		}
		return false;
	}

	/**
	 * Returns true if the object type is read-only.
	 * @param {MoserObject} obj   moser object type.
	 */
	static _isObjectReadOnly(obj) {
		if (obj instanceof ObjectType) {
			var objType = obj;
			return objType.getEditMode() == EditModeType.RO;
		}
		return false;
	}

	static _insertImp(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst) {
		var idGenerator = ModuleUtils.getIdGenerator(destParent);
		var mdtvIndex = insertAtIndex;
		var destParentObjectType = destParent.getObjectType();
		for (var __i_enFor0 = 0, __exp_enFor0 = objList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var objectType = obj.getObjectType();
			if ("QuerySubject" == objectType && "Module" == destParentObjectType) {
				mdtvIndex = ModuleUtils._insertQuerySubjectImp(destParent, srcModuleId, srcModule, asReference, mdtvFolder, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst, idGenerator, mdtvIndex, obj, objectType);
			} else if ("Relationship" == objectType && "Module" == destParentObjectType) {
				var module = destParent;
				var rel = obj.clone();
				var qsObj = oldIdToObjectMap[rel.getLeft().getRef()];
				if (qsObj) {
					rel.getLeft().setRef(qsObj.getIdentifier());
				}
				qsObj = oldIdToObjectMap[rel.getRight().getRef()];
				if (qsObj) {
					rel.getRight().setRef(qsObj.getIdentifier());
				}
				if (!ModuleUtils._findRelationshipMatch(module, rel)) {
					var qsLeft = ModuleUtils.getQuerySubjectById(rel.getLeft().getRef(), module);
					var qsRight = ModuleUtils.getQuerySubjectById(rel.getRight().getRef(), module);
					if (asReference) {
						if (!qsLeft) {
							qsLeft = ModuleUtils._getLinkedQuerySubject(rel.getLeft().getRef(), srcModule, module);
							if (qsLeft) {
								rel.getLeft().setRef(qsLeft.getIdentifier());
							}
						}
						if (!qsRight) {
							qsRight = ModuleUtils._getLinkedQuerySubject(rel.getRight().getRef(), srcModule, module);
							if (qsRight) {
								rel.getRight().setRef(qsRight.getIdentifier());
							}
						}
					}
					if (qsLeft && qsRight) {
						if (qsLeft.getInstanceType() == InstanceType.REFERENCE && qsRight.getInstanceType() == InstanceType.REFERENCE) {
							if (ModuleUtils.canMarkAsTransientRel(qsLeft, qsRight)) {
								rel.setTransientSource(TransientSourceType.MODULE);
							}
							rel.setInstanceType(InstanceType.REFERENCE);
							rel.setEditMode(EditModeType.RO);
							rel.setRef(ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj) + "." + rel.getIdentifier());
						} else {
							rel.setInstanceType(null);
							rel.setRef(null);
							rel.setEditMode(null);
						}
						idGenerator.generateId(rel);
						module.addRelationship(rel);
					}
				}
				ReferenceResolver.resolveRelationship(rel, module);
			} else if ("Calculation" == objectType && "Module" == destParentObjectType) {
				var module = destParent;
				var calc = obj.clone();
				EditModeUtils.setEditMode(calc, null);
				var oldId = calc.getIdentifier();
				idGenerator.generateId(calc);
				var newId = calc.getIdentifier();
				module.addCalculation(calc);
				ModuleUtils._insertFolderItem(mdtvFolder, calc, mdtvIndex++, objectFactory);
				ModuleUtils._updateThisObjectReference(oldIdList, oldIdToObjectMap, calc, objectType);
				if (!(newId == oldId)) {
					ModuleUtils._updateOtherObjectReference(newObjects, oldId, newId, objectType);
					oldIdToObjectMap[oldId] = calc;
					if (oldIdList) {
						oldIdList.push(oldId);
					}
				}
				if (newObjects) {
					newObjects.push(calc);
				}
			} else if ("Filter" == objectType && "Module" == destParentObjectType) {
				var module = destParent;
				var filter = obj.clone();
				EditModeUtils.setEditMode(filter, null);
				idGenerator.generateId(filter);
				module.addFilter(filter);
				ModuleUtils._insertFolderItem(mdtvFolder, filter, mdtvIndex++, objectFactory);
			} else if ("FolderItemType" == objectType && "Module" == destParentObjectType) {
				var module = destParent;
				var folderItem = obj.clone();
				var folder = folderItem.getFolder();
				var o = folderItem.getReferencedObject();
				if (folder) {
					folder.setEditMode(null);
					var folders = [];
					folders.push(folder);
					ModuleUtils._insertImp(module, folders, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, mdtvFolder, mdtvIndex++, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst);
				} else if (o) {
					var objects = [];
					objects.push(o);
					ModuleUtils._insertImp(module, objects, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, mdtvFolder, mdtvIndex++, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst);
				}
			} else if ("FolderType" == objectType && "Module" == destParentObjectType) {
				var module = destParent;
				var folder = obj.clone();
				folder.setEditMode(null);
				idGenerator.generateId(folder);
				var items = folder.basicGetFolderItem();
				if (items && !(items.length==0)) {
					var folderItems = [];
					Array.prototype.push.apply(folderItems, items);
					folder.basicGetFolderItem().length = 0;
					ModuleUtils._insertImp(module, folderItems, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, folder, 0, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst);
				}
				ModuleUtils._insertFolder(mdtvFolder, folder, mdtvIndex++, objectFactory);
			} else if ("QueryItem" == objectType) {
				mdtvIndex = ModuleUtils._insertQueryItem(destParent, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, qsNewlyInsertQIMap, qsNewlyInsertQILst, idGenerator, mdtvIndex, obj, false, null);
			}
		}
	}

	/**
	 * Creates a MetricJoinGraph object.
	 * @see {MetricJoinGraph} MetricJoinGraph
	 * @param {Object} joinGraph   join graph response
	 * @param {Module} module      module
	 */
	static createMetricJoinGraph(joinGraph, module) {
		var metricJoinGraph = new MetricJoinGraph(joinGraph);
		metricJoinGraph.setModule(module);
		return metricJoinGraph;
	}

	static canMarkAsTransientRel(qsLeft, qsRight) {
		return ShortcutUtils.isShortcut(qsLeft, true) && ShortcutUtils.isShortcut(qsRight, true);
	}

	static _insertQueryItem(destObj, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, qsNewlyInsertQIMap, qsNewlyInsertQILst, idGenerator, mdtvIndex, obj, newInsertFlag, targetQSs) {
		var destParent = destObj;
		if ("Folder" == destParent.getObjectType()) {
			destParent = ModuleUtils._getParentQuerySubject(destParent);
		}
		var destParentObjectType = destParent.getObjectType();
		var newlyInsertedItem;
		var isDestParentModule = "Module" == destParentObjectType;
		var isDestParentFolderType = "FolderType" == destParentObjectType;
		if (isDestParentModule || isDestParentFolderType) {
			var module = isDestParentModule ? destParent : MoserObject.getModuleObject(destObj);
			var ancestor = ["QuerySubject"];
			var srcQs = ModuleUtils.getTreeAncestor(obj, ancestor, null);
			var targetQS = null;
			if (targetQSs) {
				targetQS = targetQSs[srcQs.getIdentifier()];
			}
			var existingQSList = ModuleUtils.getQuerySubjectBySourceQuerySubject(srcQs, module, srcModuleId);
			if (!newInsertFlag) {
				if (existingQSList.length==0) {
					var existingQS = srcQs.clone();
					if (existingQS.basicGetSecurityFilter()) {
						existingQS.getSecurityFilter().length = 0;
					}
					existingQS.setInstanceType(asReference ? InstanceType.REFERENCE : null);
					QuerySubjectUtils.clearPropertyOverride(existingQS);
					var oldId = existingQS.getIdentifier();
					ModuleUtils._updateQuerySubjectRef(module, existingQS, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, oldId);
					idGenerator.generateId(existingQS);
					var newId = existingQS.getIdentifier();
					if (!(newId == oldId)) {
						oldIdToObjectMap[oldId] = existingQS;
						if (oldIdList) {
							oldIdList.push(oldId);
						}
					}
					module.addQuerySubject(existingQS);
					ModuleUtils._insertFolderItem(mdtvFolder, existingQS, mdtvIndex++, objectFactory);
					for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(existingQS), __len_enFor0 = __exp_enFor0.length;
							__i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qi = __exp_enFor0[__i_enFor0];
						ModuleUtils._removeObjectFromQuerySubject(qi, true);
					}
					EditModeUtils.setEditMode(existingQS, asReference ? EditModeType.RO : null);
					existingQSList.push(existingQS);
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = existingQSList, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var existingQS = __exp_enFor1[__i_enFor1];
					var qi = obj;
					var qiMap = ModuleUtils._createQIMap(existingQS);
					ModuleUtils._insertQIForExistingQS(qi, existingQS, srcQs, qiMap, asReference, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
				}
			} else {
				if (!targetQS) {
					targetQS = srcQs.clone();
					if (targetQS.basicGetSecurityFilter()) {
						targetQS.getSecurityFilter().length = 0;
					}
					targetQS.setInstanceType(asReference ? InstanceType.REFERENCE : null);
					QuerySubjectUtils.clearPropertyOverride(targetQS);
					var oldId = targetQS.getIdentifier();
					ModuleUtils._updateQuerySubjectRef(module, targetQS, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, oldId);
					idGenerator.generateId(targetQS);
					var newId = targetQS.getIdentifier();
					if (!(newId == oldId)) {
						oldIdToObjectMap[oldId] = targetQS;
						if (oldIdList) {
							oldIdList.push(oldId);
						}
					}
					module.addQuerySubject(targetQS);
					ModuleUtils._insertFolderItem(mdtvFolder, targetQS, insertAtIndex, objectFactory);
					for (var __i_enFor2 = 0, __exp_enFor2 = MoserObjectUtils.getQueryItems(targetQS), __len_enFor2 = __exp_enFor2.length;
							__i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var qi = __exp_enFor2[__i_enFor2];
						ModuleUtils._removeObjectFromQuerySubject(qi, true);
					}
					EditModeUtils.setEditMode(targetQS, asReference ? EditModeType.RO : null);
					targetQSs[srcQs.getIdentifier()] = targetQS;
				}
				var qi = obj;
				var qiMap = ModuleUtils._createQIMap(targetQS);
				ModuleUtils._insertQIForExistingQS(qi, targetQS, srcQs, qiMap, asReference, targetQS.getItem().length, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
			}
		} else if ("QuerySubject" == destParentObjectType && !asReference) {
			var ancestor = ["QuerySubject"];
			var srcQs = ModuleUtils.getTreeAncestor(obj, ancestor, null);
			var existingQS = destParent;
			var module = MoserObject.getModuleObject(existingQS);
			var qsRef = ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, srcQs) + "." + srcQs.getIdentifier();
			if (existingQS.getInstanceType() != InstanceType.MISSING && ModuleUtils._containsQSRefInOriginalRefThenRef(qsRef, existingQS)) {
				var qi = obj;
				var qiMap = ModuleUtils._createQIMap(existingQS);
				newlyInsertedItem = ModuleUtils._insertQIForExistingQS(qi, existingQS, srcQs, qiMap, asReference, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
			}
		}
		if ("Folder" == destObj.getObjectType() && newlyInsertedItem) {
			ModuleUtils.move(newlyInsertedItem, destObj, mdtvIndex++);
		}
		return mdtvIndex;
	}

	static _insertQuerySubjectImp(destParent, srcModuleId, srcModule, asReference, mdtvFolder, objectFactory, oldIdList, oldIdToObjectMap, newObjects, qsNewlyInsertQIMap, qsNewlyInsertQILst, idGenerator, insertAtIndex, obj, objectType) {
		var destParentObjectType = destParent.getObjectType();
		var mdtvIndex = insertAtIndex;
		if ("Module" == destParentObjectType) {
			var module = destParent;
			var qsRef = ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj) + "." + (obj).getIdentifier();
			var existingQS = ModuleUtils._findQuerySubjectByOriginalRefThenRef(module, qsRef);
			if (!existingQS) {
				var srcQS = obj;
				var qs = srcQS.clone();
				if (qs.basicGetSecurityFilter()) {
					qs.getSecurityFilter().length = 0;
				}
				qs.setInstanceType(asReference ? InstanceType.REFERENCE : null);
				if (asReference) {
					EditModeUtils.setEditMode(qs, EditModeType.RO);
					if (ShortcutUtils.isShortcutValid(qs)) {
						qs.setEditMode(EditModeType.RWPARTIAL);
					} else if (ShortcutUtils.insertAsShortcut(srcQS)) {
						QuerySubjectUtils.clearEmbeddedFilter(qs);
						qs.setEditMode(EditModeType.RWPARTIAL);
						qs.setTreatAs(TreatAs.REFERENCE);
					}
				} else {
					EditModeUtils.setEditMode(qs, null);
					qs.setTreatAs(null);
				}
				QuerySubjectUtils.clearPropertyOverride(qs);
				var oldId = qs.getIdentifier();
				ModuleUtils._updateQuerySubjectRef(module, qs, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, oldId);
				idGenerator.generateId(qs);
				var newId = qs.getIdentifier();
				var idForExprPrefix = qs.getIdentifier() + ".";
				for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(qs), __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qi = __exp_enFor0[__i_enFor0];
					if (!asReference) {
						qi.setExpression(qi.getIdentifier());
					}
					qi.setIdForExpression(idForExprPrefix + qi.getIdentifier());
				}
				module.addQuerySubject(qs);
				ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex++, objectFactory);
				ModuleUtils._updateThisObjectReference(oldIdList, oldIdToObjectMap, qs, objectType);
				if (!(newId == oldId)) {
					ModuleUtils._updateOtherObjectReference(newObjects, oldId, newId, objectType);
					oldIdToObjectMap[oldId] = qs;
					if (oldIdList) {
						oldIdList.push(oldId);
					}
				}
				if (newObjects) {
					newObjects.push(qs);
				}
			} else if (!asReference) {
				var qs = obj;
				ModuleUtils._updateExistingQuerySubject(existingQS, qs, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
			}
			return mdtvIndex;
		}
		return mdtvIndex;
	}

	/**
	 * register Query subject with newly insert query item. public ONLY because of coverage test in ModuleUtilsTest
	 * @param {QuerySubject} existingQS
	 * @param {Map} qsNewlyInsertQIMap
	 * @param {Array} qsNewlyInsertQILst
	 * @param {QuerySubject} srcQs
	 */
	static registerNewQueryItem(existingQS, qsNewlyInsertQIMap, qsNewlyInsertQILst, srcQs) {
		var refList = existingQS.basicGetOriginalRef();
		if (!refList || refList.length==0) {
			refList = existingQS.basicGetRef();
		}
		if (refList && refList.length == 1 && !(qsNewlyInsertQIMap.hasOwnProperty(existingQS.getIdentifier()))) {
			qsNewlyInsertQIMap[existingQS.getIdentifier()] = srcQs;
			qsNewlyInsertQILst.push(existingQS);
		}
	}

	/**
	 * update other objects after identifier is changed.
	 * @param {Array} newObjects 		candidates.
	 * @param {String} oldId 				old id.
	 * @param {String} newId 				new id.
	 * @param {String} objectType 		type of the object whose id is changed.
	 */
	static _updateOtherObjectReference(newObjects, oldId, newId, objectType) {
		if (!newObjects || newObjects.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = newObjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var objTp = obj.getObjectType();
			if ("Calculation" == objTp) {
				var expr = (obj).getExpression();
				var idForExpr = obj.basicGetIdForExpression();
				var newExpr = ItemScanner.replaceIdForExpr(objTp, expr, idForExpr, objectType, oldId, newId);
				if (newExpr != null) {
					(obj).setExpression(newExpr);
				}
			}
		}
	}

	/**
	 * Returns a linked query subject in a module based on the source identifier from the source module.
	 * @param {String} srcQSIdentifier 	source query subject id.
	 * @param {Module} srcModule 			source module.
	 * @param {Module} module 			module.
	 * @return {QuerySubject}  qs				linked qs.
	 */
	static _getLinkedQuerySubject(srcQSIdentifier, srcModule, module) {
		var srcQS = ModuleUtils.getQuerySubjectById(srcQSIdentifier, srcModule);
		if (!srcQS) {
			return null;
		}
		var srcObjs = [];
		srcObjs.push(srcQS);
		var qsList = ModuleUtils.findSourceModuleMoserObjectInDataModule(srcObjs, module);
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			if ("QuerySubject" == obj.getObjectType()) {
				var qs = obj;
				if (!(ShortcutUtils.isShortcutOrAliasValid(qs)) && InstanceType.REFERENCE == qs.getInstanceType()) {
					return qs;
				}
			}
		}
		return null;
	}

	/**
	 * update this object if there are objects whose id is changed.
	 * @param {Array} oldIdList 				old ids of objects.
	 * @param {Map} oldIdToObjectMap 		Old ID To objects map.
	 * @param {ObjectType} thisObj 				this object.
	 * @param {String} objectType 			type of this object.
	 */
	static _updateThisObjectReference(oldIdList, oldIdToObjectMap, thisObj, objectType) {
		if (!oldIdList || oldIdList.length==0) {
			return;
		}
		if ("Calculation" == objectType) {
			var thisExpr = (thisObj).getExpression();
			var thisIdForExpr = thisObj.basicGetIdForExpression();
			if (thisExpr != null && !(thisExpr.length === 0)) {
				var bChanged = false;
				for (var __i_enFor0 = 0, __exp_enFor0 = oldIdList, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var oId = __exp_enFor0[__i_enFor0];
					var srcObj = oldIdToObjectMap[oId];
					var newExpr = ItemScanner.replaceIdForExpr(objectType, thisExpr, thisIdForExpr, srcObj.getObjectType(), oId, srcObj.getIdentifier());
					if (newExpr != null) {
						bChanged = true;
						thisExpr = newExpr;
					}
				}
				if (bChanged) {
					(thisObj).setExpression(thisExpr);
				}
			}
			return;
		}
	}

	/**
	 * Copy query subjects, relationship, calculations, filters, folders from/into a module. This is typically used during a copy/paste. This method will update the mdtv to insert the ref to the new objects.
	 * @param {Module} module  : destination module
	 * @param {Array} objList  : List of moser objects (currently: query subjects, relationships, calculations, filters, folders)
	 * @param {FolderType} mdtvFolder  : the mdtvFolder to insert the object into
	 * @param {int} insertAtIndex  : where to insert the objects in the mdtvFolder
	 * @param {CopyMode} mode  : whether to copy common relationships, all relationships or none at all
	 * @param {ObjectFactory} objectFactory  : to create the new objects (if clone is not used)
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static copy(module, objList, mdtvFolder, insertAtIndex, mode, objectFactory) {
		var idGenerator = ModuleUtils.getIdGenerator(module);
		var oldIdToNewIdMap = {};
		var mdtvIndex = insertAtIndex;
		var copiedObj = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = objList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			copiedObj.push(ModuleUtils._copyMoserObject(module, obj, mdtvFolder, mdtvIndex++, idGenerator, oldIdToNewIdMap, objectFactory));
		}
		var relationships = ModuleUtils._collectRelationshipsToCopy(module, oldIdToNewIdMap, mode);
		for (var __i_enFor1 = 0, __exp_enFor1 = relationships, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var relationship = __exp_enFor1[__i_enFor1];
			ModuleUtils._copyRelationship(module, relationship, idGenerator, oldIdToNewIdMap);
		}
		return copiedObj;
	}

	/**
	 * Copy a MoserObject and insert it into the mdtvFolder.
	 * @param {MoserObject} obj
	 * @param {FolderType} mdtvFolder
	 * @param {int} mdtvIndex
	 * @param {IdGenerator} idGenerator
	 * @param {Object} oldIdToNewIdMap
	 * @param {ObjectFactory} objectFactory
	 * @return {MoserObject}  The copied MoserObject
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyMoserObject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType) {
			return ModuleUtils._copyQuerySubject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
		} else if ("Relationship" == objectType) {
			return ModuleUtils._copyRelationship(module, obj, idGenerator, oldIdToNewIdMap);
		} else if ("Calculation" == objectType) {
			return ModuleUtils._copyCalculation(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory);
		} else if ("Filter" == objectType) {
			return ModuleUtils._copyFilter(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory);
		} else if ("FolderItemType" == objectType) {
			ModuleUtils._copyFolderItemType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
		} else if ("FolderType" == objectType) {
			return ModuleUtils._copyFolderType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
		}
		return null;
	}

	/**
	 * Copy a QuerySubject and insert it into the mdtvFolder.
	 * @param {Module} module
	 * @param {QuerySubject} obj
	 * @param {IdGenerator} idGenerator
	 * @param {Object} oldIdToNewIdMap
	 * @return {QuerySubject}  The copied QuerySubject
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyQuerySubject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
		var qs = obj.clone();
		var oldId = qs.getIdentifier();
		idGenerator.generateId(qs);
		if (!(oldId == qs.getIdentifier()) && qs.basicGetIdForExpression() != null) {
			qs.setIdForExpression(qs.getIdentifier());
		}
		oldIdToNewIdMap[oldId] = qs.getIdentifier();
		PropertySetter.updateIdForExpression(qs.basicGetItem(), qs.getIdentifier());
		PropertySetter.updateIdForExpressionEmbeddedFilter(qs.basicGetFilter(), qs.getIdentifier());
		module.addQuerySubject(qs);
		ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex, objectFactory);
		return qs;
	}

	/**
	 * Creates a shortcut query subject. Either Reference or Alias.
	 * @param {QuerySubject} obj 			querySubject.
	 * @param {TreatAs} treatAs 		type of shortcut.
	 * @return {QuerySubject}  The new shortcut object.
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _createShortcutObject(obj, treatAs) {
		var qs = obj.clone();
		qs.setIdentifier(null);
		qs.setInstanceType(InstanceType.REFERENCE);
		EditModeUtils.setEditMode(qs, EditModeType.RO);
		qs.setEditMode(EditModeType.RWPARTIAL);
		qs.setTreatAs(treatAs);
		qs.getOriginalRef().length = 0;
		qs.addOriginalRef(obj.getIdentifier());
		if (qs.basicGetFilter()) {
			qs.getFilter().length = 0;
		}
		PropertySetter.cleanIdForExpressionQuerySubject(qs);
		ShortcutUtils.cleanShortcutItemPropertyOverride(qs);
		QuerySubjectUtils.clearPropertyOverride(qs);
		return qs;
	}

	/**
	 * Changes the target of a shortcut/alias query subject. The new target is a query subject from the data module or source module.
	 * @param {QuerySubject} sc       query subject to relink
	 * @param {QuerySubject} target   query subject to relink to.
	 */
	static relink(sc, target) {
		if (!sc || !target || sc == target) {
			return;
		}
		ModuleUtils._relinkImp(sc, target, {});
	}

	/**
	 * Returns a list of query subjects the given shortcut/alias cannot relink to.
	 * @param {QuerySubject} sc  query subject to relink
	 * @return {Array}  list of query subjects
	 */
	static invalidRelinkTarget(sc) {
		if (!(ShortcutUtils.isShortcutOrAlias(sc, true))) {
			return null;
		}
		var module = MoserObject.getModuleObject(sc);
		if (!module) {
			return null;
		}
		var qsMap = {};
		var qsList = module.basicGetQuerySubject();
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			qsMap[qs.getIdentifier()] = qs;
		}
		var invalidList = [];
		var invalidSet = {};
		invalidSet[sc.getIdentifier()] = 1;
		invalidList.push(sc);
		var seenQS = {};
		seenQS[sc.getIdentifier()] = 1;
		for (var __i_enFor1 = 0, __exp_enFor1 = qsList, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qs = __exp_enFor1[__i_enFor1];
			if (seenQS.hasOwnProperty(qs.getIdentifier())) {
				continue;
			}
			ModuleUtils._invalidRelinkTargetImp(qs, qsMap, invalidList, invalidSet, [], {}, seenQS);
		}
		var refs = QuerySubjectUtils.getQuerySubjectRefOrOriginalRef(sc);
		for (var __i_enFor2 = 0, __exp_enFor2 = refs, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var ref = __exp_enFor2[__i_enFor2];
			if (qsMap.hasOwnProperty(ref)) {
				var qsRef = qsMap[ref];
				if (!(invalidSet.hasOwnProperty(ref))) {
					invalidSet[ref] = 1;
					invalidList.push(qsRef);
				}
			}
		}
		return invalidList;
	}

	/**
	 * Creates a shortcut reference query subject.
	 * @param {QuerySubject} obj 			querySubject.
	 * @return {QuerySubject}  The new shortcut reference query subject.
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static createQuerySubjectShortcut(obj) {
		return ModuleUtils._createShortcutObject(obj, TreatAs.REFERENCE);
	}

	/**
	 * Creates a shortcut alias query subject.
	 * @param {QuerySubject} obj 			querySubject.
	 * @return {QuerySubject}  The new shortcut alias query subject.
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static createQuerySubjectAlias(obj) {
		return ModuleUtils._createShortcutObject(obj, TreatAs.ALIAS);
	}

	/**
	 * Returns true if the moser object is an extended item of a shortcut or alias. Returns false if object does not belong to a shortcut or alias.
	 * @param {MoserObject} obj   moser object
	 * @return {boolean}  t/f
	 */
	static isExtendedItem(obj) {
		return PropertySetter.isExtendedItem(obj);
	}

	/**
	 * Changes the target of a shortcut/alias query subject. The new target is a query subject from the data module or source module.
	 * @param {QuerySubject} sc       query subject to relink
	 * @param {QuerySubject} target   query subject to relink to.
	 * @param {Set} visited  set of visited query subject identifiers
	 */
	static _relinkImp(sc, target, visited) {
		if (visited.hasOwnProperty(sc.getIdentifier()) || !(ShortcutUtils.isShortcutOrAlias(sc, true))) {
			return;
		}
		visited[sc.getIdentifier()] = 1;
		var scModule = MoserObject.getModuleObject(sc);
		var targModule = MoserObject.getModuleObject(target);
		if (!scModule || !targModule) {
			return;
		}
		var scItems = sc.getItem();
		if (sc.getInstanceType() == InstanceType.REFERENCE) {
			DataModuleExtractor.generatePositionAfter(scItems);
		}
		var itemsToRemove = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = scItems, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var objType = MoserCommonUtils.getObject(item);
			if (!(ModuleUtils.isExtendedItem(objType))) {
				itemsToRemove.push(item);
			}
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = itemsToRemove, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var item = __exp_enFor1[__i_enFor1];
			sc.removeItem(item);
		}
		ModuleUtils.removeMembers(sc);
		try {
			var tgClone = target.clone();
			ModuleUtils.removeMembers(tgClone);
			var ignoreList = [];
			ignoreList.push(91);
			ignoreList.push(129);
			ignoreList.push(161);
			ignoreList.push(28);
			ignoreList.push(9);
			ShortcutUtils.copyPropertiesFromReference(sc, tgClone, ignoreList);
			EditModeUtils.setEditMode(tgClone, EditModeType.RO);
			ShortcutUtils.cleanShortcutItemPropertyOverride(tgClone);
			var targetQIIds = {};
			for (var __i_enFor2 = 0, __exp_enFor2 = PropertySetter.getQueryItems(tgClone), __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var qi = __exp_enFor2[__i_enFor2];
				targetQIIds[qi.getIdentifier()] = 1;
			}
			PropertySetter.addShortcutQIToItemNormalization(sc, targetQIIds, PropertySetter.getQueryItems(sc), scModule.getObjectFactory(), true);
			var tgItems = tgClone.getItem();
			ShortcutUtils.updateItemTypeParent(tgItems, sc);
			var orderedList = ShortcutUtils.resolveExtensionPositions(scItems, tgClone.getItem());
			for (var i = scItems.length - 1; i >= 0; --i) {
				sc.removeItemAt(i);
			}
			for (var __i_enFor3 = 0, __exp_enFor3 = orderedList, __len_enFor3 = __exp_enFor3.length;
					__i_enFor3 < __len_enFor3; ++__i_enFor3) {
				var item = __exp_enFor3[__i_enFor3];
				sc.addItem(item);
			}
			PropertySetter.updateIdForExpression(sc.basicGetItem(), sc.getIdentifier());
			ModuleUtils.resolveShortcutQSRef(sc, scModule, tgClone, targModule);
			if (sc.getInstanceType() != InstanceType.REFERENCE) {
				sc.setInstanceType(InstanceType.REFERENCE);
			}
		} catch (e) {
			throw e;
		}

		for (var __i_enFor4 = 0, __exp_enFor4 = MoserObjectUtils.getShortcutReferences(sc), __len_enFor4 = __exp_enFor4.length;
				__i_enFor4 < __len_enFor4; ++__i_enFor4) {
			var reference = __exp_enFor4[__i_enFor4];
			ModuleUtils._relinkImp(reference, sc, visited);
		}
	}

	/**
	 * Traverse through a query subject and its references. Adds to the list of invalid query subjects if the qs references an invalid qs indirectly or indirectly has a circular reference.
	 * @param {QuerySubject} qs             query subject to traverse
	 * @param {Map} qsMap          maps id to query subject in module
	 * @param {Array} invalidQSList  list of invalid relink query subjects
	 * @param {Set} invalidQSSet   set of invalid relink query subjects identifiers
	 * @param {Array} stack          tracks the path of the traversal
	 * @param {Set} circularSet    set used to determine a circular reference
	 * @param {Set} seenQS         set of all traversed query subjects
	 */
	static _invalidRelinkTargetImp(qs, qsMap, invalidQSList, invalidQSSet, stack, circularSet, seenQS) {
		stack.push(qs.getIdentifier());
		if (invalidQSSet.hasOwnProperty(qs.getIdentifier())) {
			stack.splice(stack.length - 1, 1);
			seenQS[qs.getIdentifier()] = 1;
			return;
		}
		if (circularSet.hasOwnProperty(qs.getIdentifier())) {
			invalidQSSet[qs.getIdentifier()] = 1;
			invalidQSList.push(qs);
			stack.splice(stack.length - 1, 1);
			seenQS[qs.getIdentifier()] = 1;
			return;
		}
		if (seenQS.hasOwnProperty(qs.getIdentifier())) {
			stack.splice(stack.length - 1, 1);
			return;
		}
		seenQS[qs.getIdentifier()] = 1;
		var refs = QuerySubjectUtils.getQuerySubjectRefOrOriginalRef(qs);
		for (var __i_enFor0 = 0, __exp_enFor0 = refs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var ref = __exp_enFor0[__i_enFor0];
			var refQS = qsMap[ref];
			if (!refQS) {
				continue;
			}
			var newCircularSet = {};
			for (var __i_enFor1 = 0, __exp_enFor1 = stack, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var id = __exp_enFor1[__i_enFor1];
				newCircularSet[id] = 1;
			}
			ModuleUtils._invalidRelinkTargetImp(refQS, qsMap, invalidQSList, invalidQSSet, stack, newCircularSet, seenQS);
			if (invalidQSSet.hasOwnProperty(refQS.getIdentifier()) && !(invalidQSSet.hasOwnProperty(qs.getIdentifier()))) {
				invalidQSSet[qs.getIdentifier()] = 1;
				invalidQSList.push(qs);
			}
		}
		stack.splice(stack.length - 1, 1);
	}

	/**
	 * Updates the ref of a shortcut to a new target QS.
	 * @param {QuerySubject} sc          shortcut
	 * @param {Module} scModule    shortcut QS module
	 * @param {QuerySubject} tg        target QS
	 * @param {Module} targModule  target QS module
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static resolveShortcutQSRef(sc, scModule, tg, targModule) {
		if (!scModule || !targModule) {
			return;
		}
		if (scModule == targModule) {
			ModuleUtils._resolveShortcutQSRefDataModule(sc, tg);
			return;
		}
		ModuleUtils._resolveShortcutQSRefSourceModule(sc, scModule, tg, targModule);
	}

	/**
	 * Updates the ref of a shortcut to a new target QS. The target QS is in the same module as the shortcut.
	 * @param {QuerySubject} sc          shortcut
	 * @param {QuerySubject} tg        target QS
	 */
	static _resolveShortcutQSRefDataModule(sc, tg) {
		QuerySubjectUtils.clearRef(sc);
		QuerySubjectUtils.addAllRef(sc, tg.getRef());
		QuerySubjectUtils.clearOriginalRef(sc);
		sc.addOriginalRef(tg.getIdentifier());
	}

	/**
	 * Updates the ref of a shortcut to a new target QS. The target QS is from a different module.
	 * @param {QuerySubject} sc          shortcut
	 * @param {Module} scModule    shortcut QS module
	 * @param  targ        target QS
	 * @param {Module} targModule  target QS module
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _resolveShortcutQSRefSourceModule(sc, scModule, tg, targModule) {
		var moduleAlias = ModuleUtils.getSourceModuleAliasIfNotDefined(null, scModule, targModule);
		if (moduleAlias == null) {
			return;
		}
		QuerySubjectUtils.clearRef(sc);
		QuerySubjectUtils.addAllRef(sc, tg.getRef());
		ModuleUtils._updateQuerySubjectRef(scModule, sc, moduleAlias, targModule, true, tg.getIdentifier());
	}

	/**
	 * Copy a Relationship.
	 * @param {Module} module
	 * @param {Relationship} obj
	 * @param {IdGenerator} idGenerator
	 * @param {Object} oldIdToNewIdMap
	 * @return {Relationship}  The copied Relationship
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyRelationship(module, obj, idGenerator, oldIdToNewIdMap) {
		var rel = obj.clone();
		var qsId = oldIdToNewIdMap[rel.getLeft().getRef()];
		if (qsId != null) {
			rel.getLeft().setRef(qsId);
		}
		qsId = oldIdToNewIdMap[rel.getRight().getRef()];
		if (qsId != null) {
			rel.getRight().setRef(qsId);
		}
		idGenerator.generateId(rel);
		module.addRelationship(rel);
		ReferenceResolver.resolveRelationship(rel, module);
		return rel;
	}

	/**
	 * Copy a Calculation and insert it into the mdtvFolder.
	 * @param {Module} module
	 * @param {Calculation} obj
	 * @param {FolderType} mdtvFolder
	 * @param {int} mdtvIndex
	 * @param {IdGenerator} idGenerator
	 * @param {ObjectFactory} objectFactory
	 * @return {Calculation}  The copied Calculation
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyCalculation(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory) {
		var calc = obj.clone();
		idGenerator.generateId(calc);
		module.addCalculation(calc);
		ModuleUtils._insertFolderItem(mdtvFolder, calc, mdtvIndex, objectFactory);
		return calc;
	}

	/**
	 * Copy a Filter and insert it into the mdtvFolder.
	 * @param {Module} module
	 * @param {Filter} obj
	 * @param {FolderType} mdtvFolder
	 * @param {int} mdtvIndex
	 * @param {IdGenerator} idGenerator
	 * @param {ObjectFactory} objectFactory
	 * @return {Filter}  The copied Filter
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyFilter(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory) {
		var filter = obj.clone();
		idGenerator.generateId(filter);
		module.addFilter(filter);
		ModuleUtils._insertFolderItem(mdtvFolder, filter, mdtvIndex, objectFactory);
		return filter;
	}

	/**
	 * Copy a FolderItemType's content and insert it into the mdtvFolder.
	 * @param {Module} module
	 * @param {FolderItemType} obj
	 * @param {FolderType} mdtvFolder
	 * @param {int} mdtvIndex
	 * @param {IdGenerator} idGenerator
	 * @param {Object} oldIdToNewIdMap
	 * @param {ObjectFactory} objectFactory
	 * @return {MoserObject}  The nested MoserObject that was copied
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyFolderItemType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
		var folder = obj.getFolder();
		var o = obj.getReferencedObject();
		if (folder) {
			return ModuleUtils._copyMoserObject(module, folder, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
		} else if (o) {
			return ModuleUtils._copyMoserObject(module, o, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
		}
		return null;
	}

	/**
	 * Copy a FolderType and insert it into the mdtvFolder. Also copy and insert all this folder's items into the new copy.
	 * @param {Module} module
	 * @param {FolderType} obj
	 * @param {FolderType} mdtvFolder
	 * @param {int} mdtvIndex
	 * @param {IdGenerator} idGenerator
	 * @param {Object} oldIdToNewIdMap
	 * @param {ObjectFactory} objectFactory
	 * @return {FolderType}  The copied FolderType
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static _copyFolderType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
		var folder = obj.clone();
		idGenerator.generateId(folder);
		var items = folder.basicGetFolderItem();
		if (items && !(items.length==0)) {
			var folderItems = [];
			Array.prototype.push.apply(folderItems, items);
			items.length = 0;
			var folderIndex = 0;
			for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var item = __exp_enFor0[__i_enFor0];
				ModuleUtils._copyMoserObject(module, item, folder, folderIndex++, idGenerator, oldIdToNewIdMap, objectFactory);
			}
		}
		ModuleUtils._insertFolder(mdtvFolder, folder, mdtvIndex, objectFactory);
		return folder;
	}

	/**
	 * Collection relationships related to all QuerySubject's referenced in the oldIdToNewIdMap.
	 * @param  Module
	 * @param {Map} oldIdToNewIdMap
	 * @param {CopyMode} mode
	 * @return {Array}
	 */
	static _collectRelationshipsToCopy(module, oldIdToNewIdMap, mode) {
		var relationshipsToCopy = [];
		var relationships = module.basicGetRelationship();
		if (CopyMode.SELECTION_ONLY === mode || !relationships || relationships.length==0) {
			return relationshipsToCopy;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var relationship = __exp_enFor0[__i_enFor0];
			var isLeft = oldIdToNewIdMap[relationship.getLeft().getRef()] != null;
			var isRight = oldIdToNewIdMap[relationship.getRight().getRef()] != null;
			if (CopyMode.COMMON_RELATIONSHIPS === mode && isLeft && isRight) {
				relationshipsToCopy.push(relationship);
			} else if (CopyMode.ALL_RELATIONSHIPS === mode && (isLeft || isRight)) {
				relationshipsToCopy.push(relationship);
			}
		}
		return relationshipsToCopy;
	}

	/**
	 * Find query subject by original ref if it exists, otherwise, by ref Ignores query subjects with copy or missing instance type
	 * @param {Module} module
	 * @param {String} ref
	 * @return {QuerySubject}  the matching query subject
	 */
	static _findQuerySubjectByOriginalRefThenRef(module, ref) {
		var qsList = MoserObjectUtils.getList(module.basicGetQuerySubject());
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (qs.getInstanceType() != InstanceType.COPY && qs.getInstanceType() != InstanceType.MISSING && ModuleUtils._containsQSRefInOriginalRefThenRef(ref, qs)) {
				return qs;
			}
		}
		return null;
	}

	static _updateExistingQuerySubject(existingQS, srcQS, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst) {
		if (srcQS.basicGetItem()) {
			var qiMap = ModuleUtils._createQIMap(existingQS);
			for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(srcQS), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qi = __exp_enFor0[__i_enFor0];
				ModuleUtils._insertQIForExistingQS(qi, existingQS, srcQS, qiMap, false, existingQS.getItem().length, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
			}
		}
	}

	static _createQIMap(qs) {
		var qiMap = {};
		if (qs.basicGetItem()) {
			for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(qs), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qi = __exp_enFor0[__i_enFor0];
				qiMap[qi.getIdentifier()] = qi;
			}
		}
		return qiMap;
	}

	/**
	 * Insert a package into a module. This method copies the querysubjects, calculations, filters, namedsets into the module, and MDTV. It also updates the deflink ref and querysubject id to have a prefix (eg., M1)
	 * @param {ObjectFactory} objectFactory  : to create new objects
	 * @param {Module} module  : the destination module
	 * @param {String} srcModuleId  : the identifier of the package
	 * @param {Module} srcModule  : the package
	 * @param {FolderType} mdtvFolder  : the folder to insert in the MDTV
	 * @param {int} insertAtIndex  : the index of mdtvFolder array to indicate where to insert in MDTV
	 * @throws {CloneNotSupportedException} CloneNotSupportedException  : exception when cloning
	 */
	static insertPackage(objectFactory, module, srcModuleId, srcModule, mdtvFolder, insertAtIndex) {
		if (CommonResolverUtil.getFMPlaceHolderInMDTV(module, srcModuleId)) {
			return;
		}
		var idToQSObjMap = {};
		var qsList = MoserObjectUtils.getList(srcModule.basicGetQuerySubject());
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var qsCopy = ModuleUtils._cloneAndUpdateId(qs, srcModuleId);
			module.addQuerySubject(qsCopy);
			idToQSObjMap[qsCopy.getIdentifier()] = qsCopy;
			for (var __i_enFor1 = 0, __exp_enFor1 = MoserObjectUtils.getItems(qsCopy), __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var aItem = __exp_enFor1[__i_enFor1];
				if (aItem instanceof QueryItem) {
					aItem.setIdForExpression(null);
				}
			}
		}
		var idToObjMap = {};
		var calcList = MoserObjectUtils.getList(srcModule.basicGetCalculation());
		for (var __i_enFor2 = 0, __exp_enFor2 = calcList, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var calc = __exp_enFor2[__i_enFor2];
			var calcCopy = ModuleUtils._cloneAndUpdateId(calc, srcModuleId);
			idToObjMap[calcCopy.getIdentifier()] = calcCopy;
			module.addCalculation(calcCopy);
		}
		var filterList = MoserObjectUtils.getList(srcModule.basicGetFilter());
		for (var __i_enFor3 = 0, __exp_enFor3 = filterList, __len_enFor3 = __exp_enFor3.length;
				__i_enFor3 < __len_enFor3; ++__i_enFor3) {
			var filter = __exp_enFor3[__i_enFor3];
			var filterCopy = ModuleUtils._cloneAndUpdateId(filter, srcModuleId);
			idToObjMap[filterCopy.getIdentifier()] = filterCopy;
			module.addFilter(filterCopy);
		}
		var namedSetList = MoserObjectUtils.getList(srcModule.basicGetNamedSet());
		for (var __i_enFor4 = 0, __exp_enFor4 = namedSetList, __len_enFor4 = __exp_enFor4.length;
				__i_enFor4 < __len_enFor4; ++__i_enFor4) {
			var namedSet = __exp_enFor4[__i_enFor4];
			var namedSetCopy = ModuleUtils._cloneAndUpdateId(namedSet, srcModuleId);
			idToObjMap[namedSetCopy.getIdentifier()] = namedSetCopy;
			module.addNamedSet(namedSetCopy);
		}
		var placeHolder = objectFactory.createFolderType();
		placeHolder.setIdentifier(srcModuleId);
		placeHolder.setLabel(srcModule.getLabel());
		placeHolder.setEditMode(EditModeType.RO);
		var ft = srcModule.getMetadataTreeView()[0];
		var fItems = ft.getFolderItem();
		for (var __i_enFor5 = 0, __exp_enFor5 = fItems, __len_enFor5 = __exp_enFor5.length;
				__i_enFor5 < __len_enFor5; ++__i_enFor5) {
			var fit = __exp_enFor5[__i_enFor5];
			placeHolder.addFolderItem(fit);
		}
		var packageFolderItem = objectFactory.createFolderItemType();
		packageFolderItem.setFolder(placeHolder);
		mdtvFolder.addFolderItemAt(insertAtIndex, packageFolderItem);
		ModuleUtils._updateFolderTypeReferences(placeHolder, srcModuleId);
		var overrideMode = module.isOverrideMode();
		module.setOverrideMode(false);
		var otFlatList = [];
		ReferenceResolver.resolveFolderTypeReferences(null, placeHolder, otFlatList, idToQSObjMap, idToObjMap);
		if (!(otFlatList.length==0)) {
			var moduleFlatList = module.getFlattenedBaseObjectTypeList();
			if (!moduleFlatList) {
				module.setFlattenedBaseObjectTypeList(otFlatList);
			} else {
				Array.prototype.push.apply(moduleFlatList, otFlatList);
			}
		}
		for (var __i_enFor6 = 0, __exp_enFor6 = otFlatList, __len_enFor6 = __exp_enFor6.length;
				__i_enFor6 < __len_enFor6; ++__i_enFor6) {
			var o = __exp_enFor6[__i_enFor6];
			CommonResolverUtil.markFM(o);
		}
		CommonResolverUtil.markFM(placeHolder);
		module.setOverrideMode(overrideMode);
	}

	static _cloneAndUpdateId(obj, idPrefix) {
		var id = idPrefix + "." + obj.getIdentifier();
		var objCopy = obj.clone();
		objCopy.setIdentifier(id);
		objCopy.setIdForExpression(null);
		return objCopy;
	}

	static _updateFolderTypeReferences(folderType, idPrefix) {
		var folderItemTypes = folderType.basicGetFolderItem();
		if (folderItemTypes) {
			for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folderItemType = __exp_enFor0[__i_enFor0];
				var nestedFolder = folderItemType.getFolder();
				if (nestedFolder) {
					ModuleUtils._updateFolderTypeReferences(nestedFolder, idPrefix);
				}
				var defLinkType = folderItemType.getDefLink();
				if (defLinkType && defLinkType.getIdentifier() != null) {
					var ref = idPrefix + "." + defLinkType.getIdentifier();
					defLinkType.setRef(ref);
				}
			}
		}
	}

	static _insertFolderItem(folder, obj, index, objectFactory) {
		var item = objectFactory.createFolderItemType();
		item.setRef(obj.getIdentifier());
		item.setReferencedObject(obj);
		folder.addFolderItemAt(index, item);
	}

	static _insertFolder(folder, obj, index, objectFactory) {
		var item = objectFactory.createFolderItemType();
		item.setFolder(obj);
		item.setReferencedObject(obj);
		folder.addFolderItemAt(index, item);
	}

	static _updateQuerySubjectRef(module, qs, srcModuleId, srcModule, isReference, qsIdentifier) {
		if (isReference) {
			QuerySubjectUtils.clearOriginalRef(qs);
			var ref = srcModuleId + "." + qsIdentifier;
			qs.addOriginalRef(ref);
			var refs = qs.getRef();
			for (var i = 0; i < refs.length; ++i) {
				ref = refs[i];
				var srcModuleUseSpecId = ReferenceResolver.getFirstPart(ref);
				var oldUseSpec = QuerySubjectUtils.getUseSpecById(srcModule, srcModuleUseSpecId);
				if (!oldUseSpec) {
					continue;
				}
				var useSpec = ModuleUtils._getUseSpecByStoreId(module, oldUseSpec.getStoreID());
				var newModuleId;
				if (!useSpec) {
					useSpec = oldUseSpec.clone();
					newModuleId = IdGenerator.generateNewUseSpecIdWithPrefix(module, "__Base");
					useSpec.setIdentifier(newModuleId);
					module.addUseSpec(useSpec);
				} else {
					newModuleId = useSpec.getIdentifier();
				}
				var sepIndex = ref.indexOf(".");
				ref = newModuleId + "." + ref.substring(sepIndex + 1);
				qs.removeRefAt(i);
				qs.addRefAt(i, ref);
			}
		} else {
			QuerySubjectUtils.clearOriginalRef(qs);
			QuerySubjectUtils.clearRef(qs);
			qs.addRef(srcModuleId + "." + qsIdentifier);
		}
	}

	static _getUseSpecByStoreId(module, storeId) {
		var uSpecs = MoserObjectUtils.getList(module.basicGetUseSpec());
		for (var __i_enFor0 = 0, __exp_enFor0 = uSpecs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var useSpec = __exp_enFor0[__i_enFor0];
			if (storeId == useSpec.getStoreID()) {
				return useSpec;
			}
		}
		return null;
	}

	static _findRelationshipMatch(module, rel) {
		var relationShips = MoserObjectUtils.getList(module.basicGetRelationship());
		for (var __i_enFor0 = 0, __exp_enFor0 = relationShips, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var relshp = __exp_enFor0[__i_enFor0];
			if (RelationshipUtils.isEqual(rel, relshp)) {
				return relshp;
			}
		}
		return null;
	}

	static _findQuerySubjectByRef(module, qsRef) {
		var qsList = MoserObjectUtils.getList(module.basicGetQuerySubject());
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (ModuleUtils._findString(qs.basicGetRef(), qsRef) || ModuleUtils._findString(qs.basicGetOriginalRef(), qsRef)) {
				return qs;
			}
		}
		return null;
	}

	/**
	 * Returns true if qsRef is in the original ref then ref of a query subject. Ignores query subjects with copy or missing instance type
	 * @param {String} qsRef 	ref
	 * @param {QuerySubject} qs     query subject
	 */
	static _containsQSRefInOriginalRefThenRef(qsRef, qs) {
		var refList = qs.basicGetOriginalRef();
		if (!refList || refList.length==0) {
			refList = qs.basicGetRef();
		}
		return ModuleUtils._findString(refList, qsRef);
	}

	static _findString(strList, strValue) {
		if (!strList) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = strList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var str = __exp_enFor0[__i_enFor0];
			if (str == strValue) {
				return true;
			}
		}
		return false;
	}

	static _deleteRelationshipsForQuerySubject(module, rels, qsId) {
		var i;
		for (i = rels.length - 1; i >= 0; --i) {
			var rel = rels[i];
			if (qsId == rel.getLeft().getRef() || qsId == rel.getRight().getRef()) {
				module.removeRelationshipAt(i);
			}
		}
	}

	static deleteRelationshipsForQS(module, rels, qsId, instanceTypes) {
		if (!instanceTypes || instanceTypes.length==0) {
			ModuleUtils._deleteRelationshipsForQuerySubject(module, rels, qsId);
			return;
		}
		for (var i = rels.length - 1; i >= 0; --i) {
			var rel = rels[i];
			if (instanceTypes.indexOf(rel.getInstanceType())> -1) {
				if (qsId == rel.getLeft().getRef() || qsId == rel.getRight().getRef()) {
					module.removeRelationshipAt(i);
				}
			}
		}
	}

	/**
	 * Delete a query subject from a module and clean up any reference to the query subject
	 * @param {Module} module
	 * @param {QuerySubject} qs  : query subject to be deleted from module
	 */
	static deleteQuerySubject(module, qs) {
		ModuleUtils._deleteQuerySubjectImp(module, qs, true);
	}

	/**
	 * restore the ref from the original ref.
	 * @param {QuerySubject} sc
	 */
	static _restoreRefFromOriginalRef(sc) {
		var orgRef = sc.basicGetOriginalRef();
		if (!orgRef || orgRef.length==0) {
			return;
		}
		var ref = sc.basicGetRef();
		var i = 0;
		if (ref && !(ref.length==0)) {
			for (i = ref.length - 1; i >= 0; --i) {
				sc.removeRefAt(i);
			}
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = orgRef, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var r = __exp_enFor0[__i_enFor0];
			sc.addRef(r);
		}
		for (i = orgRef.length - 1; i >= 0; --i) {
			sc.removeOriginalRefAt(i);
		}
	}

	/**
	 * @param {QuerySubject} sc
	 */
	static cleanShortcutQuerySubject(sc) {
		sc.setInstanceType(InstanceType.MISSING);
		ModuleUtils._restoreRefFromOriginalRef(sc);
		if (sc.getDataCacheExpiry() != null) {
			sc.setDataCacheExpiry(null);
		}
		var i = 0;
		var props = MoserObjectUtils.getList(sc.basicGetProperty());
		for (i = props.length - 1; i >= 0; --i) {
			var p = props[i];
			if ("_MUI_data_cache" == p.getName()) {
				sc.removePropertyAt(i);
			}
		}
		if (sc.getComment() != null) {
			sc.setComment(null);
		}
		if (sc.getScreenTip() != null) {
			sc.setScreenTip(null);
		}
		if (sc.isHidden() != null) {
			sc.setHidden(null);
		}
		if (sc.getQuerySubjectUsage()) {
			sc.setQuerySubjectUsage(null);
		}
		if (sc.getSelectListControl()) {
			sc.setSelectListControl(null);
		}
		if (sc.getSqlQuery()) {
			sc.setSqlQuery(null);
		}
		if (sc.getQueryOperation()) {
			sc.setQueryOperation(null);
		}
		if (sc.getJoinOperation()) {
			sc.setJoinOperation(null);
		}
		if (sc.getClassifier()) {
			sc.setClassifier(null);
		}
		if (sc.getItemNormalization()) {
			sc.setItemNormalization(null);
		}
		var secFilters = MoserObjectUtils.getList(sc.basicGetSecurityFilter());
		for (i = secFilters.length - 1; i >= 0; --i) {
			sc.removeSecurityFilterAt(i);
		}
		var embedFilters = MoserObjectUtils.getList(sc.basicGetFilter());
		for (i = embedFilters.length - 1; i >= 0; --i) {
			var f = embedFilters[i];
			if (EditModeType.RO === f.getEditMode()) {
				sc.removeFilterAt(i);
			}
		}
		var itmObjs = MoserObjectUtils.getItems(sc);
		var pre;
		for (var __i_enFor0 = 0, __exp_enFor0 = itmObjs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var o = __exp_enFor0[__i_enFor0];
			if (EditModeType.RO === o.getEditMode()) {
				ModuleUtils._removeObjectFromQuerySubject(o, true);
			} else {
				ModuleUtils._setPositionAfter(o, pre);
			}
			pre = o.getIdentifier();
		}
	}

	/**
	 * clean shortcut.
	 * @param {QuerySubject} qs
	 */
	static _cleanShortcut(qs) {
		var references = MoserObjectUtils.getShortcutReferences(qs);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var sc = __exp_enFor0[__i_enFor0];
			ModuleUtils._cleanShortcut(sc);
			if (!(InstanceType.REFERENCE === sc.getInstanceType())) {
				continue;
			}
			ModuleUtils.cleanShortcutQuerySubject(sc);
		}
	}

	/**
	 * @param {ObjectType} o
	 * @param {String} pre
	 */
	static _setPositionAfter(o, pre) {
		var itm = MoserObjectUtils.getParentObjectOfType(o, "ItemType");
		if (itm) {
			(itm).setPositionAfter(pre);
		}
	}

	static _deleteQuerySubjectRelatedObjects(module, qs, qsId) {
		ModuleUtils._cleanShortcut(qs);
		var rels = MoserObjectUtils.getList(module.basicGetRelationship());
		ModuleUtils._deleteRelationshipsForQuerySubject(module, rels, qsId);
		var dgs = MoserObjectUtils.getList(module.basicGetDrillGroup());
		var qsFirstPart = qsId + ".";
		var i;
		for (i = dgs.length - 1; i >= 0; --i) {
			var dg = dgs[i];
			var segs = dg.basicGetSegment();
			if (!segs) {
				continue;
			}
			for (var j = segs.length - 1; j >= 0; --j) {
				if (segs[j].getRef().indexOf(qsFirstPart) == 0) {
					dg.removeSegmentAt(j);
				}
			}
		}
	}

	static _deleteQuerySubjectImp(module, qs, bClean) {
		var qsId = qs.getIdentifier();
		if (bClean) {
			ModuleUtils._deleteQuerySubjectRelatedObjects(module, qs, qsId);
		}
		var mdtvs = MoserObjectUtils.getList(module.basicGetMetadataTreeView());
		for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folder = __exp_enFor0[__i_enFor0];
			var del = ModuleUtils._removeQuerySubjectFromMDTVFolder(qsId, folder, bClean);
			if (!bClean && del) {
				return del;
			}
		}
		module.removeQuerySubject(qs);
		return qs;
	}

	static _removeQuerySubjectFromMDTVFolder(qsId, folder, bClean) {
		if (!folder) {
			return null;
		}
		var itemList = MoserObjectUtils.getList(folder.basicGetFolderItem());
		for (var j = itemList.length - 1; j >= 0; --j) {
			if (qsId == itemList[j].getRef()) {
				var r = itemList[j];
				if (bClean) {
					folder.removeFolderItemAt(j);
				} else {
					return r;
				}
			} else {
				var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(qsId, itemList[j].getFolder(), bClean);
				if (r && !bClean) {
					return r;
				}
			}
		}
		return null;
	}

	/**
	 * We are inserting qsList into dstModule, so we need to find some relationships in srcModule that we can copy to dstModule as well
	 * @param  srcModule: Source Module
	 * @param  srcModuleId: this is dstModule.srcModuleUseSpec.id
	 * @param  qsList: List of query subjects coming from the srcModule and will be added to the dstModule
	 * @param  dstModule: Destination Module
	 * @return {Array}  List of suggested relationships
	 */
	static suggestRelationships(srcModule, srcModuleId, qsList, dstModule) {
		var result = [];
		var qsIds = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			qsIds[qs.getIdentifier()] = 1;
		}
		var qsRefs = {};
		var dstQSList = MoserObjectUtils.getList(dstModule.basicGetQuerySubject());
		for (var __i_enFor1 = 0, __exp_enFor1 = dstQSList, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qs = __exp_enFor1[__i_enFor1];
			var prefix = srcModuleId + ".";
			var qsRefList = MoserObjectUtils.getList(qs.basicGetRef());
			for (var __i_enFor2 = 0, __exp_enFor2 = qsRefList, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var ref = __exp_enFor2[__i_enFor2];
				if (ref.indexOf(prefix) == 0) {
					qsRefs[ref] = 1;
				}
			}
			var qsOrgRefList = MoserObjectUtils.getList(qs.basicGetOriginalRef());
			for (var __i_enFor3 = 0, __exp_enFor3 = qsOrgRefList, __len_enFor3 = __exp_enFor3.length;
					__i_enFor3 < __len_enFor3; ++__i_enFor3) {
				var ref = __exp_enFor3[__i_enFor3];
				if (ref.indexOf(prefix) == 0) {
					qsRefs[ref] = 1;
				}
			}
		}
		var srcRelList = MoserObjectUtils.getList(srcModule.basicGetRelationship());
		for (var __i_enFor4 = 0, __exp_enFor4 = srcRelList, __len_enFor4 = __exp_enFor4.length;
				__i_enFor4 < __len_enFor4; ++__i_enFor4) {
			var rel = __exp_enFor4[__i_enFor4];
			var otherQSId;
			if (qsIds.hasOwnProperty(rel.getLeft().getRef())) {
				otherQSId = rel.getRight().getRef();
			} else if (qsIds.hasOwnProperty(rel.getRight().getRef())) {
				otherQSId = rel.getLeft().getRef();
			} else {
				continue;
			}
			if (qsIds.hasOwnProperty(otherQSId)) {
				result.push(rel);
			} else {
				var otherRef = srcModuleId + "." + otherQSId;
				if (qsRefs.hasOwnProperty(otherRef)) {
					result.push(rel);
				} else {
					var qs = ModuleUtils.getQuerySubjectById(otherQSId, srcModule);
					if (qs) {
						var ref = qs.getRef()[0];
						if (ref != null && !(ref.length === 0)) {
							var useSpec = DataModuleExtractor.getUseSpecByRef(srcModule, ref, true);
							var storeId = null;
							if (useSpec) {
								storeId = useSpec.getStoreID();
							}
							if (storeId != null) {
								var dstModuleUSpecs = MoserObjectUtils.getList(dstModule.basicGetUseSpec());
								for (var __i_enFor5 = 0, __exp_enFor5 = dstModuleUSpecs, __len_enFor5 = __exp_enFor5.length;
										__i_enFor5 < __len_enFor5; ++__i_enFor5) {
									var us = __exp_enFor5[__i_enFor5];
									var id = us.getIdentifier();
									if (us.getStoreID() == storeId && id.indexOf("__Base") != 0) {
										var dstRef = us.getIdentifier() + "." + ReferenceResolver.getSecondPart(ref);
										var qsDst = ModuleUtils._findQuerySubjectByRef(dstModule, dstRef);
										if (qsDst) {
											result.push(rel);
										}
										break;
									}
								}
							}
						}
					}
				}
			}
		}
		return result;
	}

	/**
	 * Retrieve <code>QuerySubject</code> by identifier
	 * @param {String} id 	the identifier used as a 'ref' by other objects
	 * @param {Module} module 	the data module
	 * @return {QuerySubject}  a reference of the <code>QuerySubject</code>
	 */
	static getQuerySubjectById(id, module) {
		var querySubject;
		var qsList = MoserObjectUtils.getList(module.basicGetQuerySubject());
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (qs.getIdentifier() == id) {
				querySubject = qs;
				break;
			}
		}
		return querySubject;
	}

	/**
	 * Retrieve all <code>QuerySubject</code>s in a data module referencing a source query subject. Finds query subjects in a data module referencing a query subject from another source module or base module. Ignores query subjects with missing instance type.
	 * @param {QuerySubject} srcQS 		  source query subject
	 * @param {Module} module 	  the data module
	 * @param {String} srcModuleId  source module alias (optional)
	 * @return {Array}  a list of query subjects from data module.
	 */
	static getQuerySubjectBySourceQuerySubject(srcQS, module, srcModuleId) {
		var foundQuerySubjects = [];
		if (srcQS && module) {
			var qsRef = ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, srcQS) + "." + srcQS.getIdentifier();
			var qsList = MoserObjectUtils.getList(module.basicGetQuerySubject());
			for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qs = __exp_enFor0[__i_enFor0];
				if (qs.getInstanceType() != InstanceType.MISSING && ModuleUtils._containsQSRefInOriginalRefThenRef(qsRef, qs)) {
					foundQuerySubjects.push(qs);
				}
			}
		}
		return foundQuerySubjects;
	}

	/**
	 * Retrieve <code>Relationship</code> by identifier
	 * @param {String} id 	the identifier used as a 'ref' by other objects
	 * @param {Module} module 	the data module
	 * @return {Relationship}  a reference of the <code>Relationship</code>
	 */
	static getRelationshipById(id, module) {
		var relationship;
		var rlshpList = MoserObjectUtils.getList(module.basicGetRelationship());
		for (var __i_enFor0 = 0, __exp_enFor0 = rlshpList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var rlshp = __exp_enFor0[__i_enFor0];
			if (rlshp.getIdentifier() == id) {
				relationship = rlshp;
				break;
			}
		}
		return relationship;
	}

	/**
	 * Retrieve <code>Calculation</code> by identifier
	 * @param {String} id  the identifier used as a 'ref' by other objects
	 * @param {Module} module 	the data module
	 * @return {Calculation}  a reference of the <code>Calculation</code>
	 */
	static getCalculationById(id, module) {
		var calculation;
		var calculations = MoserObjectUtils.getList(module.basicGetCalculation());
		for (var __i_enFor0 = 0, __exp_enFor0 = calculations, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var calc = __exp_enFor0[__i_enFor0];
			if (calc.getIdentifier() == id) {
				calculation = calc;
				break;
			}
		}
		return calculation;
	}

	/**
	 * Retrieve <code>QueryItem</code> by identifier
	 * @param {String} qualifiedID  the identifier used as a 'ref' by other objects to refer to a QueryItem. It is in the format of "querysubjectid.queryitemid"
	 * @param {Module} module 	the data module
	 * @return {BaseQueryItemType}  a reference of the <code>QueryItem</code>
	 */
	static getQueryItemById(qualifiedID, module) {
		var queryItem;
		var qsId = ReferenceResolver.getFirstPart(qualifiedID);
		if (qsId != null && qsId.length > 0) {
			var qs = ModuleUtils.getQuerySubjectById(qsId, module);
			var qiId = ReferenceResolver.getSecondPart(qualifiedID);
			if (qs && qiId != null && qiId.length > 0) {
				queryItem = QuerySubjectUtils.getQueryItemById(qiId, qs);
			}
		}
		return queryItem;
	}

	/**
	 * Retrieve <code>Filter</code> by identifier
	 * @param {String} id  the identifier used as a 'ref' by other objects
	 * @param {Module} module 	the data module
	 * @return {Filter}  a reference of the <code>Filter</code>
	 */
	static getFilterById(id, module) {
		var filter;
		var filterList = MoserObjectUtils.getList(module.basicGetFilter());
		for (var __i_enFor0 = 0, __exp_enFor0 = filterList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var fltr = __exp_enFor0[__i_enFor0];
			if (fltr.getIdentifier() == id) {
				filter = fltr;
				break;
			}
		}
		return filter;
	}

	/**
	 * Retrieve <code>MoserObject</code> by idForExpression
	 * @param {String} idForExprn  the idForExpression to look for
	 * @param {Module} module 	the data module
	 * @return {MoserObject}  a reference of the <code>MoserObject</code> including QuerySubject, QueryItem, Calculation and Filter
	 */
	static getMoserObjectByIdForExpression(idForExprn, module) {
		var obj = ReferenceResolver.getMoserObjectByIdForExpression(idForExprn, module);
		if (!obj) {
			var alias = ReferenceResolver.strBetween(idForExprn, "[", "].");
			if (alias != null) {
				for (var __i_enFor0 = 0, __exp_enFor0 = module.getUseSpec(), __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (alias == useSpec.getIdentifier()) {
						var newID = alias + "." + ReferenceResolver.strAfter(idForExprn, "].");
						return ReferenceResolver.getMoserObjectByIdForExpression(newID, module);
					}
				}
			}
		}
		return obj;
	}

	/**
	 * @return {ObjectType}  Locate and return object by it's fully qualified path (idForExpression). If not found, see if this is a split definition QI , expand it, add new items to the cache and return the one annotated by idForExpression. Return null if not found
	 */
	static findAndCacheObjectById(cache, idForExpression, module) {
		var object = cache[idForExpression];
		if (object) {
			return object;
		}
		var parts = IdGenerator.splitQualifiedPath(idForExpression);
		var parent;
		for (var i = parts.length - 1; i > 0; --i) {
			var qullyQualifiedPath = ModuleUtils._join(parts, i, ".");
			parent = cache[qullyQualifiedPath];
			if (parent) {
				break;
			}
		}
		if (parent) {
			if ("QueryItem" == parent.getObjectType()) {
				var parent_QI = parent;
				var splitDefinition = parent_QI.basicGetSplitDefinition();
				if (!splitDefinition || splitDefinition.length==0) {
					return null;
				}
				var querySubject = QuerySubjectUtils.getParentQuerySubject(parent);
				if (!querySubject) {
					return null;
				}
				if (splitDefinition.length != 1) {
					return null;
				}
				var sp = splitDefinition[0];
				var ref = sp.getRef();
				if (ref == null || ref.length === 0 || "none" == ref.toLowerCase() || !cache[ref]) {
					return null;
				}
				var items = PropertySetter.createItemsFromSplitDefinition(parent_QI, cache[ref], querySubject);
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi = item.getQueryItem();
					if (idForExpression == qi.getIdForExpression()) {
						object = qi;
					}
					cache[qi.getIdForExpression()] = qi;
				}
				object = cache[idForExpression];
				return object;
			}
		}
		var temp_cache = {};
		for (var __i_enFor1 = 0, __exp_enFor1 = module.getQuerySubject(), __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qs = __exp_enFor1[__i_enFor1];
			if (!(cache.hasOwnProperty(idForExpression))) {
				temp_cache[qs.getIdForExpression()] = qs;
				for (var __i_enFor2 = 0, __exp_enFor2 = qs.getItem(), __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var item = __exp_enFor2[__i_enFor2];
					var qi = item.getQueryItem();
					if (qi) {
						temp_cache[qi.getIdForExpression()] = qi;
					}
				}
			}
		}
		return ModuleUtils.findAndCacheObjectById(temp_cache, idForExpression, module);
	}

	/**
	 * Pull together multipart name separated by the separator character
	 */
	static _join(parts, index, separator) {
		var result = "";
		for (var i = 0; i < index; ++i) {
			result += parts[i];
			if (i + 1 != index) {
				result += separator;
			}
		}
		return result.valueOf();
	}

	static _getModule(o) {
		var obj = o.getParent();
		while (obj) {
			if ("Module" == obj.getObjectType()) {
				return obj;
			}
			obj = obj.getParent();
		}
		return null;
	}

	/**
	 * If you have a ObjectType, it may have a ref that point to an object in a source. This method returns the UseSpec that point to that source.
	 * @param {ObjectType} obj  : ObjectType to find UseSpec for.
	 * @param {Module} m  : the module that contains the object. if null, we'll try to find it using getParent()
	 * @return {UseSpec}  UseSpec of the referenced source or null if can't find it.
	 */
	static getObjectUseSpec(obj, m) {
		var module = m;
		if (!module) {
			module = ModuleUtils._getModule(obj);
			if (!module) {
				throw new Error("Can't find the module!");
			}
		}
		return DataModuleExtractor.getUseSpec(obj, module, false);
	}

	/**
	 * For a given UseSpec, return the list of ObjectType's in the Module that are referencing it. The only ObjectType's that can have a reference are: QuerySubject, Relationship, Calculation, Filter
	 * @param {UseSpec} useSpec  : The UseSpec to find all references of
	 * @param {Module} m  : the module that contains the object. if null, we'll try to find it using getParent()
	 * @return {Array}
	 */
	static getUseSpecRefs(useSpec, m) {
		var module = m;
		if (!module) {
			module = ModuleUtils._getModule(useSpec);
			if (!module) {
				throw new Error("Can't find the module!");
			}
		}
		return DataModuleExtractor.getUseSpecRefs(useSpec, module);
	}

	/**
	 * Create a list of Ancestors by parsing a JSONArray that is returned with /sources calls.
	 * @param {Array} ancestorsResp JSONArray that is returned with /sources calls., e.g.[ { "name": "Some directory", "id": "iAA9C873CD3AF42D5ADB36572D05C98E6", "type": "directory" }, { "name": "My Folders", "id": "i32DE242D91604B8DAB9CE8EA5E46B37D", "type": "folder" }, { "name": "Some directory", "id": "iAA9C873CD3AF42D5ADB36572D05C98E6", "type": "directory" } ]
	 * @param {String} myFoldersLabel  symbolic id for my content folder
	 * @param {String} teamContentLabel  symbolic if for team content folder
	 * @return {Array}  list of ancestors
	 */
	static createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel) {
		return MoserCommonUtils.createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel);
	}

	/**
	 * Create members under the given parent from the JSON response to calling the members endpoint API.
	 * @param {ObjectFactory} factory  - Used to create a member.
	 * @param {MoserObject} parent  - Created members are added to this parent.
	 * @param {Object} membersResponse  - Input members response from which members are created.
	 */
	static createMembers(factory, parent, membersResponse) {
		if (!factory || !parent || !membersResponse) {
			return null;
		}
		var dataItems = membersResponse["dataItems"];
		if (!dataItems || dataItems.length==0) {
			return null;
		}
		if (!(parent instanceof QueryItem || parent instanceof MemberType)) {
			return null;
		}
		var items = (dataItems[0])["items"];
		if (!items) {
			return null;
		}
		var members = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var member = ModuleUtils._addMember(factory, ModuleUtils._getData(item), parent);
			if (member) {
				members.push(member);
				ModuleUtils.setMemberHidden(member, false);
			}
		}
		return members;
	}

	static _getData(item) {
		var t = item["t"];
		if (!t || t.length != 1) {
			return null;
		}
		return t[0];
	}

	/**
	 * @param {ObjectFactory} factory
	 * @param  item
	 * @param {MoserObject} parent
	 */
	static _addMember(factory, data, parent) {
		if (!data || !parent) {
			return null;
		}
		var mun = data["u"];
		var member = ModuleUtils._getMember(parent, mun);
		if (member) {
			if (parent instanceof QueryItem) {
				(parent).removeMembers(member);
				(parent).addMembers(member);
			} else {
				(parent).removeMembers(member);
				(parent).addMembers(member);
			}
			return member;
		}
		member = factory.createMemberType();
		ModuleUtils.setMemberHidden(member, true);
		member.setIdentifier(mun);
		member.setIdForExpression(mun);
		member.setLabel(data["d"]);
		member.setMemberCaption(data["d"]);
		var jparent = data["p"];
		if (jparent) {
			member.setParentUniqueName(jparent["u"]);
		}
		member.setDimensionUniqueName(data["du"]);
		member.setLevelNumber(data["ln"]);
		member.setLevelLabel(data["ll"]);
		member.setLevelUniqueName(data["lu"]);
		member.setHierarchyUniqueName(data["hu"]);
		member.setParentLevel(data["pn"]);
		var ctype = data["ctype"];
		if (ctype != null && !(ctype.length === 0)) {
			try {
				member.setCalculatedMemberType(CalculatedMemberTypeEnum.fromValue(ctype));
			} catch (e) {
				throw e;
			}

		}
		if (parent instanceof QueryItem) {
			(parent).addMembers(member);
		} else {
			(parent).addMembers(member);
		}
		return member;
	}

	/**
	 * @param {MoserObject} parent
	 * @param {String} mun
	 * @return {MemberType}
	 */
	static _getMember(parent, mun) {
		if (mun == null) {
			return null;
		}
		var members;
		if (parent instanceof QueryItem) {
			members = (parent).basicGetMembers();
		} else {
			members = (parent).basicGetMembers();
		}
		if (!members || members.length==0) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = members, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var member = __exp_enFor0[__i_enFor0];
			if (mun == member.getIdForExpression()) {
				return member;
			}
		}
		return null;
	}

	/**
	 * Create members under the given parent from the JSON response to calling the members endpoint API.
	 * @param {ObjectFactory} factory  - Used to create a member.
	 * @param  parent  - Created members are added to this parent.
	 * @param {Object} membersResponse  - Input members response from which members are created.
	 */
	static createMembersForSearch(factory, module, membersResponse) {
		if (!factory || !module || !membersResponse) {
			return null;
		}
		var dataItems = membersResponse["dataItems"];
		if (!dataItems || dataItems.length != 1) {
			return null;
		}
		var items = (dataItems[0])["items"];
		if (!items || items.length==0) {
			return null;
		}
		var members = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var data = ModuleUtils._getData(item);
			var parent = ModuleUtils._getMemberParent(module, data);
			if (parent) {
				var member = ModuleUtils._addMember(factory, data, parent);
				if (member) {
					members.push(member);
					member.setParent(parent);
				}
			}
		}
		return members;
	}

	/**
	 * @param {Module} module
	 * @param {Object} item
	 * @return {MoserObject}
	 */
	static _getMemberParent(module, item) {
		if (!module || !item) {
			return null;
		}
		var mun = item["u"];
		if (mun == null) {
			return null;
		}
		var itemId = ModuleUtils._extractItemID(mun);
		return ReferenceResolver.bindMoserObject(module, itemId);
	}

	/**
	 * @param {String} startAtPath
	 * @return {String}
	 */
	static _extractItemID(startAtPath) {
		var itemId = startAtPath;
		var idx = startAtPath.indexOf("->");
		if (idx != -1) {
			itemId = startAtPath.substring(0, idx);
		}
		return itemId;
	}

	/**
	 * Given the Moser JSON response of a long running task (TaskState), calculate a percentage completed.
	 * @param {Object} taskStatus
	 */
	static taskPercentage(taskStatus) {
		var state = taskStatus["state"];
		if ("SUCCESS" == state || "CANCELLED" == state || "ERROR" == state || "NOT_AVAILABLE" == state) {
			return 100;
		}
		if ("PENDING" == state) {
			return 0;
		}
		return ModuleUtils._taskStepPercentage(taskStatus["taskStep"]);
	}

	/**
	 * Given the JSON of a TaskStep, calculate a percentage completed.
	 * @param {Object} taskStep
	 */
	static _taskStepPercentage(taskStep) {
		var numTotalSteps = (taskStep["numTotalSteps"]);
		var numCompleted = taskStep.hasOwnProperty("numCompleted") ? (taskStep["numCompleted"]) : 0;
		var currentStepNum = (taskStep["currentStepNum"]);
		var percentagePerStep = 100.0 / numTotalSteps;
		var stepNum = currentStepNum < 1 ? 1 : currentStepNum;
		stepNum += numCompleted;
		var percentageCompleted = percentagePerStep * (stepNum - 1);
		var currentSubTask = taskStep["currentSubTask"];
		if (currentSubTask) {
			percentageCompleted += percentagePerStep * ModuleUtils._taskStepPercentage(currentSubTask) / 100.0;
		}
		return percentageCompleted > 100.0 ? 100 : percentageCompleted < 0.0 ? 0 : Math.round(percentageCompleted);
	}

	static findObjectTypeByIdForExpression(module, idForExprn) {
		if (idForExprn == null || idForExprn.length === 0) {
			return null;
		}
		var parts = idForExprn.split(new RegExp("\\."));
		if (parts.length == 0) {
			return null;
		}
		if (parts.length == 1) {
			var qs = ModuleUtils.getQuerySubjectById(parts[0], module);
			if (qs) {
				return qs;
			}
			var calc = ModuleUtils.getCalculationById(parts[0], module);
			if (calc) {
				return calc;
			}
			return ModuleUtils.getFilterById(parts[0], module);
		}
		var qs = ModuleUtils.getQuerySubjectById(parts[0], module);
		if (!qs) {
			return null;
		}
		var items = qs.basicGetItem();
		var rt;
		for (var currentPos = 1; currentPos < parts.length; ++currentPos) {
			rt = ModuleUtils._findObjectTypeByIdInItems(items, parts[currentPos]);
			if (!rt) {
				break;
			}
			if (rt.getObjectType() == "QueryItem") {
				items = (rt).basicGetItem();
			} else {
				items = null;
			}
		}
		return rt;
	}

	static _findObjectTypeByIdInItems(items, id) {
		if (!items) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var qi = itm.getQueryItem();
			if (qi) {
				if (id == qi.getIdentifier()) {
					return qi;
				}
				continue;
			}
			var flt = itm.getFilter();
			if (flt) {
				if (id == flt.getIdentifier()) {
					return flt;
				}
				continue;
			}
			var folder = itm.getFolder();
			if (folder) {
				var rt = ModuleUtils._findObjectTypeByIdInItems(folder.basicGetItem(), id);
				if (rt) {
					return rt;
				}
				continue;
			}
		}
		return null;
	}

	static areCompatibleDataTypes(lDataType, rDataType) {
		return MoserCommonUtils.areCompatibleDataTypes(lDataType, rDataType);
	}

	static getPrecision(dataType) {
		return MoserCommonUtils.getPrecision(dataType);
	}

	static getScale(dataType) {
		return MoserCommonUtils.getScale(dataType);
	}

	/**
	 * (item collection)				itemType	itemType	itemType	itemType		itemType	itemType querysubject 	queryitem	namedset	filter		itemHierarchy	folder		calculation queryitem		y				y			x			x			x				?(qs or qi)	x namedset		y				x			x			x			x				?(qs)		x filter			y				y			x			x			x				?(qs)		x itemHierarchy	x				x			x			x			x				x			x folder			y				y			x			x			x				y			y calculation		x				x			x			x			x				?(calc)		y security/ embedded filer  y(direct)		x			x			x			x				x			x in MDTV Querysubject statndalone Calculation statndalone Filter FolderType
	 * @return {boolean}  t/f.
	 */
	static _checkValidContainer(obj, parentObj, bEmbeddedFilter) {
		if (!obj || !parentObj) {
			return false;
		}
		var objTp = obj.getObjectType();
		var allowed = {};
		var skipped = {};
		if ("QuerySubject" == objTp) {
			allowed["Module"] = 1;
			allowed["FolderType"] = 1;
			skipped["FolderItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("FolderType" == objTp) {
			allowed["Module"] = 1;
			allowed["FolderType"] = 1;
			skipped["FolderItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("QueryItem" == objTp) {
			allowed["QuerySubject"] = 1;
			allowed["QueryItem"] = 1;
			skipped["Folder"] = 1;
			skipped["ItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("NamedSet" == objTp) {
			allowed["QuerySubject"] = 1;
			skipped["Folder"] = 1;
			skipped["ItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("Filter" == objTp) {
			if (bEmbeddedFilter) {
				allowed["QuerySubject"] = 1;
				return ModuleUtils._checkContainer(parentObj, allowed, skipped);
			}
			var qs = ModuleUtils._getParentQuerySubject(parentObj);
			if (qs) {
				allowed["QuerySubject"] = 1;
				allowed["QueryItem"] = 1;
				skipped["Folder"] = 1;
				skipped["ItemType"] = 1;
				return ModuleUtils._checkContainer(parentObj, allowed, skipped);
			}
			allowed["Module"] = 1;
			allowed["FolderType"] = 1;
			skipped["FolderItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("Folder" == objTp) {
			allowed["QuerySubject"] = 1;
			allowed["QueryItem"] = 1;
			allowed["Folder"] = 1;
			allowed["Calculation"] = 1;
			skipped["ItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("Calculation" == objTp) {
			allowed["Module"] = 1;
			allowed["FolderType"] = 1;
			allowed["Calculation"] = 1;
			allowed["WhatIfModel"] = 1;
			skipped["Folder"] = 1;
			skipped["ItemType"] = 1;
			skipped["FolderItemType"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("SecurityFilter" == objTp) {
			allowed["QuerySubject"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		if ("WhatIfModel" == objTp || "Translation" == objTp) {
			allowed["Module"] = 1;
			return ModuleUtils._checkContainer(parentObj, allowed, skipped);
		}
		return false;
	}

	static _checkContainer(parentObj, allowed, skipped) {
		var parent = parentObj;
		while (parent) {
			var parentTp = parent.getObjectType();
			if (allowed.hasOwnProperty(parentTp)) {
				return true;
			}
			if (!(skipped.hasOwnProperty(parentTp))) {
				return false;
			}
			parent = parent.getParent();
		}
		return false;
	}

	/**
	 * add an object to the parent object. supported obj classes: QueryItem			-> QuerySubject SecurityFilter		-> QuerySubject Folder				-> QuerySubject QuerySubject			-> Module Calculation			-> Module FolderType			-> Module Filter				-> QuerySubject or Module depending on parentObj
	 * @param {MoserObject} obj 				object to add.
	 * @param {MoserObject} parentObj 			parent object.
	 * @param {int} index 				position.
	 * @param {boolean} bEmbeddedFilter 	optional. only for filter inside query subject. If true, it is embedded filter.
	 * @param {ObjectFactory} objectFactory 		factory.
	 */
	static add(obj, parentObj, index, objectFactory, bEmbeddedFilter) {
		if (!(ModuleUtils._checkValidContainer(obj, parentObj, bEmbeddedFilter))) {
			return false;
		}
		var added = false;
		var objTp = obj.getObjectType();
		if ("QueryItem" == objTp || "SecurityFilter" == objTp || "NamedSet" == objTp) {
			added = ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, false);
		}
		if ("Folder" == objTp) {
			var qs = ModuleUtils._getParentQuerySubject(parentObj);
			if (qs) {
				added = ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, false);
			} else {
				added = ModuleUtils._addObjectToCalculation(obj, parentObj, index, objectFactory);
			}
		}
		if ("Filter" == objTp) {
			var qs = ModuleUtils._getParentQuerySubject(parentObj);
			if (qs) {
				added = ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, bEmbeddedFilter);
			} else {
				added = ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
			}
		}
		if ("QuerySubject" == objTp) {
			added = ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
		}
		if ("WhatIfModel" == objTp) {
			var module = parentObj;
			ModuleUtils._setIdentifierInModuleScope(obj, module);
			module.addWhatIfModel(obj);
			added = true;
		}
		if ("Calculation" == objTp) {
			if ("WhatIfModel" == parentObj.getObjectType()) {
				var whatIfModel = parentObj;
				var calculation = obj;
				var idman = ModuleUtils.getIdGenerator(whatIfModel);
				idman.generateId(calculation);
				whatIfModel.addCalculation(calculation);
				added = true;
			} else {
				var c = ModuleUtils._getParentCalculation(parentObj);
				if (c) {
					var module = MoserObject.getModuleObject(c);
					if (!module) {
						return false;
					}
					ModuleUtils._setIdentifierInModuleScope(obj, module);
					added = ModuleUtils._addObjectToCalculation(obj, parentObj, index, objectFactory);
				} else {
					added = ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
				}
			}
		}
		if ("FolderType" == objTp) {
			added = ModuleUtils._addFolderTypeToMDTV(obj, parentObj, index, objectFactory);
		}
		if ("Translation" == objTp) {
			added = ModuleUtils._addTranslationToModule(obj, parentObj, index);
		}
		if (added) {
			ModuleUtils._updateShortcutRefsAdd(obj, parentObj, index, objectFactory, bEmbeddedFilter);
		}
		return added;
	}

	static _getParentCalculation(parentObj) {
		var obj = parentObj;
		while (obj) {
			var tp = obj.getObjectType();
			if ("Calculation" == tp) {
				return obj;
			}
			if ("Module" == tp) {
				return null;
			}
			obj = obj.getParent();
		}
		return null;
	}

	static _getParentQuerySubject(parentObj) {
		var parentTp = parentObj.getObjectType();
		if ("QuerySubject" == parentTp) {
			return parentObj;
		}
		return PropertySetter.getParentQuerySubject(parentObj);
	}

	static _invalidIndex(list, index) {
		return !list || index < 0 || index >= list.length;
	}

	static _addItemToParent(item, parentObj, index) {
		var parentTp = parentObj.getObjectType();
		if ("QuerySubject" == parentTp) {
			if (ModuleUtils._invalidIndex((parentObj).basicGetItem(), index)) {
				(parentObj).addItem(item);
			} else {
				(parentObj).addItemAt(index, item);
			}
			return;
		}
		if ("QueryItem" == parentTp) {
			if (ModuleUtils._invalidIndex((parentObj).basicGetItem(), index)) {
				(parentObj).addItem(item);
			} else {
				(parentObj).addItemAt(index, item);
			}
			return;
		}
		if ("Folder" == parentTp) {
			if (ModuleUtils._invalidIndex((parentObj).basicGetItem(), index)) {
				(parentObj).addItem(item);
			} else {
				(parentObj).addItemAt(index, item);
			}
			return;
		}
		if ("Calculation" == parentTp) {
			if (ModuleUtils._invalidIndex((parentObj).basicGetItem(), index)) {
				(parentObj).addItem(item);
			} else {
				(parentObj).addItemAt(index, item);
			}
			return;
		}
	}

	static _getIdChain(idChain, parentObj, anchor) {
		var parent = parentObj;
		while (parent) {
			var objType = parent.getObjectType();
			if ("QuerySubject" == objType || "QueryItem" == objType) {
				idChain.push((parent).getIdentifier());
			}
			if (parent === anchor) {
				break;
			}
			parent = parent.getParent();
		}
	}

	static _addObjectToQuerySubject(obj, parentObj, index, objectFactory, bEmbeddedFilter) {
		var qs = ModuleUtils._getParentQuerySubject(parentObj);
		if (!qs) {
			return false;
		}
		var tp = obj.getObjectType();
		var label = (obj).getLabel();
		if (label == null || label.length === 0) {
			label = "new" + tp;
		}
		var id = (obj).getIdentifier();
		if (id == null || id.length === 0) {
			id = IdGenerator.makeIdentifier(parentObj, label);
			(obj).setIdentifier(id);
		}
		if (!("Folder" == tp)) {
			if (id != null && !(id.length === 0)) {
				var idChain = [];
				ModuleUtils._getIdChain(idChain, parentObj, qs);
				var idforexpr = "";
				for (var i = idChain.length - 1; i >= 0; --i) {
					idforexpr = idforexpr + idChain[i] + ".";
				}
				idforexpr = idforexpr + id;
				(obj).setIdForExpression(idforexpr);
			}
		}
		if ("QueryItem" == tp) {
			(obj).setHighlevelDatatype(MoserCommonUtils.generateHighlevelDatatype((obj).getDatatype()));
			var item = objectFactory.createItemType();
			item.setQueryItem(obj);
			ModuleUtils._addItemToParent(item, parentObj, index);
			PropertySetter.updateItemNormFromAdd(qs, objectFactory);
			return true;
		}
		if ("NamedSet" == tp) {
			var item = objectFactory.createItemType();
			item.setNamedSet(obj);
			ModuleUtils._addItemToParent(item, parentObj, index);
			return true;
		}
		if ("Folder" == tp) {
			var item = objectFactory.createItemType();
			item.setFolder(obj);
			ModuleUtils._addItemToParent(item, parentObj, index);
			return true;
		}
		if ("Filter" == tp) {
			if (bEmbeddedFilter) {
				if (ModuleUtils._invalidIndex((parentObj).basicGetFilter(), index)) {
					(parentObj).addFilter(obj);
				} else {
					(parentObj).addFilterAt(index, obj);
				}
			} else {
				var item = objectFactory.createItemType();
				item.setFilter(obj);
				ModuleUtils._addItemToParent(item, parentObj, index);
			}
			return true;
		}
		if (ModuleUtils._invalidIndex((parentObj).basicGetSecurityFilter(), index)) {
			(parentObj).addSecurityFilter(obj);
		} else {
			(parentObj).addSecurityFilterAt(index, obj);
		}
		return true;
	}

	static _addObjectToCalculation(obj, parentObj, index, objectFactory) {
		var tp = obj.getObjectType();
		if ("Calculation" == tp) {
			var item = objectFactory.createItemType();
			item.setCalculation(obj);
			ModuleUtils._addItemToParent(item, parentObj, index);
			return true;
		}
		if ("Folder" == tp) {
			var item = objectFactory.createItemType();
			item.setFolder(obj);
			ModuleUtils._addItemToParent(item, parentObj, index);
			return true;
		}
		return false;
	}

	static _getParentFolderType(parentObj) {
		var parent = parentObj;
		while (parent) {
			var parentTp = parent.getObjectType();
			if ("FolderType" == parentTp) {
				return parent;
			}
			if ("Module" == parentTp) {
				var module = parent;
				var mdtv = module.basicGetMetadataTreeView();
				if (mdtv && !(mdtv.length==0)) {
					return mdtv[0];
				}
				return null;
			}
			parent = parent.getParent();
		}
		return null;
	}

	static _addFolderTypeToMDTV(obj, parentObj, index, objectFactory) {
		var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
		if (!parentFolderType) {
			return false;
		}
		var folderItem = objectFactory.createFolderItemType();
		folderItem.setFolder(obj);
		if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), index)) {
			parentFolderType.addFolderItem(folderItem);
		} else {
			parentFolderType.addFolderItemAt(index, folderItem);
		}
		return true;
	}

	/**
	 * Returns true if translation is successfully added to the module.
	 * @param {Translation} obj
	 * @param {MoserObject} parentObj
	 * @param {int} index
	 * @return {boolean}  t/f
	 */
	static _addTranslationToModule(obj, parentObj, index) {
		if (!("Module" == parentObj.getObjectType())) {
			return false;
		}
		var module = parentObj;
		ModuleUtils._setIdentifierInModuleScope(obj, module);
		if (ModuleUtils._invalidIndex(module.basicGetTranslation(), index)) {
			module.addTranslation(obj);
		} else {
			module.addTranslationAt(index, obj);
		}
		return true;
	}

	static _setIdentifierInModuleScope(obj, module) {
		var label = (obj).getLabel();
		if (label == null || label.length === 0) {
			label = "new" + obj.getObjectType();
		}
		var id = (obj).getIdentifier();
		if (id == null || id.length === 0) {
			id = IdGenerator.makeIdentifier(module, label);
			(obj).setIdentifier(id);
			(obj).setIdForExpression(id);
		}
		return id;
	}

	static _addObjectToModule(obj, parentObj, index, objectFactory) {
		var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
		if (!parentFolderType) {
			return false;
		}
		var module = MoserObject.getModuleObject(parentFolderType);
		if (!module) {
			return false;
		}
		var id = ModuleUtils._setIdentifierInModuleScope(obj, module);
		var tp = obj.getObjectType();
		var folderItem = objectFactory.createFolderItemType();
		folderItem.setRef(id);
		folderItem.setReferencedObject(obj);
		if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), index)) {
			parentFolderType.addFolderItem(folderItem);
		} else {
			parentFolderType.addFolderItemAt(index, folderItem);
		}
		if ("QuerySubject" == tp) {
			PropertySetter.updateIdForExpressionQuerySubject(obj, id);
			module.addQuerySubject(obj);
		} else if ("Calculation" == tp) {
			module.addCalculation(obj);
		} else {
			module.addFilter(obj);
		}
		return true;
	}

	/**
	 * remove an object.
	 * @param {MoserObject} obj  object to remove.
	 * @return {MoserObject}  obj or null.
	 */
	static remove(obj) {
		return ModuleUtils._removeImp(obj, true);
	}

	static _removeImp(obj, bClean) {
		if (!obj) {
			return null;
		}
		var removedObject;
		var qs = ModuleUtils._getParentQuerySubject(obj);
		var objTp = obj.getObjectType();
		if ("QueryItem" == objTp || "SecurityFilter" == objTp || "Folder" == objTp) {
			removedObject = ModuleUtils._removeObjectFromQuerySubject(obj, bClean);
		}
		if ("Filter" == objTp) {
			if (qs) {
				removedObject = ModuleUtils._removeObjectFromQuerySubject(obj, bClean);
			} else {
				removedObject = ModuleUtils._removeObjectFromModule(obj, bClean);
			}
		}
		if ("Calculation" == objTp || "QuerySubject" == objTp) {
			removedObject = ModuleUtils._removeObjectFromModule(obj, bClean);
		}
		if ("FolderType" == objTp) {
			removedObject = ModuleUtils._removeFolderTypeFromMDTV(obj, bClean);
		}
		if ("Translation" == objTp) {
			removedObject = ModuleUtils._removeTranslationFromModule(obj);
		}
		if ("Relationship" == objTp) {
			removedObject = ModuleUtils._removeRelationship(obj);
		}
		if (removedObject) {
			ModuleUtils._updateShortcutRefsRemove(obj, bClean, qs);
		}
		return removedObject;
	}

	static _removeObjectFromQuerySubject(obj, bClean) {
		var objTp = obj.getObjectType();
		if ("Folder" == objTp || "QueryItem" == objTp) {
			return ModuleUtils._removeParentItem(obj, bClean);
		} else if ("SecurityFilter" == objTp) {
			var parentTp = ModuleUtils._getParentObjectType(obj);
			if ("QuerySubject" == parentTp) {
				var qs = obj.getParent();
				if (bClean) {
					qs.removeSecurityFilter(obj);
				}
				return obj;
			}
			return null;
		} else if ("Filter" == objTp) {
			var parentTp = ModuleUtils._getParentObjectType(obj);
			if ("QuerySubject" == parentTp) {
				var qs = obj.getParent();
				if (bClean) {
					qs.removeFilter(obj);
				}
				return obj;
			}
			return ModuleUtils._removeParentItem(obj, bClean);
		} else {
			return null;
		}
	}

	static _getParentObjectType(obj) {
		var parent = obj.getParent();
		if (!parent) {
			return null;
		}
		return parent.getObjectType();
	}

	/**
	 * obj is in ItemType.
	 * @param {MoserObject} obj  object.
	 * @return {MoserObject}  obj or null.
	 */
	static _removeParentItem(obj, bclean) {
		var parentTp = ModuleUtils._getParentObjectType(obj);
		if (!("ItemType" == parentTp)) {
			return null;
		}
		var item = obj.getParent();
		var parentParent = item.getParent();
		if (!parentParent) {
			return null;
		}
		var parentParentTp = parentParent.getObjectType();
		var qiIds;
		var qiIdForExpressions;
		var module;
		var qs;
		if (bclean) {
			qiIds = [];
			qiIdForExpressions = [];
			ModuleUtils._collectQIIdsInItem(item, qiIds, qiIdForExpressions);
			if (!(qiIds.length==0)) {
				qs = ModuleUtils._getParentQuerySubject(item);
				module = MoserObject.getModuleObject(qs);
			}
			if (module && qs) {
				ModuleUtils._cleanSplitDefinition(module, obj);
			}
			if (qs) {
				ModuleUtils._cleanEmbeddedFilter(qs, qiIdForExpressions);
				ModuleUtils._cleanTimeReferences(qs, qiIdForExpressions);
			}
		}
		if ("QuerySubject" == parentParentTp) {
			if (bclean) {
				(parentParent).removeItem(item);
			}
		} else if ("QueryItem" == parentParentTp) {
			if (bclean) {
				(parentParent).removeItem(item);
			}
		} else if ("Folder" == parentParentTp) {
			if (bclean) {
				(parentParent).removeItem(item);
			}
		} else {
			return null;
		}
		if (qs) {
			for (var i = 0; i < qiIds.length; ++i) {
				var qiId = qiIds[i];
				if (module && qs.getIdentifier() != null) {
					PropertySetter.resetReferencedObject(module, qiId, qiIdForExpressions[i], qs.getIdentifier());
				}
				ModuleUtils._cleanItemNormalization(qs, qiId);
				if (module) {
					ModuleUtils._updateDuplicateShortcutItemNorm(qs, qiId);
				}
			}
		}
		if (bclean) {
			return obj;
		}
		return item;
	}

	/**
	 * qiIdForExpressions contains query items to be deleted. need to delete embedded filters using these query items. In dash board, there is no way to manually delete embedded filters.
	 * @param {QuerySubject} qs
	 * @param {Array} qiIdForExpressions
	 */
	static _cleanEmbeddedFilter(qs, qiIdForExpressions) {
		var embedFilters = qs.basicGetFilter();
		if (!embedFilters || embedFilters.length==0) {
			return;
		}
		var type = {};
		type["QueryItem"] = 1;
		for (var i = embedFilters.length - 1; i >= 0; --i) {
			var aFlt = embedFilters[i];
			var usedIds = PropertySetter.getUsedIds(aFlt.basicGetProperty(), type, aFlt.getExpression());
			if (!usedIds || usedIds.length==0) {
				continue;
			}
			var bUsed = false;
			for (var __i_enFor0 = 0, __exp_enFor0 = usedIds, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var aId = __exp_enFor0[__i_enFor0];
				var idForExpr = QuerySubjectUtils.getNormalized(aId, qs.getIdentifier());
				bUsed = qiIdForExpressions.indexOf(idForExpr)> -1;
				if (bUsed) {
					break;
				}
			}
			if (bUsed) {
				qs.removeFilter(aFlt);
			}
		}
	}

	/**
	 * qiIdForExpressions contains query items to be deleted. need to delete time references using these query items.
	 * @param {QuerySubject} qs
	 * @param {Array} qiIdForExpressions
	 */
	static _cleanTimeReferences(qs, qiIdForExpressions) {
		var timeReferences = qs.basicGetTimeRef();
		if (!timeReferences || timeReferences.length==0) {
			return;
		}
		for (var i = timeReferences.length - 1; i >= 0; --i) {
			var idForExpr = timeReferences[i];
			var bUsed = qiIdForExpressions.indexOf(idForExpr)> -1;
			if (bUsed) {
				qs.removeTimeRef(idForExpr);
			}
		}
	}

	static _cleanSplitDefinition(module, obj) {
		if (!obj) {
			return;
		}
		if (!("QueryItem" == obj.getObjectType())) {
			return;
		}
		var sp = (obj).basicGetSplitDefinition();
		if (!sp || sp.length==0 || PropertySetter.isEmptyRef(sp[0].getRef())) {
			return;
		}
		var idForExpr = (obj).getIdForExpression();
		var qss = module.basicGetQuerySubject();
		if (!qss) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = qss, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var aQS = __exp_enFor0[__i_enFor0];
			for (var __i_enFor1 = 0, __exp_enFor1 = PropertySetter.getAllQueryItemsInQuerySubject(aQS), __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var aQI = __exp_enFor1[__i_enFor1];
				if (aQI === obj) {
					continue;
				}
				var sp1 = aQI.basicGetSplitDefinition();
				if (!sp1 || sp1.length==0) {
					continue;
				}
				if (PropertySetter.checkSplitRefToQueryItem(aQS, aQI, ModuleUtils._getParentQuerySubject(obj), obj)) {
					sp1[0].setRef("None");
				}
			}
		}
	}

	static _cleanItemNormalization(qs, qiId) {
		var itemNorm = qs.getItemNormalization();
		if (!itemNorm) {
			return;
		}
		var grps = itemNorm.basicGetItemNormalizationGroup();
		if (!grps || grps.length==0) {
			return;
		}
		var grpToDelete;
		for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			var attrs = g.basicGetAttribute();
			var k = g.getKey();
			if (attrs && !(attrs.length==0)) {
				var sz = attrs.length;
				for (var __i_enFor1 = 0, __exp_enFor1 = attrs, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var a = __exp_enFor1[__i_enFor1];
					if (qiId == a.getItemRef()) {
						if (sz == 1 && !k) {
							grpToDelete = g;
							break;
						}
						g.removeAttribute(a);
						return;
					}
				}
			}
			if (grpToDelete) {
				break;
			}
			if (!k) {
				continue;
			}
			if (qiId == k.getItemRef()) {
				grpToDelete = g;
				break;
			}
		}
		if (grpToDelete) {
			var gpId = grpToDelete.getIdentifier();
			var paranetGrps = grpToDelete.basicGetParentGroupRef();
			itemNorm.removeItemNormalizationGroup(grpToDelete);
			for (var __i_enFor2 = 0, __exp_enFor2 = grps, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var otherGrp = __exp_enFor2[__i_enFor2];
				var otherParanetGrps = otherGrp.basicGetParentGroupRef();
				if (otherParanetGrps && !(otherParanetGrps.length==0) && otherParanetGrps.indexOf(gpId)> -1) {
					otherGrp.removeParentGroupRef(gpId);
					if (paranetGrps) {
						for (var __i_enFor3 = 0, __exp_enFor3 = paranetGrps, __len_enFor3 = __exp_enFor3.length;
								__i_enFor3 < __len_enFor3; ++__i_enFor3) {
							var sg = __exp_enFor3[__i_enFor3];
							if (!(otherParanetGrps.indexOf(sg)> -1)) {
								otherGrp.addParentGroupRef(sg);
							}
						}
					}
				}
			}
		}
		if (grps.length==0) {
			qs.setItemNormalization(null);
		}
	}

	static _updateDuplicateShortcutItemNorm(qs, qiId) {
		if (!(ShortcutUtils.isShortcutOrAliasValid(qs))) {
			return;
		}
		var itemNorm = qs.getItemNormalization();
		if (!itemNorm) {
			return;
		}
		var grps = itemNorm.basicGetItemNormalizationGroup();
		if (!grps || grps.length==0) {
			return;
		}
		var parentModule = ModuleUtils._getModule(qs);
		if (!parentModule || !parentModule.getObjectFactory()) {
			return;
		}
		var bUndoable = true;
		PropertySetter.refreshShortcutItemNorm(qs, bUndoable);
	}

	static _collectQIIdsInItem(itm, qiIds, qiIdForExpressions) {
		var qi = itm.getQueryItem();
		if (qi) {
			var id = qi.getIdentifier();
			var qiIdForExpression = qi.getIdForExpression();
			if (id != null && qiIdForExpression != null) {
				qiIds.push(id);
				qiIdForExpressions.push(qiIdForExpression);
			}
			var childItems = qi.basicGetItem();
			if (childItems && !(childItems.length==0)) {
				for (var __i_enFor0 = 0, __exp_enFor0 = childItems, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var childItem = __exp_enFor0[__i_enFor0];
					ModuleUtils._collectQIIdsInItem(childItem, qiIds, qiIdForExpressions);
				}
			}
		} else {
			var fld = itm.getFolder();
			if (fld) {
				ModuleUtils._collectQIIdsInFolder(fld, qiIds, qiIdForExpressions);
			}
		}
	}

	static _collectQIIdsInFolder(theFolder, qiIds, qiIdForExpressions) {
		var items = theFolder.basicGetItem();
		if (!items || items.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			ModuleUtils._collectQIIdsInItem(itm, qiIds, qiIdForExpressions);
		}
	}

	static _checkFolderType(obj) {
		var parent = obj.getParent();
		var parentTp = parent.getObjectType();
		if (!("Module" == parentTp) && !("FolderItemType" == parentTp)) {
			return false;
		}
		if ("Module" == parentTp) {
			return true;
		}
		var folderItem = parent;
		var parentParentTp = ModuleUtils._getParentObjectType(folderItem);
		return "FolderType" == parentParentTp;
	}

	static _collectIdsInFolderType(obj, ids) {
		var bFM = false;
		if (!obj) {
			return bFM;
		}
		var folderItems = obj.basicGetFolderItem();
		if (!folderItems) {
			return bFM;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderItem = __exp_enFor0[__i_enFor0];
			var ref = folderItem.getRef();
			if (ref == null) {
				var defLnk = folderItem.getDefLink();
				if (defLnk) {
					bFM = true;
					ref = defLnk.getRef();
				}
			}
			if (ref != null) {
				ids.push(ref);
			}
			bFM = ModuleUtils._collectIdsInFolderType(folderItem.getFolder(), ids) || bFM;
		}
		return bFM;
	}

	static _removeObjectsInMDTVFolderType(obj) {
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return;
		}
		var ids = [];
		var bFM = ModuleUtils._collectIdsInFolderType(obj, ids);
		if (ids.length==0) {
			return;
		}
		var idToQS = {};
		var idToCalc = {};
		var idToFilter = {};
		var qss = module.basicGetQuerySubject();
		if (qss) {
			for (var __i_enFor0 = 0, __exp_enFor0 = qss, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qs = __exp_enFor0[__i_enFor0];
				idToQS[qs.getIdentifier()] = qs;
			}
		}
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor1 = 0, __exp_enFor1 = calcs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var c = __exp_enFor1[__i_enFor1];
				idToCalc[c.getIdentifier()] = c;
			}
		}
		var filters = module.basicGetFilter();
		if (filters) {
			for (var __i_enFor2 = 0, __exp_enFor2 = filters, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var f = __exp_enFor2[__i_enFor2];
				idToFilter[f.getIdentifier()] = f;
			}
		}
		var seen = {};
		for (var __i_enFor3 = 0, __exp_enFor3 = ids, __len_enFor3 = __exp_enFor3.length;
				__i_enFor3 < __len_enFor3; ++__i_enFor3) {
			var id = __exp_enFor3[__i_enFor3];
			if (seen.hasOwnProperty(id)) {
				continue;
			}
			seen[id] = 1;
			var q = idToQS[id];
			if (q) {
				if (!bFM) {
					ModuleUtils._deleteQuerySubjectRelatedObjects(module, q, id);
				}
				module.removeQuerySubject(q);
				continue;
			}
			var c = idToCalc[id];
			if (c) {
				module.removeCalculation(c);
				continue;
			}
			var f = idToFilter[id];
			if (f) {
				module.removeFilter(f);
			}
		}
	}

	static _removeFolderTypeFromMDTV(obj, bClean) {
		if (!(ModuleUtils._checkFolderType(obj))) {
			return null;
		}
		var parent = obj.getParent();
		var parentTp = parent.getObjectType();
		if (!bClean) {
			if ("FolderItemType" == parentTp) {
				return parent;
			}
			return null;
		}
		ModuleUtils._removeObjectsInMDTVFolderType(obj);
		if ("Module" == parentTp) {
			(parent).removeMetadataTreeView(obj);
			return obj;
		}
		var folderItem = parent;
		(folderItem.getParent()).removeFolderItem(folderItem);
		return obj;
	}

	/**
	 * Removes and returns the removed translation object from the module. Returns null if object was not successfully removed.
	 * @param {Translation} obj
	 */
	static _removeTranslationFromModule(obj) {
		var parent = obj.getParent();
		if (!parent) {
			return null;
		}
		var parentTp = parent.getObjectType();
		if ("Module" == parentTp) {
			(parent).removeTranslation(obj);
			return obj;
		}
		return null;
	}

	/**
	 * Removes and returns the removed relationship object from its parent: module or JoinOperation in QuerySubject. Returns null if object was not successfully removed.
	 * @param {Relationship} obj
	 */
	static _removeRelationship(obj) {
		var parent = obj.getParent();
		if (!parent) {
			return null;
		}
		var parentTp = parent.getObjectType();
		if ("Module" == parentTp) {
			(parent).removeRelationship(obj);
			return obj;
		}
		if ("JoinOperation" == parentTp) {
			(parent).removeRelationship(obj);
			return obj;
		}
		return null;
	}

	static _removeObjectFromModule(obj, bClean) {
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return null;
		}
		var objectTp = obj.getObjectType();
		if ("QuerySubject" == objectTp) {
			return ModuleUtils._deleteQuerySubjectImp(module, obj, bClean);
		}
		var mdtvs = MoserObjectUtils.getList(module.basicGetMetadataTreeView());
		if ("Calculation" == objectTp) {
			var calc = obj;
			for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folder = __exp_enFor0[__i_enFor0];
				var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(calc.getIdentifier(), folder, bClean);
				if (!bClean && r) {
					return r;
				}
			}
			module.removeCalculation(calc);
			return obj;
		} else if ("Filter" == objectTp) {
			var filter = obj;
			for (var __i_enFor1 = 0, __exp_enFor1 = mdtvs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var folder = __exp_enFor1[__i_enFor1];
				var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(filter.getIdentifier(), folder, bClean);
				if (!bClean && r) {
					return r;
				}
			}
			module.removeFilter(filter);
			return obj;
		} else {
			return null;
		}
	}

	/**
	 * Move a moser object in a parent object using an indexed position. The moser object to move can be one of the following types: QuerySubject, QueryItem, SecurityFilter, Folder, Filter, Calculation, FolderType. If the move is not valid, or the moser object move is unsuccessful, null is returned.
	 * @param {MoserObject} obj        : the moser object to move
	 * @param {MoserObject} parentObj  : the parent moser object
	 * @param {int} index      : where to insert the obj into the parentObj
	 * @return {MoserObject}  the moved MoserObject or null if move failed
	 */
	static move$0(obj, parentObj, index) {
		var removed = ModuleUtils._removeImp(obj, false);
		if (!removed) {
			return null;
		}
		var p1 = ModuleUtils._getParentContainer(parentObj);
		var p2 = ModuleUtils._getParentContainer(removed);
		if (!p1 || !p2 || !(p1 === p2)) {
			return null;
		}
		var oldParentObj = [null];
		var oldIdx = ModuleUtils._detachFromParent(removed, oldParentObj);
		if (oldIdx == -1) {
			return null;
		}
		ModuleUtils._insertToParent(removed, parentObj, index, oldParentObj[0], oldIdx);
		ModuleUtils._updateShortcutRefsMove(obj, parentObj, index);
		return obj;
	}

	/**
	 * Move a list of moser object in a parent object using an indexed position. The moser objects to move can be one of the following types: QuerySubject, QueryItem, SecurityFilter, Folder, Filter, Calculation, FolderType.
	 * @param  obj        : list of moser object to move
	 * @param {MoserObject} parentObj  : the parent moser object
	 * @param {int} index      : where to insert the objs into the parentObj
	 * @return {Array}  the list of moved MoserObjects
	 */
	static move$1(objs, parentObj, index) {
		var movedObjs = [];
		if (!objs) {
			return movedObjs;
		}
		var currentIndex = index;
		for (var __i_enFor0 = 0, __exp_enFor0 = objs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var movedObj = ModuleUtils.move$0(obj, parentObj, currentIndex);
			if (movedObj) {
				movedObjs.push(movedObj);
				currentIndex++;
			}
		}
		return movedObjs;
	}

	/**
	 * Returns true if the object is moveble in the parent object at a given index.
	 * @param {MoserObject} obj              the moser object to move
	 * @param  parentObject     the parent moser object
	 * @param {int} index            where to insert the obj into the parentObj.
	 */
	static isMoveable$0(obj, parentObj, index) {
		if (!(ModuleUtils._checkRelocateModuleConditions(obj, parentObj))) {
			return false;
		}
		if (!(ModuleUtils._checkRelocateContainerConditions(obj, parentObj, false))) {
			return false;
		}
		return ModuleUtils._checkRelocateItemConditions(obj, parentObj);
	}

	/**
	 * Returns true if the object is moveble in the parent object at a given index.
	 * @param {Array} objs              list of moser object to move
	 * @param  parentObject     the parent moser object
	 * @param {int} index            where to insert the obj into the parentObj.
	 */
	static isMoveable$1(objs, parentObj, index) {
		if (!objs || objs.length==0) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = objs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var isMoveable = ModuleUtils.isMoveable$0(obj, parentObj, index);
			if (!isMoveable) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Returns true if the object is pastable in the parent object at a given index.
	 * @param {MoserObject} obj              the moser object to be pasted
	 * @param  parentObject     the parent moser object
	 * @param  index            where to insert the obj into the parentObj.
	 */
	static isPastable$0(obj, parentObj) {
		if (!(ModuleUtils._checkRelocateModuleConditions(obj, parentObj))) {
			return false;
		}
		if (!(ModuleUtils._checkRelocateContainerConditions(obj, parentObj, true))) {
			return false;
		}
		return ModuleUtils._checkRelocateItemConditions(obj, parentObj);
	}

	/**
	 * Returns true if the object is pastable in the parent object at a given index.
	 * @param {Array} objs             list of moser object to be pasted
	 * @param  parentObject     the parent moser object
	 * @param  index            where to insert the obj into the parentObj.
	 */
	static isPastable$1(objs, parentObj) {
		if (!objs || objs.length==0) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = objs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var isPastable = ModuleUtils.isPastable$0(obj, parentObj);
			if (!isPastable) {
				return false;
			}
		}
		return true;
	}

	static _checkRelocateModuleConditions(obj, parentObj) {
		if (!obj || !parentObj || obj == parentObj) {
			return false;
		}
		var objModule = MoserObject.getModuleObject(obj);
		var parentObjModule = MoserObject.getModuleObject(parentObj);
		if (!objModule || !parentObjModule) {
			return false;
		}
		if (!(objModule === parentObjModule)) {
			return false;
		}
		if (ModuleUtils._isObjectReadOnly(parentObj)) {
			return false;
		}
		return true;
	}

	static _checkRelocateItemConditions(obj, parentObj) {
		var qs = ModuleUtils._getParentQuerySubject(obj);
		if (qs && obj != qs) {
			return !(ModuleUtils._isObjectReadOnly(obj));
		}
		var objType = obj.getObjectType();
		var parentObjType = parentObj.getObjectType();
		var isGlobalItemType = "Filter" == objType || "Calculation" == objType || "FolderType" == objType;
		var isQS = "QuerySubject" == objType;
		var isGlobalItem = !qs && isGlobalItemType;
		var isGlobalObject = isGlobalItem || isQS;
		return isGlobalObject && "FolderType" == parentObjType || "Module" == parentObjType;
	}

	static _checkRelocateContainerConditions(obj, parentObj, toCopiedQS) {
		var p1 = ModuleUtils._getParentContainer(parentObj);
		var p2;
		if ("QuerySubject" == obj.getObjectType() || "ItemType" == ModuleUtils._getParentObjectType(obj)) {
			p2 = ModuleUtils._getParentContainer(obj.getParent());
		} else {
			p2 = ModuleUtils._getParentContainer(obj);
		}
		if (!p1 || !p2) {
			return false;
		}
		if (!toCopiedQS && !(p1 === p2)) {
			return false;
		}
		if (toCopiedQS && !(p1 === p2)) {
			if (!("QuerySubject" == p1.getObjectType()) || !("QuerySubject" == p2.getObjectType())) {
				return false;
			}
			var p1Refs = (p1).getRef();
			var p2Refs = (p2).getRef();
			if (p1Refs.length==0 || p2Refs.length==0) {
				return false;
			}
			if (p1Refs.length > 1 || p2Refs.length > 1) {
				return false;
			}
			if (!(p1Refs[0] == p2Refs[0])) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Returns the long identifier of a moser object. Returns null if moser object does not have a long identifier. Expects moser object is part of a module.
	 * @param {MoserObject} obj   MoserObject
	 */
	static getLongIdentifier(obj) {
		return MoserObjectUtils.getLongIdentifier(obj);
	}

	/**
	 * Add a copy of obj to all shortcuts and aliases that directly reference the query subject of obj.
	 * @param {MoserObject} obj              obj that was added.
	 * @param {MoserObject} parentObject     parent obj was added to.
	 * @param {int} index            index to add obj.
	 * @param {ObjectFactory} objectFactory
	 * @param {boolean} bEmbeddedFilter  is obj an embedded filter.
	 */
	static _updateShortcutRefsAdd(obj, parentObject, index, objectFactory, bEmbeddedFilter) {
		if (bEmbeddedFilter) {
			return;
		}
		if (!(ModuleUtils._canUpdateItemInShortcuts(obj))) {
			return;
		}
		if (!ModuleUtils._getParentQuerySubject(parentObject)) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getShortcutReferences(obj), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var reference = __exp_enFor0[__i_enFor0];
			try {
				var newObj = obj.clone();
				newObj.setEditMode(EditModeType.RO);
				newObj.setIdForExpression(null);
				var parentObjFromRef = ModuleUtils._getObjectInQuerySubject(parentObject, reference);
				if (parentObjFromRef) {
					newObj.getPropertyOverride().length = 0;
					ModuleUtils.add(newObj, parentObjFromRef, index, objectFactory, bEmbeddedFilter);
				}
			} catch (e) {
				throw e;
			}

		}
	}

	/**
	 * Inserts QI from source into an existing query subject in module.
	 * @param {QueryItem} qi                  inserted query item.
	 * @param {QuerySubject} existingQS          query subject qi was inserted to.
	 * @param {QuerySubject} srcQs               source qs existingQS came from.
	 * @param {Map} qiMap 				 maps qi identifier to qi object.
	 * @param {boolean} asReference         inserted as a reference.
	 * @param {int} insertAtIndex       index qi inserted.
	 * @param {ObjectFactory} objectFactory       object factory
	 * @param {Map} qsNewlyInsertQIMap  maps inserted qs to the source qs.
	 * @param {Array} qsNewlyInsertQILst  list of qs the qi has been inserted to.
	 */
	static _insertQIForExistingQS(qi, existingQS, srcQs, qiMap, asReference, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst) {
		var idForExprPrefix = existingQS.getIdentifier() + ".";
		if (!qiMap[qi.getIdentifier()] || ShortcutUtils.isShortcutOrAliasValid(existingQS)) {
			var newQI = qi.clone();
			newQI.getPropertyOverride().length = 0;
			newQI.setEditMode(asReference ? EditModeType.RO : null);
			newQI.setExpression(newQI.getIdentifier());
			newQI.setIdForExpression(idForExprPrefix + newQI.getIdentifier());
			var newItem = objectFactory.createItemType();
			newItem.setQueryItem(newQI);
			existingQS.addItemAt(insertAtIndex, newItem);
			if (!asReference) {
				ModuleUtils.registerNewQueryItem(existingQS, qsNewlyInsertQIMap, qsNewlyInsertQILst, srcQs);
			}
			ModuleUtils._updateShortcutRefsInsert(newQI, existingQS, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
			return newQI;
		}
		return null;
	}

	/**
	 * Query Item has been inserted to a query subject. Find all references and insert the qi to each reference.
	 * @param {QueryItem} qi                  inserted query item.
	 * @param {QuerySubject} existingQS          query subject qi was inserted to.
	 * @param {int} insertAtIndex       index qi inserted.
	 * @param {ObjectFactory} objectFactory       object factory
	 * @param {Map} qsNewlyInsertQIMap  maps inserted qs to the source qs.
	 * @param {Array} qsNewlyInsertQILst  list of qs the qi has been inserted to.
	 */
	static _updateShortcutRefsInsert(qi, existingQS, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst) {
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getShortcutReferences(qi), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var reference = __exp_enFor0[__i_enFor0];
			var refQIMap = ModuleUtils._createQIMap(reference);
			ModuleUtils._insertQIForExistingQS(qi, reference, existingQS, refQIMap, true, insertAtIndex, objectFactory, qsNewlyInsertQIMap, qsNewlyInsertQILst);
		}
	}

	/**
	 * Remove reference obj from all shortcuts and aliases that directly reference the query subject of obj.
	 * @param {MoserObject} obj     obj to remove in shortcuts/aliases.
	 * @param {boolean} bClean  clean removal.
	 * @param {QuerySubject} qs      qs of obj before obj was removed.
	 */
	static _updateShortcutRefsRemove(obj, bClean, qs) {
		if (!(ModuleUtils._canUpdateItemInShortcuts(obj))) {
			return;
		}
		var objType = obj;
		var identifier = objType.getIdentifier();
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getShortcutReferences(qs), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var refQS = __exp_enFor0[__i_enFor0];
			var objsFromRef = MoserObjectUtils.getObjectTypesById(refQS, identifier);
			for (var __i_enFor1 = 0, __exp_enFor1 = objsFromRef, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var objFromRef = __exp_enFor1[__i_enFor1];
				if (ModuleUtils._isObjectReadOnly(objFromRef)) {
					ModuleUtils._removeImp(objFromRef, bClean);
					break;
				}
			}
		}
	}

	/**
	 * Move reference obj from all shortcuts and aliases that directly reference the query subject of obj.
	 * @param {MoserObject} obj              obj to remove in shortcuts/aliases.
	 * @param  bClean     	  clean removal.
	 * @param  qs               qs of obj before obj was removed.
	 */
	static _updateShortcutRefsMove(obj, parentObject, index) {
		if (!(ModuleUtils._canUpdateItemInShortcuts(obj))) {
			return;
		}
		if (!ModuleUtils._getParentQuerySubject(parentObject)) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getShortcutReferences(obj), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var reference = __exp_enFor0[__i_enFor0];
			var objsFromRef = MoserObjectUtils.getObjectTypesById(reference, (obj).getIdentifier());
			for (var __i_enFor1 = 0, __exp_enFor1 = objsFromRef, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var objFromRef = __exp_enFor1[__i_enFor1];
				if (ModuleUtils._isObjectReadOnly(objFromRef)) {
					var parentObjFromRef = ModuleUtils._getObjectInQuerySubject(parentObject, reference);
					if (parentObjFromRef) {
						ModuleUtils.move(objFromRef, parentObjFromRef, index);
						objFromRef.getPropertyOverride().length = 0;
						break;
					}
				}
			}
		}
	}

	/**
	 * Returns a query subject or folder obj from given query subject. Returns qs if parentObject is a query subject. Otherwise iterates over folder items in qs and matches identifier. Used to update shortcuts and aliases after add/remove/move operations.
	 * @param {MoserObject} obj
	 * @param {QuerySubject} qs
	 */
	static _getObjectInQuerySubject(obj, qs) {
		if ("QuerySubject" == obj.getObjectType()) {
			return qs;
		}
		var objType = obj.getObjectType();
		if ("Folder" == objType || "QueryItem" == objType) {
			var parentIdentifier = (obj).getIdentifier();
			var objsFromRef = MoserObjectUtils.getObjectTypesById(qs, parentIdentifier);
			for (var __i_enFor0 = 0, __exp_enFor0 = objsFromRef, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var objFromRef = __exp_enFor0[__i_enFor0];
				if (objType == objFromRef.getObjectType()) {
					return objFromRef;
				}
			}
		}
		return null;
	}

	/**
	 * Returns true if the moser object is a query item, folder, filter, and calculation.
	 * @param {MoserObject} obj
	 */
	static _canUpdateItemInShortcuts(obj) {
		var objTp = obj.getObjectType();
		return obj instanceof ObjectType && ("QueryItem" == objTp || "Folder" == objTp || "Filter" == objTp);
	}

	static _getParentContainer(obj) {
		if (!obj) {
			return null;
		}
		var objType = obj.getObjectType();
		if ("QueryItem" == objType || "QuerySubject" == objType || "Module" == objType) {
			return obj;
		}
		return ModuleUtils._getParentContainer(obj.getParent());
	}

	static _detachFromParent(removed, oldParent) {
		var parent = removed.getParent();
		var parentObjType = parent.getObjectType();
		var objType = removed.getObjectType();
		var oldIdx;
		if ("QuerySubject" == parentObjType) {
			var qs = parent;
			if ("ItemType" == objType) {
				oldIdx = qs.getItem().indexOf(removed);
				if (oldIdx >= 0) {
					qs.removeItemAt(oldIdx);
					oldParent[0] = qs;
				}
			} else if ("Filter" == objType) {
				oldIdx = qs.getFilter().indexOf(removed);
				if (oldIdx >= 0) {
					qs.removeFilterAt(oldIdx);
					oldParent[0] = qs;
				}
			} else if ("SecurityFilter" == objType) {
				oldIdx = qs.getSecurityFilter().indexOf(removed);
				if (oldIdx >= 0) {
					qs.removeSecurityFilterAt(oldIdx);
					oldParent[0] = qs;
				}
			} else {
				return -1;
			}
		} else if ("Folder" == parentObjType) {
			if ("ItemType" == objType) {
				oldIdx = (parent).getItem().indexOf(removed);
				if (oldIdx >= 0) {
					(parent).removeItemAt(oldIdx);
					oldParent[0] = parent;
				}
			} else {
				return -1;
			}
		} else if ("QueryItem" == parentObjType) {
			if ("ItemType" == objType) {
				oldIdx = (parent).getItem().indexOf(removed);
				if (oldIdx >= 0) {
					(parent).removeItemAt(oldIdx);
					oldParent[0] = parent;
				}
			} else {
				return -1;
			}
		} else if ("FolderType" == parentObjType) {
			if ("FolderItemType" == objType) {
				oldIdx = (parent).getFolderItem().indexOf(removed);
				if (oldIdx >= 0) {
					(parent).removeFolderItemAt(oldIdx);
					oldParent[0] = parent;
				}
			} else {
				return -1;
			}
		} else {
			return -1;
		}
		removed.setParent(null);
		return oldIdx;
	}

	static _adjustIndex(i, parent, oldIdx, oldParent) {
		var index = i;
		if (oldParent && parent && parent === oldParent && index > oldIdx) {
			index--;
		}
		return index;
	}

	static _insertToParent(removed, parentObj, index, oldParent, oldIdx) {
		var objType = removed.getObjectType();
		if ("FolderItemType" == objType) {
			var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
			if (!parentFolderType) {
				return;
			}
			var idx = ModuleUtils._adjustIndex(index, parentFolderType, oldIdx, oldParent);
			if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), idx)) {
				parentFolderType.addFolderItem(removed);
			} else {
				parentFolderType.addFolderItemAt(idx, removed);
			}
		} else if ("ItemType" == objType) {
			var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
			ModuleUtils._addItemToParent(removed, parentObj, idx);
		} else if ("Filter" == objType) {
			var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
			if (ModuleUtils._invalidIndex((parentObj).basicGetFilter(), idx)) {
				(parentObj).addFilter(removed);
			} else {
				(parentObj).addFilterAt(idx, removed);
			}
		} else if ("SecurityFilter" == objType) {
			var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
			if (ModuleUtils._invalidIndex((parentObj).basicGetSecurityFilter(), idx)) {
				(parentObj).addSecurityFilter(removed);
			} else {
				(parentObj).addSecurityFilterAt(idx, removed);
			}
		}
	}

	static getExtractIdentifiersSpec(obj, value) {
		return PropertySetter.getExtractIdentifiersSpec(obj, value);
	}

	static setIdentifier(obj, value, response) {
		var idforExprToNewExpr;
		if (response) {
			var feedBack = response["feedback"];
			if (feedBack && !(feedBack.length==0)) {
				idforExprToNewExpr = {};
				for (var __i_enFor0 = 0, __exp_enFor0 = feedBack, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var f = __exp_enFor0[__i_enFor0];
					var jobj = f;
					idforExprToNewExpr[jobj["idForExpression"]] = jobj["expression"];
				}
			}
		}
		PropertySetter.setIdentifier(obj, value, idforExprToNewExpr);
	}

	/**
	 * Returns a boolean that says, is the MoserObject visible or hidden. Any object with an ancestor (folder/query subject) marked as hidden, should be returned as hidden
	 * @param {ObjectType} object - object in a module
	 * @param {Module} module - module owning the object
	 * @return {boolean}
	 */
	static isVisible(object, module) {
		var hidden = object.isHidden() == null ? false : object.isHidden(), visible = !hidden;
		if (hidden) {
			return visible;
		}
		var parent = ModuleUtils.getTreeAncestor(object, null, module);
		if (parent) {
			return visible && ModuleUtils.isVisible(parent, module);
		}
		return visible;
	}

	/**
	 * find the ancestor in the tree.
	 * @param {MoserObject} obj
	 * @param {String[]} anestorType
	 * @param {Module} module  TODO
	 * @return {MoserObject}
	 */
	static getTreeAncestor(obj, anestorType, module) {
		var objTp = obj.getObjectType();
		if (!(ModuleUtils._isMDTVObjectType(objTp, false))) {
			return null;
		}
		if (!module) {
			module = MoserObject.getModuleObject(obj);
		}
		var ancestorSet;
		if (anestorType && anestorType.length > 0) {
			ancestorSet = {};
			for (var __i_enFor0 = 0, __len_enFor0 = anestorType.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var element = anestorType[__i_enFor0];
				ancestorSet[element] = 1;
			}
		}
		if ("QuerySubject" == objTp || "Calculation" == objTp) {
			var folderItemType = ModuleUtils._getFolderItemType(module, (obj).getIdentifier());
			if (!folderItemType) {
				if ("Calculation" == objTp) {
					return obj.getParent() && obj.getParent().getParent() ? obj.getParent().getParent() : null;
				}
				return null;
			}
			return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
		}
		if ("FolderType" == objTp) {
			return ModuleUtils._getTreeAncestorMDTV(module, obj.getParent(), ancestorSet);
		}
		if ("Filter" == objTp || "NamedSet" == objTp) {
			var qs = ModuleUtils._getParentQuerySubject(obj);
			if (!qs) {
				var folderItemType = ModuleUtils._getFolderItemType(module, (obj).getIdentifier());
				if (!folderItemType) {
					return null;
				}
				return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
			}
			return ModuleUtils._getTreeAncestorQuerySubject(module, obj.getParent(), ancestorSet);
		}
		return ModuleUtils._getTreeAncestorQuerySubject(module, obj.getParent(), ancestorSet);
	}

	static _isMDTVObjectType(objectType, incModule) {
		if ("QueryItem" == objectType || "Folder" == objectType || "Filter" == objectType || "QuerySubject" == objectType || "Calculation" == objectType || "FolderType" == objectType || "NamedSet" == objectType || "MemberType" == objectType) {
			return true;
		}
		return incModule && "Module" == objectType;
	}

	static _isPackage(obj) {
		var packageTypes = [];
		packageTypes.push(UseSpecType.PACKAGE);
		packageTypes.push(UseSpecType.LW_OLAP);
		return ModuleUtils._isPackageCheck(obj, packageTypes);
	}

	static _isPackageCheck(obj, packageTypes) {
		if (!obj) {
			return false;
		}
		if (!("Module" == obj.getObjectType()) && !("FolderType" == obj.getObjectType())) {
			return false;
		}
		var parentModule = QuerySubjectUtils.getParentModule(obj);
		if (!parentModule) {
			return false;
		}
		if ("Module" == obj.getObjectType()) {
			return parentModule.getContainer() == "FM_Package";
		}
		var parentModuleUseSpecs = parentModule.getUseSpec();
		if (!parentModuleUseSpecs) {
			return false;
		}
		var id = (obj).getIdentifier();
		var targetUseSpec;
		for (var __i_enFor0 = 0, __exp_enFor0 = parentModuleUseSpecs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var useSpec = __exp_enFor0[__i_enFor0];
			if (useSpec.getIdentifier() == id) {
				targetUseSpec = useSpec;
				break;
			}
		}
		if (!targetUseSpec) {
			return false;
		}
		return packageTypes.indexOf(targetUseSpec.getType())> -1;
	}

	/**
	 * Returns true if the object is an external reference.
	 * @param {MoserObject} obj   MoserObject
	 */
	static isExternalReference(obj) {
		if (obj instanceof ObjectType) {
			var useSpec = DataModuleExtractor.getUseSpecByObjectType(obj);
			return useSpec && (UseSpecType.MODULE == useSpec.getType() || UseSpecType.PACKAGE == useSpec.getType());
		}
		return false;
	}

	static canBeTranslated(mo, featureId, bIncludeExternal) {
		if (157 != featureId && 159 != featureId && 126 != featureId) {
			return false;
		}
		if (mo instanceof ObjectType) {
			if (bIncludeExternal) {
				return true;
			}
			var qs = ModuleUtils._getParentQuerySubject(mo);
			if (qs && ShortcutUtils.isShortcutOrAlias(qs, true)) {
				if (qs == mo) {
					var propOverrides = MoserObjectUtils.getList(qs.basicGetPropertyOverride());
					var featureName = qs.getFeatureName(featureId);
					return propOverrides.indexOf(featureName)> -1;
				}
				var objType = mo;
				var propOverrides = MoserObjectUtils.getList(objType.basicGetPropertyOverride());
				if (propOverrides.indexOf("NEW")> -1) {
					return true;
				}
				if ("QueryItem" == objType.getObjectType() || "Filter" == objType.getObjectType()) {
					var parent = objType.getParent();
					if (parent) {
						parent = parent.getParent();
					}
					if (parent && "QueryItem" == parent.getObjectType()) {
						var parentQI = parent;
						propOverrides = MoserObjectUtils.getList(parentQI.basicGetPropertyOverride());
						return propOverrides.indexOf("NEW")> -1;
					}
				}
				return false;
			}
			return !(ModuleUtils.isExternalReference(mo));
		}
		return false;
	}

	static _getTreeAncestorQuerySubject(module, parentObj, ancestorSet) {
		if (!parentObj) {
			return null;
		}
		var objType = parentObj.getObjectType();
		if ("QuerySubject" == objType) {
			if (!ancestorSet || ancestorSet.hasOwnProperty(objType)) {
				return parentObj;
			}
			var folderItemType = ModuleUtils._getFolderItemType(module, (parentObj).getIdentifier());
			if (!folderItemType) {
				return null;
			}
			return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
		}
		if (ModuleUtils._isMDTVObjectType(objType, false) && (!ancestorSet || ancestorSet.hasOwnProperty(objType))) {
			return parentObj;
		}
		return ModuleUtils._getTreeAncestorQuerySubject(module, parentObj.getParent(), ancestorSet);
	}

	static _getTreeAncestorMDTV(module, parent, ancestorSet) {
		if (!parent) {
			return null;
		}
		var objType = parent.getObjectType();
		if (ModuleUtils._isMDTVObjectType(objType, true) && (!ancestorSet || ancestorSet.hasOwnProperty(objType))) {
			if (parent.getParent() == module) {
				return module;
			}
			return parent;
		}
		return ModuleUtils._getTreeAncestorMDTV(module, parent.getParent(), ancestorSet);
	}

	static _getFolderItemType(module, id) {
		if (!module) {
			return null;
		}
		var mdtvs = MoserObjectUtils.getList(module.basicGetMetadataTreeView());
		for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folder = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._getFolderItemTypeInMDTVFolder(id, folder);
			if (r) {
				return r;
			}
		}
		return null;
	}

	static _getFolderItemTypeInMDTVFolder(id, folder) {
		if (!folder) {
			return null;
		}
		var itemList = MoserObjectUtils.getList(folder.basicGetFolderItem());
		for (var j = itemList.length - 1; j >= 0; --j) {
			var r = itemList[j];
			if (id == r.getRef() || r.getDefLink() && id == r.getDefLink().getRef()) {
				return r;
			}
			r = ModuleUtils._getFolderItemTypeInMDTVFolder(id, r.getFolder());
			if (r) {
				return r;
			}
		}
		return null;
	}

	static findTreeObjectByIdForExpression(idForExpression, treeObject, forceMDTVSearch) {
		if (idForExpression == null || idForExpression.length === 0 || !treeObject) {
			return null;
		}
		if (!forceMDTVSearch) {
			return ModuleUtils._findObjectByIdforExprInObject(treeObject, idForExpression);
		}
		var module = MoserObject.getModuleObject(treeObject);
		if (!module) {
			return null;
		}
		var mdtvs = MoserObjectUtils.getList(module.basicGetMetadataTreeView());
		for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folder = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
			if (r) {
				return r;
			}
		}
		return null;
	}

	static _findObjectByIdforExprInObject(obj, idForExpression) {
		if (!obj) {
			return null;
		}
		var objType = obj.getObjectType();
		if ("FolderType" == objType) {
			return ModuleUtils._findObjectByIdforExprInFolderType(obj, idForExpression);
		}
		if ("FolderItemType" == objType) {
			return ModuleUtils._findObjectByIdforExprInFolderItemType(obj, idForExpression);
		}
		if ("QuerySubject" == objType) {
			return ModuleUtils._findObjectByIdforExprInQuerySubject(obj, idForExpression);
		}
		if ("ItemType" == objType) {
			return ModuleUtils._findObjectByIdforExprInItemType(obj, idForExpression);
		}
		if ("QueryItem" == objType) {
			return ModuleUtils._findObjectByIdforExprInQueryItem(obj, idForExpression);
		}
		if ("Folder" == objType) {
			return ModuleUtils._findObjectByIdforExprInFolder(obj, idForExpression);
		}
		if ("Calculation" == objType || "Filter" == objType || "NamedSet" == objType) {
			var idforexpr = (obj).getIdForExpression();
			if (idForExpression == idforexpr) {
				return obj;
			}
			return null;
		}
		return null;
	}

	static _findObjectByIdforExprInFolderType(obj, idForExpression) {
		var items = MoserObjectUtils.getList(obj.basicGetFolderItem());
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
			if (r) {
				return r;
			}
		}
		return null;
	}

	static _findObjectByIdforExprInFolderItemType(obj, idForExpression) {
		var folder = obj.getFolder();
		if (folder) {
			return ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
		}
		var ref = obj.getRef();
		if (ref != null && !(ref.length === 0)) {
			return ModuleUtils._findObjectByIdforExprInObject(obj.getReferencedObject(), idForExpression);
		}
		var dlink = obj.getDefLink();
		if (dlink) {
			var rf = dlink.getRef();
			if (rf != null && !(rf.length === 0)) {
				return ModuleUtils._findObjectByIdforExprInObject(dlink.getReferencedObject(), idForExpression);
			}
		}
		return null;
	}

	static _findObjectByIdforExprInQuerySubject(obj, idForExpression) {
		var idforexpr = obj.getIdForExpression();
		if (idForExpression == idforexpr) {
			return obj;
		}
		var items = MoserObjectUtils.getList(obj.basicGetItem());
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
			if (r) {
				return r;
			}
		}
		return null;
	}

	static _findObjectByIdforExprInItemType(obj, idForExpression) {
		var queryItem = obj.getQueryItem();
		if (queryItem) {
			return ModuleUtils._findObjectByIdforExprInObject(queryItem, idForExpression);
		}
		var nameSet = obj.getNamedSet();
		if (nameSet) {
			return ModuleUtils._findObjectByIdforExprInObject(nameSet, idForExpression);
		}
		var filter = obj.getFilter();
		if (filter) {
			return ModuleUtils._findObjectByIdforExprInObject(filter, idForExpression);
		}
		var folder = obj.getFolder();
		if (folder) {
			return ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
		}
		return null;
	}

	static _findObjectByIdforExprInFolder(obj, idForExpression) {
		var items = MoserObjectUtils.getList(obj.basicGetItem());
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
			if (r) {
				return r;
			}
		}
		return null;
	}

	static _findObjectByIdforExprInQueryItem(obj, idForExpression) {
		var idforexpr = obj.getIdForExpression();
		if (idForExpression == idforexpr) {
			return obj;
		}
		var items = MoserObjectUtils.getList(obj.basicGetItem());
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
			if (r) {
				return r;
			}
		}
		return null;
	}

	/**
	 * objects excluding Objects from FM.
	 * @param {Array} selectedMoserObjects  a list of objects visible in the MDTV tree
	 * @param {boolean} bIncludeHidden           include hidden items and their children
	 * @return {Array}  non empty or null Given: mod -> folder1(hidden) -> qs -> folder2(hidden) -> qi user selects mod - and include - gets mod/folder1/qs/folder2/qi user selects folder1 - and exclude - gets folder1/qs user selects folder1 - and include - gets folder1/qs/folder2/qi user selects qs - and exclude - gets qs user selects qs - and include - gets qs/folder2/qi user selects folder2 - and exclude - gets folder2/qi user selects folder2 - and include - gets folder2/qi user selects qi - and exclude - gets qi user selects qi - and include - gets qi
	 */
	static getExportableTranslationsObjects(selectedMoserObjects, bIncludeHidden) {
		var bExclHidden = !bIncludeHidden;
		var rt = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = selectedMoserObjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var objTp = obj.getObjectType();
			if ("Segment" == objTp) {
				rt.push(obj);
				continue;
			}
			if ("DrillGroup" == objTp) {
				rt.push(obj);
				for (var __i_enFor1 = 0, __exp_enFor1 = (obj).getSegment(), __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var seg = __exp_enFor1[__i_enFor1];
					if (ModuleUtils._excludeHiddenObject(bExclHidden, seg)) {
						continue;
					}
					rt.push(seg);
				}
				continue;
			}
			if (!(ModuleUtils._isMDTVObjectType(objTp, true)) || ModuleUtils._excludeFMObjectAndMember(true, obj)) {
				continue;
			}
			var tmp = ModuleUtils._getTreeChildrenImp(obj, 0, null, true, bExclHidden);
			if (tmp) {
				Array.prototype.push.apply(rt, tmp);
			}
			if ("Module" == objTp) {
				for (var __i_enFor2 = 0, __exp_enFor2 = (obj).getDrillGroup(), __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var d = __exp_enFor2[__i_enFor2];
					if (ModuleUtils._excludeHiddenObject(bExclHidden, d)) {
						continue;
					}
					rt.push(d);
					for (var __i_enFor3 = 0, __exp_enFor3 = d.getSegment(), __len_enFor3 = __exp_enFor3.length;
							__i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var seg = __exp_enFor3[__i_enFor3];
						if (ModuleUtils._excludeHiddenObject(bExclHidden, seg)) {
							continue;
						}
						rt.push(seg);
					}
				}
			}
			rt.push(obj);
		}
		return rt;
	}

	/**
	 * @param {MoserObject} obj
	 * @param {int} depth
	 * @param {String[]} childrenType
	 * @return {Array}
	 */
	static getTreeChildren(obj, depth, childrenType) {
		return ModuleUtils._getTreeChildrenImp(obj, depth, childrenType, false, false);
	}

	static _getTreeChildrenImp(obj, depth, childrenType, bExclFMandMember, bExclHidden) {
		if (!obj || depth < 0) {
			return null;
		}
		var objTp = obj.getObjectType();
		if (!(ModuleUtils._isMDTVObjectType(objTp, true))) {
			return null;
		}
		var childrenSet;
		if (childrenType && childrenType.length > 0) {
			childrenSet = {};
			for (var __i_enFor0 = 0, __len_enFor0 = childrenType.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var element = childrenType[__i_enFor0];
				childrenSet[element] = 1;
			}
		}
		var rt = [];
		if ("Module" == objTp) {
			var mdtv = (obj).basicGetMetadataTreeView();
			if (!mdtv) {
				return rt;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = mdtv, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var folder = __exp_enFor1[__i_enFor1];
				ModuleUtils._getTreeChildrenObjects(folder, depth, 1, childrenSet, rt, bExclFMandMember, bExclHidden);
			}
			return rt;
		}
		ModuleUtils._getTreeChildrenObjects(obj, depth, 1, childrenSet, rt, bExclFMandMember, bExclHidden);
		return rt;
	}

	/**
	 * exclude FM object and member?
	 * @param {boolean} bExclFMandMember
	 * @param {MoserObject} obj
	 * @return {boolean}
	 */
	static _excludeFMObjectAndMember(bExclFMandMember, obj) {
		return bExclFMandMember && (CommonResolverUtil.isFMObject(obj) || "MemberType" == obj.getObjectType());
	}

	static _excludeHiddenObject(bExclHidden, obj) {
		return bExclHidden && obj instanceof ObjectType && (obj).isHidden() != null && (obj).isHidden();
	}

	static _getTreeChildrenObjects(parent, depth, d, childrenSet, rt, bExclFMandMember, bExclHidden) {
		if (depth != 0 && d > depth) {
			return;
		}
		var children = ModuleUtils._getVisibleChildren(parent);
		for (var __i_enFor0 = 0, __exp_enFor0 = children, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var c = __exp_enFor0[__i_enFor0];
			var cType = c.getObjectType();
			if (ModuleUtils._excludeFMObjectAndMember(bExclFMandMember, c) || ModuleUtils._excludeHiddenObject(bExclHidden, c)) {
				continue;
			}
			if (!childrenSet || childrenSet.hasOwnProperty(cType)) {
				rt.push(c);
			}
			ModuleUtils._getTreeChildrenObjects(c, depth, d + 1, childrenSet, rt, bExclFMandMember, bExclHidden);
		}
	}

	static _getVisibleChildren(parent) {
		var children = [];
		var parentType = parent.getObjectType();
		if ("FolderType" == parentType) {
			var itms = (parent).basicGetFolderItem();
			if (itms) {
				for (var __i_enFor0 = 0, __exp_enFor0 = itms, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var fldType = itm.getFolder();
					if (fldType) {
						children.push(fldType);
						continue;
					}
					var o = itm.getReferencedObject();
					if (o) {
						children.push(o);
						continue;
					}
					var dlink = itm.getDefLink();
					if (dlink) {
						var refobj = dlink.getReferencedObject();
						if (refobj) {
							children.push(refobj);
						}
					}
				}
			}
		} else if ("QueryItem" == parentType || "Folder" == parentType || "QuerySubject" == parentType) {
			var items = null;
			var members = null;
			if ("QueryItem" == parentType) {
				items = (parent).basicGetItem();
				members = (parent).basicGetMembers();
			} else if ("Folder" == parentType) {
				items = (parent).basicGetItem();
			} else {
				items = (parent).basicGetItem();
			}
			if (items) {
				for (var __i_enFor1 = 0, __exp_enFor1 = items, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var item = __exp_enFor1[__i_enFor1];
					var qi = item.getQueryItem();
					if (qi) {
						children.push(qi);
						continue;
					}
					var fld = item.getFolder();
					if (fld) {
						children.push(fld);
						continue;
					}
					var flt = item.getFilter();
					if (flt) {
						children.push(flt);
						continue;
					}
					var nmSet = item.getNamedSet();
					if (nmSet) {
						children.push(nmSet);
					}
				}
			}
			if (members) {
				Array.prototype.push.apply(children, members);
			}
		} else if ("MemberType" == parentType) {
			var members = (parent).basicGetMembers();
			if (members) {
				Array.prototype.push.apply(children, members);
			}
		}
		return children;
	}

	static copyModule(srcModule) {
		var clonedModule = srcModule.clone();
		ModuleUtils._resetRefObject(clonedModule);
		ReferenceResolver.resolve(clonedModule);
		return clonedModule;
	}

	static _resetRefObject(module) {
		if (!module) {
			return;
		}
		var overrideMode = module.isOverrideMode();
		module.setOverrideMode(false);
		ModuleUtils._resetItemHierarchyLocalRef(module);
		var mdtv = module.basicGetMetadataTreeView();
		if (mdtv) {
			for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folderType = __exp_enFor0[__i_enFor0];
				ModuleUtils._resetFolderTypeReferences(folderType);
			}
		}
		ModuleUtils._resetSegmentReferences(module);
		ModuleUtils._resetRelationships(module);
		ModuleUtils._resetFacetDef(module);
		module.setOverrideMode(overrideMode);
	}

	static _resetItemHierarchyLocalRef(module) {
		var querySubjectList = module.basicGetQuerySubject();
		if (!querySubjectList) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = querySubjectList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var querySubject = __exp_enFor0[__i_enFor0];
			var queryItemTypeList = querySubject.basicGetItem();
			if (!queryItemTypeList) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = queryItemTypeList, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var queryItemType = __exp_enFor1[__i_enFor1];
				var hierarchy = queryItemType.getItemHierarchy();
				if (!hierarchy) {
					continue;
				}
				var localRefList = hierarchy.basicGetLocalRef();
				if (!localRefList) {
					continue;
				}
				for (var __i_enFor2 = 0, __exp_enFor2 = localRefList, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var localRef = __exp_enFor2[__i_enFor2];
					var ref = localRef.getRef();
					if (ref != null) {
						localRef.setReferencedObject(null);
					}
				}
			}
		}
	}

	static _resetFolderTypeReferences(folderType) {
		var folderItemTypes = folderType.basicGetFolderItem();
		if (!folderItemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderItemType = __exp_enFor0[__i_enFor0];
			var ref = folderItemType.getRef();
			if (ref != null) {
				folderItemType.setReferencedObject(null);
			} else {
				var defLinkType = folderItemType.getDefLink();
				if (defLinkType) {
					defLinkType.setReferencedObject(null);
				}
			}
			var nestedFolder = folderItemType.getFolder();
			if (nestedFolder) {
				ModuleUtils._resetFolderTypeReferences(nestedFolder);
			}
		}
	}

	static _resetSegmentReferences(module) {
		var drillGroups = module.basicGetDrillGroup();
		if (!drillGroups) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var drillGroup = __exp_enFor0[__i_enFor0];
			var segments = drillGroup.basicGetSegment();
			if (!segments) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var segment = __exp_enFor1[__i_enFor1];
				segment.setReferencedObject(null);
			}
		}
	}

	static _resetRelationships(module) {
		var relationships = module.basicGetRelationship();
		if (!relationships) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var relationship = __exp_enFor0[__i_enFor0];
			var leftcard = relationship.getLeft();
			if (leftcard) {
				leftcard.setReferencedObject(null);
			}
			var rightcard = relationship.getRight();
			if (rightcard) {
				rightcard.setReferencedObject(null);
			}
			var links = relationship.basicGetLink();
			if (!links) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var link = __exp_enFor1[__i_enFor1];
				link.setReferencedObjectLeft(null);
				link.setReferencedObjectRight(null);
			}
		}
	}

	static _resetFacetDef(module) {
		var querySubjects = module.basicGetQuerySubject();
		if (!querySubjects) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var querySubject = __exp_enFor0[__i_enFor0];
			var itemTypeList = querySubject.basicGetItem();
			ModuleUtils._resetFacetDefFromItems(itemTypeList);
		}
	}

	static _resetFacetDefFromItems(itemTypeList) {
		if (!itemTypeList) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itemType = __exp_enFor0[__i_enFor0];
			var nested = null;
			var queryItem = itemType.getQueryItem();
			if (queryItem) {
				ModuleUtils._resetFacetDefFromQueryItem(queryItem);
				nested = queryItem.basicGetItem();
			} else {
				var nestedFolder = itemType.getFolder();
				if (nestedFolder) {
					nested = nestedFolder.basicGetItem();
				}
			}
			ModuleUtils._resetFacetDefFromItems(nested);
		}
	}

	static _resetFacetDefFromQueryItem(item) {
		var ft = item.getFacetDefinition();
		if (!ft) {
			return;
		}
		var sl = ft.getSortList();
		if (sl) {
			var sortItems = sl.basicGetSortItem();
			if (sortItems) {
				for (var __i_enFor0 = 0, __exp_enFor0 = sortItems, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var sortItem = __exp_enFor0[__i_enFor0];
					sortItem.setReferencedObject(null);
				}
			}
		}
		var context = ft.getContext();
		if (context) {
			context.setReferencedObject(null);
		}
	}

	static isForData(mo) {
		return mo instanceof MemberType;
	}

	/**
	 * Sets the member to hidden. Members retrieved from expanding the members folder or from doing a member search, are both added to the same tree. When members are retrieved from search results, they are marked as hidden. They're put in the tree for the sole purpose of having them have the proper parentage so that the UI code behaves properly. Only when members are added when expanding the members folder (i.e when createMembers() is called) are they marked as not hidden. NOTE: There is a setHidden on parent class ObjectType which could've been used, but its purpose to determine if the metadata item is visible. It was decided not to overload this.
	 * @param {MemberType} member  - Input member.
	 * @param {boolean} hidden  - Hidden flag.
	 */
	static setMemberHidden(member, hidden) {
		var prop = ModuleUtils.getMemberHiddenProperty(member);
		if (!prop) {
			prop = new PropertyType();
			prop.setName("memberHidden");
			member.addProperty(prop);
		}
		if (hidden) {
			prop.setValue("true");
		} else {
			prop.setValue("false");
		}
	}

	/**
	 * @param {MemberType} member
	 * @return {PropertyType}
	 */
	static getMemberHiddenProperty(member) {
		for (var __i_enFor0 = 0, __exp_enFor0 = member.getProperty(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if ("memberHidden" == p.getName()) {
				return p;
			}
		}
		return null;
	}

	static getMemberHidden(member) {
		var p = ModuleUtils.getMemberHiddenProperty(member);
		if (p) {
			return "true" == p.getValue();
		}
		return false;
	}

	/**
	 * clean  an object. this function does not allow undo.
	 * @param {MoserObject} obj  object to clean.
	 * @param {Array} objTypes  objects to be cleaned. If empty, to default clean.
	 * @return {boolean}  t/f.
	 */
	static cleanObject(obj, objTypes) {
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType) {
			return ModuleUtils._cleanQuerySubject(obj, objTypes);
		}
		return false;
	}

	static _cleanQuerySubject(qs, objTypes) {
		return ModuleUtils._cleanQuerySubjectItemNormalization(qs, objTypes);
	}

	static _cleanQuerySubjectItemNormalization(qs, objTypes) {
		var itemNorm = qs.getItemNormalization();
		if (!itemNorm) {
			return false;
		}
		var grps = itemNorm.basicGetItemNormalizationGroup();
		if (!grps || grps.length==0) {
			return false;
		}
		if (objTypes && !(objTypes.length==0) && !(objTypes.indexOf("ItemNormalizationType")> -1)) {
			return false;
		}
		var existingQIs = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getQueryItems(qs), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qi = __exp_enFor0[__i_enFor0];
			existingQIs.push(qi.getIdentifier());
		}
		return PropertySetter.cleanQuerySubjectItemNormalization(qs, existingQIs);
	}

	/**
	 * this function is copied from ShapingModelManager.copyPartialMoserModuleJSON in dashboard-livewidget. Returns a partial module of the current module containing only the query subjects for the given queryitemIds, calculation, NamedSet.  This is required for Smarts alternate vis recommender.
	 * @param {Module} srcModule 				source module.
	 * @param {Array} ids 					idForExpressions of QueryItems / Calculations / NamedSets.
	 * @param {ObjectFactory} objectFactory
	 * @return {Module}
	 */
	static copyPartialMoserModule(srcModule, ids, objectFactory) {
		if (!srcModule || !ids || !objectFactory) {
			return null;
		}
		var newModule = ModuleUtils.createModule(objectFactory, srcModule.getLabel(), srcModule.getExpressionLocale());
		newModule.setOverrideMode(false);
		var relationShips = srcModule.basicGetRelationship();
		if (relationShips && !(relationShips.length==0)) {
			for (var __i_enFor0 = 0, __exp_enFor0 = relationShips, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var r = __exp_enFor0[__i_enFor0];
				newModule.addRelationship(r.clone());
			}
		}
		var seen = {};
		var qiIdForExprToQS = {};
		var calcIdForExprToCalc = {};
		var namedSetIdForExprToNamedSet = {};
		var qsList = srcModule.basicGetQuerySubject();
		if (qsList) {
			for (var __i_enFor1 = 0, __exp_enFor1 = qsList, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var aQS = __exp_enFor1[__i_enFor1];
				if (aQS.basicGetIdForExpression() == null) {
					continue;
				}
				ModuleUtils._addQueryItemIntoMap(aQS, aQS.basicGetItem(), qiIdForExprToQS);
			}
		}
		var calcList = srcModule.basicGetCalculation();
		if (calcList) {
			for (var __i_enFor2 = 0, __exp_enFor2 = calcList, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var aC = __exp_enFor2[__i_enFor2];
				ModuleUtils._addCalculationIntoMap(aC, calcIdForExprToCalc);
			}
		}
		var namedSetList = srcModule.basicGetNamedSet();
		if (namedSetList) {
			for (var __i_enFor3 = 0, __exp_enFor3 = namedSetList, __len_enFor3 = __exp_enFor3.length;
					__i_enFor3 < __len_enFor3; ++__i_enFor3) {
				var aN = __exp_enFor3[__i_enFor3];
				var namedSetIdForExpr = aN.basicGetIdForExpression();
				if (namedSetIdForExpr != null) {
					namedSetIdForExprToNamedSet[namedSetIdForExpr] = aN;
				}
			}
		}
		for (var __i_enFor4 = 0, __exp_enFor4 = ids, __len_enFor4 = __exp_enFor4.length;
				__i_enFor4 < __len_enFor4; ++__i_enFor4) {
			var id = __exp_enFor4[__i_enFor4];
			var qs = qiIdForExprToQS[id];
			if (qs) {
				var qsIdForExpr = qs.basicGetIdForExpression();
				if (!(seen.hasOwnProperty(qsIdForExpr))) {
					seen[qsIdForExpr] = 1;
					var newQS = qs.clone();
					ModuleUtils.removeMembers(newQS);
					newModule.addQuerySubject(newQS);
				}
				continue;
			}
			var calc = calcIdForExprToCalc[id];
			if (calc) {
				if (!(seen.hasOwnProperty(id))) {
					seen[id] = 1;
					newModule.addCalculation(calc.clone());
				}
				continue;
			}
			var namedSet = namedSetIdForExprToNamedSet[id];
			if (namedSet) {
				if (!(seen.hasOwnProperty(id))) {
					seen[id] = 1;
					newModule.addNamedSet(namedSet.clone());
				}
			}
		}
		return newModule;
	}

	static _addQueryItemIntoMap(qs, itemTypes, mp) {
		if (!itemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var qi = itm.getQueryItem();
			if (qi) {
				var qiIdForExpr = qi.basicGetIdForExpression();
				if (qiIdForExpr != null) {
					mp[qiIdForExpr] = qs;
				}
				ModuleUtils._addQueryItemIntoMap(qs, qi.basicGetItem(), mp);
				continue;
			}
			var namedSet = itm.getNamedSet();
			if (namedSet) {
				var idForExpr = namedSet.basicGetIdForExpression();
				if (idForExpr != null) {
					mp[idForExpr] = qs;
				}
				ModuleUtils._addQueryItemIntoMap(qs, namedSet.basicGetItem(), mp);
				continue;
			}
			var fld = itm.getFolder();
			if (fld) {
				ModuleUtils._addQueryItemIntoMap(qs, fld.basicGetItem(), mp);
			}
		}
	}

	static _addCalculationIntoMap(aC, calcIdForExprToCalc) {
		var calcIdForExpr = aC.basicGetIdForExpression();
		if (calcIdForExpr != null) {
			calcIdForExprToCalc[calcIdForExpr] = aC;
		}
	}

	/**
	 * restore itemNormalization from source QS.
	 * @param {Array} newQSs
	 * @param {Map} qsNewlyInsertQIMap
	 * @param {ObjectFactory} objectFactory
	 */
	static _restoreItemNormalizationFromSourceQS(newQSs, qsNewlyInsertQIMap, objectFactory) {
		for (var __i_enFor0 = 0, __exp_enFor0 = newQSs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var newQS = __exp_enFor0[__i_enFor0];
			var srcQS = qsNewlyInsertQIMap[newQS.getIdentifier()];
			var srcItmNorm = srcQS.getItemNormalization();
			if (!srcItmNorm) {
				continue;
			}
			var srcGrps = srcItmNorm.basicGetItemNormalizationGroup();
			if (!srcGrps || srcGrps.length==0) {
				continue;
			}
			ModuleUtils._restoreItemNormalizationFromSourceItemNormalization(srcQS, srcItmNorm, newQS, objectFactory);
		}
	}

	/**
	 * collect query items in item normalization.
	 * @param {ItemNormalizationType} srcItmNorm
	 * @param {Object} grpIdToGrpMap
	 * @param {Object} queryItemIdToGrpIdMap
	 * @param {Object} keyQIs
	 * @param {Object} attrQIsNotKeyGrps
	 */
	static _collectQueryItemInfoInItemNormalization(srcItmNorm, grpIdToGrpMap, queryItemIdToGrpIdMap, keyQIs, attrQIsNotKeyGrps) {
		var srcGrps = srcItmNorm.basicGetItemNormalizationGroup();
		for (var __i_enFor0 = 0, __exp_enFor0 = srcGrps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var srcGrp = __exp_enFor0[__i_enFor0];
			var srcGrpId = srcGrp.getIdentifier();
			if (srcGrpId == null || srcGrpId.length === 0) {
				return false;
			}
			grpIdToGrpMap[srcGrpId] = srcGrp;
			var srcKey = srcGrp.getKey();
			var bHasKey = false;
			if (srcKey) {
				var srcKeyQI = srcKey.getItemRef();
				if (srcKeyQI != null && !(srcKeyQI.length === 0)) {
					if (keyQIs.hasOwnProperty(srcKeyQI)) {
						return false;
					}
					keyQIs[srcKeyQI] = 1;
					queryItemIdToGrpIdMap[srcKeyQI] = srcGrpId;
					bHasKey = true;
				}
			}
			var attrs = srcGrp.basicGetAttribute();
			if (!attrs || attrs.length==0) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = attrs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var attr = __exp_enFor1[__i_enFor1];
				var srcAttrQI = attr.getItemRef();
				if (srcAttrQI != null && !(srcAttrQI.length === 0)) {
					queryItemIdToGrpIdMap[srcAttrQI] = srcGrpId;
					if (!bHasKey && attrQIsNotKeyGrps) {
						attrQIsNotKeyGrps[srcAttrQI] = 1;
					}
				}
			}
		}
		return true;
	}

	/**
	 * @param {QuerySubject} aQS
	 * @param {Array} queryItemIdList
	 * @param {Object} queryItemIdMap
	 */
	static _getAllQueryItemIds(aQS, queryItemIdList, queryItemIdMap) {
		var allItems = MoserObjectUtils.getItems(aQS);
		for (var __i_enFor0 = 0, __exp_enFor0 = allItems, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var o = __exp_enFor0[__i_enFor0];
			if (o instanceof QueryItem) {
				var qi = o;
				var id = qi.getIdentifier();
				if (queryItemIdList) {
					queryItemIdList.push(id);
				}
				if (queryItemIdMap) {
					queryItemIdMap[id] = qi;
				}
			}
		}
	}

	/**
	 * restore itemNormalization from source QS.
	 * @param {QuerySubject} srcQS
	 * @param {ItemNormalizationType} srcItmNorm
	 * @param {QuerySubject} newQS
	 * @param {ObjectFactory} objectFactory
	 */
	static _restoreItemNormalizationFromSourceItemNormalization(srcQS, srcItmNorm, newQS, objectFactory) {
		var srcGrpIdToGrpMap = {};
		var srcQueryItemIdToGrpIdMap = {};
		var srcKeyQIs = {};
		var srcAttrQIsNoKeyGroups = {};
		if (!(ModuleUtils._collectQueryItemInfoInItemNormalization(srcItmNorm, srcGrpIdToGrpMap, srcQueryItemIdToGrpIdMap, srcKeyQIs, null))) {
			return;
		}
		var newItmNorm = newQS.getItemNormalization();
		if (newItmNorm) {
			var newGroups = newItmNorm.basicGetItemNormalizationGroup();
			if (newGroups && !(newGroups.length==0)) {
				for (var __i_enFor0 = 0, __exp_enFor0 = newGroups, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var newGrp = __exp_enFor0[__i_enFor0];
					if (!(srcGrpIdToGrpMap.hasOwnProperty(newGrp.getIdentifier()))) {
						return;
					}
				}
			}
		}
		var srcQueryItemIdMap = {};
		ModuleUtils._getAllQueryItemIds(srcQS, null, srcQueryItemIdMap);
		var queryItemIdList = [];
		var queryItemIdMap = {};
		ModuleUtils._getAllQueryItemIds(newQS, queryItemIdList, queryItemIdMap);
		var requiredGrps = {};
		var requiredGrpIds = [];
		var extraCalculatedIdList = [];
		for (var __i_enFor1 = 0, __exp_enFor1 = queryItemIdList, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qiId = __exp_enFor1[__i_enFor1];
			if (!(srcQueryItemIdMap.hasOwnProperty(qiId))) {
				extraCalculatedIdList.push(qiId);
				continue;
			}
			var grpId = null;
			if (srcKeyQIs.hasOwnProperty(qiId) || srcAttrQIsNoKeyGroups.hasOwnProperty(qiId)) {
				grpId = srcQueryItemIdToGrpIdMap[qiId];
			}
			if (grpId == null) {
				continue;
			}
			if (requiredGrps.hasOwnProperty(grpId)) {
				continue;
			}
			requiredGrps[grpId] = 1;
			requiredGrpIds.push(grpId);
		}
		var bRemoved = false;
		newItmNorm = srcItmNorm.clone();
		if (!(ModuleUtils._isObjectReadOnly(newQS))) {
			EditModeUtils.setEditMode(newItmNorm, null);
		}
		var newGrps = newItmNorm.basicGetItemNormalizationGroup();
		for (var i = newGrps.length - 1; i >= 0; --i) {
			var gId = newGrps[i].getIdentifier();
			if (gId == null || gId.length === 0 || !(requiredGrps.hasOwnProperty(gId))) {
				newGrps.splice(i, 1);
				bRemoved = true;
				continue;
			}
			var newAttrs = newGrps[i].basicGetAttribute();
			if (!newAttrs || newAttrs.length==0) {
				continue;
			}
			for (var j = newAttrs.length - 1; j >= 0; --j) {
				var srcAttrQI = newAttrs[j].getItemRef();
				if (srcAttrQI == null || srcAttrQI.length === 0 || !(queryItemIdMap.hasOwnProperty(srcAttrQI))) {
					newAttrs.splice(j, 1);
				}
			}
		}
		if (bRemoved) {
			PropertySetter.relinkItemNormalizationGroups(newGrps, srcGrpIdToGrpMap);
		}
		for (var __i_enFor2 = 0, __exp_enFor2 = extraCalculatedIdList, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var cId = __exp_enFor2[__i_enFor2];
			PropertySetter.addQueryItemToItemNormalizationGroup(newQS.getIdentifier(), newItmNorm, queryItemIdMap[cId], objectFactory, false);
		}
		newQS.setItemNormalization(newItmNorm);
	}

	/**
	 * return idForExpression to ObjectType map. Supported ObjectType is of QueryItem, Filter, FolderType, QuerySubject, Calculation.
	 * @param {Module} module
	 * @param {Array} types 		optional. If null, return all supported ObjectTypes in module. Otherwise, return ObjectTypes in the types.
	 * @return {Map}
	 */
	static getIdForExpressionToObjectMap(module, types) {
		var rt = {};
		var bQueryItem = !types || types.indexOf("QueryItem")> -1;
		var bFilter = !types || types.indexOf("Filter")> -1;
		var bFolder = !types || types.indexOf("FolderType")> -1;
		var bQuerySubject = !types || types.indexOf("QuerySubject")> -1;
		var bCalculation = !types || types.indexOf("Calculation")> -1;
		if (!bQueryItem && !bFilter && !bFolder && !bQuerySubject && !bCalculation) {
			return rt;
		}
		if (bQueryItem || bFilter || bQuerySubject) {
			var qsLst = module.basicGetQuerySubject();
			if (qsLst) {
				for (var __i_enFor0 = 0, __exp_enFor0 = qsLst, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (bQuerySubject) {
						ModuleUtils._putIfKeyNonNull(qs.getIdentifier(), qs, rt);
					}
					if (bFilter) {
						var embeddedFilters = qs.basicGetFilter();
						if (embeddedFilters) {
							for (var __i_enFor1 = 0, __exp_enFor1 = embeddedFilters, __len_enFor1 = __exp_enFor1.length;
									__i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var f = __exp_enFor1[__i_enFor1];
								ModuleUtils._putIfKeyNonNull(f.getIdForExpression(), f, rt);
							}
						}
					}
					if (bQueryItem || bFilter) {
						var allItems = MoserObjectUtils.getItems(qs);
						for (var __i_enFor2 = 0, __exp_enFor2 = allItems, __len_enFor2 = __exp_enFor2.length;
								__i_enFor2 < __len_enFor2; ++__i_enFor2) {
							var o = __exp_enFor2[__i_enFor2];
							if (bQueryItem && o instanceof QueryItem) {
								var qi = o;
								ModuleUtils._putIfKeyNonNull(qi.getIdForExpression(), qi, rt);
								continue;
							}
							if (bFilter && o instanceof Filter) {
								var f = o;
								ModuleUtils._putIfKeyNonNull(f.getIdForExpression(), f, rt);
							}
						}
					}
				}
			}
		}
		if (bCalculation) {
			var calcLst = module.basicGetCalculation();
			if (calcLst) {
				for (var __i_enFor3 = 0, __exp_enFor3 = calcLst, __len_enFor3 = __exp_enFor3.length;
						__i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var c = __exp_enFor3[__i_enFor3];
					ModuleUtils._putIfKeyNonNull(c.getIdentifier(), c, rt);
				}
			}
		}
		if (bFilter) {
			var fltLst = module.basicGetFilter();
			if (fltLst) {
				for (var __i_enFor4 = 0, __exp_enFor4 = fltLst, __len_enFor4 = __exp_enFor4.length;
						__i_enFor4 < __len_enFor4; ++__i_enFor4) {
					var f = __exp_enFor4[__i_enFor4];
					ModuleUtils._putIfKeyNonNull(f.getIdentifier(), f, rt);
				}
			}
		}
		if (bFolder) {
			var folders = MoserObjectUtils.getFolderTypes(module);
			for (var __i_enFor5 = 0, __exp_enFor5 = folders, __len_enFor5 = __exp_enFor5.length;
					__i_enFor5 < __len_enFor5; ++__i_enFor5) {
				var folder = __exp_enFor5[__i_enFor5];
				ModuleUtils._putIfKeyNonNull(folder.getIdentifier(), folder, rt);
			}
		}
		return rt;
	}

	/**
	 * @param {String} id
	 * @param {ObjectType} o
	 * @param {Map} rt
	 */
	static _putIfKeyNonNull(id, o, rt) {
		if (id != null) {
			rt[id] = o;
		}
	}

	/**
	 * replace oldObj with newObj in the module.
	 * @param {ObjectType} oldObj
	 * @param {ObjectType} newObj
	 * @return {boolean}  t/f
	 */
	static replace(oldObj, newObj) {
		var oldType = oldObj.getObjectType();
		var newType = newObj.getObjectType();
		if ("QuerySubject" == oldType && "QuerySubject" == newType) {
			return ModuleUtils._replaceQuerySubject(oldObj, newObj);
		}
		return false;
	}

	/**
	 * replace oldQS with newQS in the module.
	 * @param {QuerySubject} oldQS
	 * @param {QuerySubject} newQS
	 * @return {boolean}  t/f
	 */
	static _replaceQuerySubject(oldQS, newQS) {
		var module = QuerySubjectUtils.getParentModule(oldQS);
		if (!module) {
			return false;
		}
		var idx = module.getQuerySubject().indexOf(oldQS);
		if (idx < 0) {
			return false;
		}
		var oldID = oldQS.getIdentifier();
		PropertySetter.set(newQS, 91, oldID, false);
		PropertySetter.set(newQS, 129, oldID, false);
		var allQueryItems = {};
		PropertySetter.ensureIdForExpression(oldID, newQS.basicGetItem(), allQueryItems);
		var embedFilters = MoserObjectUtils.getList(newQS.basicGetFilter());
		for (var __i_enFor0 = 0, __exp_enFor0 = embedFilters, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var flt = __exp_enFor0[__i_enFor0];
			var newIdforExpr = oldID + "." + flt.getIdentifier();
			PropertySetter.set(flt, 129, newIdforExpr, false);
		}
		module.removeQuerySubjectAt(idx);
		module.addQuerySubjectAt(idx, newQS);
		var mdtvs = MoserObjectUtils.getList(module.basicGetMetadataTreeView());
		for (var __i_enFor1 = 0, __exp_enFor1 = mdtvs, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var folder = __exp_enFor1[__i_enFor1];
			ModuleUtils._setQuerySubjectToMDTVFolderReferencedObject(newQS, folder);
		}
		var relationships = MoserObjectUtils.getList(module.basicGetRelationship());
		for (var __i_enFor2 = 0, __exp_enFor2 = relationships, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var relationship = __exp_enFor2[__i_enFor2];
			var links = MoserObjectUtils.getList(relationship.basicGetLink());
			if (ModuleUtils._setQuerySubjectToCardinalityTypeReferencedObject(newQS, relationship.getLeft())) {
				ModuleUtils._setQueryItemToLinkReferencedObject(links, newQS, true);
			}
			if (ModuleUtils._setQuerySubjectToCardinalityTypeReferencedObject(newQS, relationship.getRight())) {
				ModuleUtils._setQueryItemToLinkReferencedObject(links, newQS, false);
			}
		}
		var drillGroups = MoserObjectUtils.getList(module.basicGetDrillGroup());
		for (var __i_enFor3 = 0, __exp_enFor3 = drillGroups, __len_enFor3 = __exp_enFor3.length;
				__i_enFor3 < __len_enFor3; ++__i_enFor3) {
			var drillGroup = __exp_enFor3[__i_enFor3];
			var segments = MoserObjectUtils.getList(drillGroup.basicGetSegment());
			for (var __i_enFor4 = 0, __exp_enFor4 = segments, __len_enFor4 = __exp_enFor4.length;
					__i_enFor4 < __len_enFor4; ++__i_enFor4) {
				var segment = __exp_enFor4[__i_enFor4];
				ModuleUtils._setQueryItemToSegmentReferencedObject(segment, allQueryItems);
			}
		}
		for (var __i_enFor5 = 0, __exp_enFor5 = PropertySetter.getQueryItems(newQS), __len_enFor5 = __exp_enFor5.length;
				__i_enFor5 < __len_enFor5; ++__i_enFor5) {
			var qi = __exp_enFor5[__i_enFor5];
			var ft = qi.getFacetDefinition();
			if (!ft) {
				continue;
			}
			var sl = ft.getSortList();
			if (!sl) {
				continue;
			}
			var sortItems = MoserObjectUtils.getList(sl.basicGetSortItem());
			for (var __i_enFor6 = 0, __exp_enFor6 = sortItems, __len_enFor6 = __exp_enFor6.length;
					__i_enFor6 < __len_enFor6; ++__i_enFor6) {
				var sortItem = __exp_enFor6[__i_enFor6];
				var qiRef = sortItem.getRef();
				var refQI = ReferenceResolver.getQueryItemByIdAndQuerySubject(qiRef, newQS, false);
				if (refQI) {
					sortItem.setReferencedObject(refQI);
				}
			}
		}
		for (var __i_enFor7 = 0, __exp_enFor7 = MoserObjectUtils.getShortcutReferences(newQS), __len_enFor7 = __exp_enFor7.length;
				__i_enFor7 < __len_enFor7; ++__i_enFor7) {
			var reference = __exp_enFor7[__i_enFor7];
			ModuleUtils.relink(reference, newQS);
		}
		return true;
	}

	/**
	 * @param {QuerySubject} qs
	 * @param {FolderType} folder
	 */
	static _setQuerySubjectToMDTVFolderReferencedObject(qs, folder) {
		if (!folder) {
			return;
		}
		var itemList = MoserObjectUtils.getList(folder.basicGetFolderItem());
		for (var __i_enFor0 = 0, __exp_enFor0 = itemList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			if (qs.getIdentifier() == itm.getRef()) {
				itm.setRef(qs.getIdentifier());
			} else {
				ModuleUtils._setQuerySubjectToMDTVFolderReferencedObject(qs, itm.getFolder());
			}
		}
	}

	/**
	 * @param {QuerySubject} qs
	 * @param {CardinalityType} cardinality
	 */
	static _setQuerySubjectToCardinalityTypeReferencedObject(qs, cardinality) {
		if (!cardinality) {
			return false;
		}
		var ref = cardinality.getRef();
		if (qs.getIdentifier() == ref) {
			cardinality.setReferencedObject(qs);
			return true;
		}
		return false;
	}

	/**
	 * @param {Array} links
	 * @param {QuerySubject} qs
	 * @param {boolean} bLeft
	 */
	static _setQueryItemToLinkReferencedObject(links, qs, bLeft) {
		for (var __i_enFor0 = 0, __exp_enFor0 = links, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var lnk = __exp_enFor0[__i_enFor0];
			var ref = bLeft ? lnk.getLeftRef() : lnk.getRightRef();
			var qi = ReferenceResolver.getQueryItemByIdAndQuerySubject(ref, qs, false);
			if (qi) {
				if (bLeft) {
					lnk.setLeftRef(qi.getIdentifier());
				} else {
					lnk.setRightRef(qi.getIdentifier());
				}
			}
		}
	}

	/**
	 * @param {Segment} segment
	 * @param {Object} allQueryItems
	 */
	static _setQueryItemToSegmentReferencedObject(segment, allQueryItems) {
		var qi = allQueryItems[segment.getRef()];
		if (qi) {
			segment.setRef(segment.getRef());
		}
	}

	/**
	 * transfer source module information to data module
	 * @param {Module} module 			data module
	 * @param {Module} srcModule 		source module
	 * @param {ObjectFactory} factory 		factory
	 */
	static transferSourceModuleInfoToDataModule(module, srcModule, factory) {
		var useSpec = ModuleUtils.getSourceModuleUseSpecInParentModule(srcModule, module);
		if (!useSpec || !(UseSpecType.DATABASE === useSpec.getType()) || useSpec.basicGetAncestors()) {
			return;
		}
		var dsName = ModuleUtils._getPropertyValueByName(srcModule, "_connectionUID");
		if (dsName != null) {
			var ancestors = factory.createModuleUseSpecAncestors();
			ancestors.setDefaultName(dsName);
			useSpec.addAncestors(ancestors);
		}
	}

	static _getPropertyValueByName(obj, name) {
		var props = obj.basicGetProperty();
		if (!props) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if (p.getName() == name) {
				return p.getValue();
			}
		}
		return null;
	}

	static move(a0, a1, a2) {
		var args = arguments;
		if (args.length == 3 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return ModuleUtils.move$1(a0, a1, a2);
		}
		return ModuleUtils.move$0(a0, a1, a2);
	}

	static isMoveable(a0, a1, a2) {
		var args = arguments;
		if (args.length == 3 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return ModuleUtils.isMoveable$1(a0, a1, a2);
		}
		return ModuleUtils.isMoveable$0(a0, a1, a2);
	}

	static isPastable(a0, a1) {
		var args = arguments;
		if (args.length == 2 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return ModuleUtils.isPastable$1(a0, a1);
		}
		return ModuleUtils.isPastable$0(a0, a1);
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/ModuleUtils.js